/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { graphql, type GraphQLResponseResolver, type RequestHandlerOptions } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A JSON scalar */
  JSON: { input: any; output: any; }
};

export enum ActionType {
  MLB_ALL_SINGLE_TEAM_ENTITLEMENTS = 'MLB_ALL_SINGLE_TEAM_ENTITLEMENTS',
  VIEWING_POLICY_LIST = 'VIEWING_POLICY_LIST'
}

export type ActiveState = {
  __typename?: 'ActiveState';
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  group: Scalars['String']['output'];
  message: Scalars['String']['output'];
  short_message: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type AdEngineIdentifier = {
  __typename?: 'AdEngineIdentifier';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdEventType = {
  __typename?: 'AdEventType';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum AdExperienceType {
  /** GAM Standalone */
  GOOGLE_STANDALONE_AD_PODS = 'GOOGLE_STANDALONE_AD_PODS',
  /** Legacy pod serving */
  LEGACY_AD_PODS = 'LEGACY_AD_PODS',
  /** Legacy dfp */
  LEGACY_SEGMENT_REDIRECT = 'LEGACY_SEGMENT_REDIRECT',
  /** Non Ad Supported platforms */
  NONE = 'NONE'
}

export enum AssetState {
  DEGRADED = 'DEGRADED',
  ERROR = 'ERROR',
  OFF = 'OFF',
  ON = 'ON'
}

export enum AssetTier {
  PRIMARY = 'PRIMARY',
  RECOVERY = 'RECOVERY',
  UNKNOWN = 'UNKNOWN'
}

export type Audience = {
  __typename?: 'Audience';
  authenticated: Scalars['Boolean']['output'];
  details?: Maybe<Array<Scalars['String']['output']>>;
  href: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  match: Scalars['String']['output'];
  type: AudienceType;
};

export type AudienceCreateInput = {
  authenticated: Scalars['Boolean']['input'];
  href: Scalars['String']['input'];
  match: Scalars['String']['input'];
  type: AudienceType;
  values: Array<Scalars['String']['input']>;
};

export enum AudienceType {
  AUTHENTICATED = 'AUTHENTICATED',
  COUNTRY = 'COUNTRY',
  GROUP = 'GROUP',
  IP = 'IP',
  PLATFORM = 'PLATFORM',
  SUBSCRIPTION = 'SUBSCRIPTION',
  ZIP = 'ZIP'
}

export type AudienceUpdateInput = {
  authenticated: Scalars['Boolean']['input'];
  match: Scalars['String']['input'];
  type: AudienceType;
  values: Array<Scalars['String']['input']>;
};

export type AuditPageView = {
  __typename?: 'AuditPageView';
  audits: Array<AuditView>;
  total: Scalars['Int']['output'];
};

export type AuditSourceSystemMetadata = {
  __typename?: 'AuditSourceSystemMetadata';
  name: Scalars['String']['output'];
  operations: Array<Scalars['String']['output']>;
};

export type AuditView = {
  __typename?: 'AuditView';
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  eventData?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  instigator?: Maybe<Scalars['String']['output']>;
  operation: Scalars['String']['output'];
  resourceTags?: Maybe<Array<ResourceTag>>;
  sourceSystem: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'email' instead */
  userEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'instigator' instead */
  userId?: Maybe<Scalars['String']['output']>;
};

export type BivoCreateJobInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  executor: Scalars['String']['input'];
  executorParams?: InputMaybe<Scalars['JSON']['input']>;
  runAfter: Scalars['String']['input'];
};

export type BivoJob = {
  __typename?: 'BivoJob';
  description?: Maybe<Scalars['String']['output']>;
  executeTime?: Maybe<Scalars['String']['output']>;
  executor: Scalars['String']['output'];
  executorParams?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  runAfter: Scalars['String']['output'];
  status: BivoJobStatus;
};

export type BivoJobDefinition = {
  __typename?: 'BivoJobDefinition';
  schema: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
};

export type BivoJobDefinitionGroup = {
  __typename?: 'BivoJobDefinitionGroup';
  definitions: Array<BivoJobDefinition>;
  executor: Scalars['String']['output'];
};

export enum BivoJobStatus {
  CANCELLED = 'CANCELLED',
  FAILURE = 'FAILURE',
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  SCHEDULED = 'SCHEDULED',
  SUCCESS = 'SUCCESS'
}

export type BivoUpdateJobInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  executorParams?: InputMaybe<Scalars['JSON']['input']>;
  runAfter?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BivoJobStatus>;
};

export type Broadcast = {
  __typename?: 'Broadcast';
  availability: BroadcastAvailability;
  availableForStreaming: Scalars['Boolean']['output'];
  callSign: Scalars['String']['output'];
  colorSpace?: Maybe<VideoColorSpace>;
  feedType: MediaFeedType;
  freeGameStatuses: Array<FreeGameStatus>;
  language: Scalars['String']['output'];
  mediaId: Scalars['String']['output'];
  mediaState: MediaState;
  mediaType: MediaType;
  mvpdRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  postGameShow: Scalars['Boolean']['output'];
  preGameShow?: Maybe<Scalars['String']['output']>;
  videoResolution?: Maybe<VideoResolution>;
};

export enum BroadcastAvailability {
  EXCLUSIVE = 'EXCLUSIVE',
  LOCAL_IN_MARKET = 'LOCAL_IN_MARKET',
  LOCAL_OUT_OF_MARKET = 'LOCAL_OUT_OF_MARKET',
  NATIONAL = 'NATIONAL',
  UNKNOWN = 'UNKNOWN'
}

export type BroadcastOverrideUpdateRequest = {
  callSign: Scalars['String']['input'];
  fronthaulDecoderInputLabel?: InputMaybe<Scalars['String']['input']>;
  multicastAddress?: InputMaybe<Scalars['String']['input']>;
};

export type BroadcastSourceOverride = {
  __typename?: 'BroadcastSourceOverride';
  callSign: Scalars['String']['output'];
  gameSource?: Maybe<ProgramSource>;
  id: Scalars['ID']['output'];
  postgameSource?: Maybe<ProgramSource>;
  pregameSource?: Maybe<ProgramSource>;
};

export type BroadcastSourceOverrideInput = {
  callSign: Scalars['String']['input'];
  gameSource?: InputMaybe<ProgramSource>;
  postgameSource?: InputMaybe<ProgramSource>;
  pregameSource?: InputMaybe<ProgramSource>;
};

export type BroadcastSourceUpdateInput = {
  overrideType: SourceType;
  source: ProgramSource;
};

export type CachedProfile = {
  __typename?: 'CachedProfile';
  doNotSell?: Maybe<Scalars['Boolean']['output']>;
  favoriteTeam?: Maybe<Scalars['Int']['output']>;
};

export enum Cdn {
  FASTLY = 'FASTLY',
  MEDIA_CDN = 'MEDIA_CDN'
}

export type CdnStatus = {
  __typename?: 'CdnStatus';
  cdn: Cdn;
  enabled: Scalars['Boolean']['output'];
};

export type Channel = {
  __typename?: 'Channel';
  activeMute: Scalars['Boolean']['output'];
  broadcasterClusterId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  muted: Scalars['Boolean']['output'];
  mutedUntil?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  objectState?: Maybe<ObjectState>;
  sourceId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  targets: Array<TargetIdentifier>;
  updatedAt: Scalars['String']['output'];
};

export type Content = {
  __typename?: 'Content';
  assetTrackingKey: Scalars['String']['output'];
  assets: Array<LocationAsset>;
  callSign?: Maybe<Scalars['String']['output']>;
  contentId: Scalars['String']['output'];
  contentRestrictions: Array<Scalars['String']['output']>;
  contentType: ContentType;
  description?: Maybe<Scalars['String']['output']>;
  feedType: MediaFeedType;
  gamePk?: Maybe<Scalars['Int']['output']>;
  language: Scalars['String']['output'];
  mediaId: Scalars['String']['output'];
  mediaState: MediaConfiguration;
  quality?: Maybe<MediaQuality>;
  sportId?: Maybe<Scalars['Int']['output']>;
};

export enum ContentExperience {
  LIVE = 'LIVE',
  ON_DEMAND = 'ON_DEMAND'
}

export enum ContentRestriction {
  FREE = 'FREE',
  SUBSCRIBER = 'SUBSCRIBER'
}

export type ContentRestrictionDetail = {
  __typename?: 'ContentRestrictionDetail';
  code: Scalars['String']['output'];
  details: Array<Scalars['String']['output']>;
};

export enum ContentType {
  CONDENSED_GAME = 'CONDENSED_GAME',
  GAME = 'GAME',
  GAME_RECAP = 'GAME_RECAP',
  HIGHLIGHT = 'HIGHLIGHT',
  PRESS_CONFERENCE = 'PRESS_CONFERENCE',
  SHOW = 'SHOW',
  UNKNOWN = 'UNKNOWN'
}

export type CopyrightStream = {
  __typename?: 'CopyrightStream';
  awayTriCode: Scalars['String']['output'];
  feedType: Scalars['String']['output'];
  gamePk: Scalars['Int']['output'];
  gameStartTime: Scalars['String']['output'];
  homeTriCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  scheduleDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
  streamEndTime?: Maybe<Scalars['String']['output']>;
  streamStartTime?: Maybe<Scalars['String']['output']>;
};

export type CopyrightStreamProvision = {
  awayTriCode: Scalars['String']['input'];
  feedType: Scalars['String']['input'];
  gamePk: Scalars['Int']['input'];
  gameStartTime: Scalars['String']['input'];
  homeTriCode: Scalars['String']['input'];
  scheduleDate: Scalars['String']['input'];
};

export type DataCenter = {
  __typename?: 'DataCenter';
  channels: Array<Channel>;
  name: Scalars['String']['output'];
};

export type Device = {
  __typename?: 'Device';
  appVersion: Scalars['String']['output'];
  applicationRuntime: Scalars['String']['output'];
  extraAttributes: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  language: Scalars['String']['output'];
  manufacturer: Scalars['String']['output'];
  model: Scalars['String']['output'];
  os: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  profile: Scalars['String']['output'];
  userAgent: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type EchoProcessingResult = {
  __typename?: 'EchoProcessingResult';
  href: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EsniMediaProcessingResult = {
  __typename?: 'EsniMediaProcessingResult';
  policies: Array<Scalars['String']['output']>;
  rules: Array<EsniRule>;
};

export type EsniRule = {
  __typename?: 'EsniRule';
  actions: Array<EsniRuleAction>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  status: EsniRuleStatus;
  type: EsniRuleType;
};

export type EsniRuleAction = {
  __typename?: 'EsniRuleAction';
  actionType: ActionType;
  metadata: Scalars['JSON']['output'];
};

export type EsniRuleActionInput = {
  actionType: ActionType;
  metadata: Scalars['JSON']['input'];
};

export type EsniRuleInput = {
  actions: Array<EsniRuleActionInput>;
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  status: EsniRuleStatus;
  type: EsniRuleType;
};

export type EsniRuleProcessingResult = {
  __typename?: 'EsniRuleProcessingResult';
  reason?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum EsniRuleStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  TESTING = 'TESTING'
}

export enum EsniRuleType {
  BLACKOUT = 'BLACKOUT',
  ENTITLEMENT = 'ENTITLEMENT'
}

export type EviPodInfo = {
  __typename?: 'EviPodInfo';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  vendor: Scalars['String']['output'];
};

export type ExperienceOverrideSearchView = {
  __typename?: 'ExperienceOverrideSearchView';
  experience: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  matchParams: Scalars['JSON']['output'];
};

export enum ExperienceOverrideType {
  PLAYBACK = 'PLAYBACK',
  SESSION = 'SESSION'
}

export type Feature = {
  __typename?: 'Feature';
  featureType: FeatureType;
  gameDate: Scalars['String']['output'];
  gamePk: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type FeatureDisableResult = {
  __typename?: 'FeatureDisableResult';
  featureId: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type FeatureEnableResult = {
  __typename?: 'FeatureEnableResult';
  featureId: Scalars['Int']['output'];
  gamePk: Scalars['Int']['output'];
};

export enum FeatureType {
  AUTO_ADS = 'AUTO_ADS',
  AUTO_ROUTING = 'AUTO_ROUTING',
  AUTO_SLATE = 'AUTO_SLATE'
}

export type Feed = {
  __typename?: 'Feed';
  feedType: MediaFeedType;
  postGameShow: Scalars['Boolean']['output'];
  preGameShow?: Maybe<Scalars['String']['output']>;
};

export type FreeGameStatus = {
  __typename?: 'FreeGameStatus';
  freeGameType: FreeGameType;
  status: Scalars['Boolean']['output'];
};

export type FreeGameStatusInput = {
  freeGameType: FreeGameType;
  status: Scalars['Boolean']['input'];
};

export enum FreeGameType {
  FREE_GAME_EXTRA_INNINGS = 'FREE_GAME_EXTRA_INNINGS',
  FREE_GAME_OF_THE_DAY = 'FREE_GAME_OF_THE_DAY'
}

export type Game = {
  __typename?: 'Game';
  away: Team;
  broadcasts: Array<Broadcast>;
  content: Array<Content>;
  features: Array<Feature>;
  feeds: Array<Feed>;
  gameDate: Scalars['String']['output'];
  gamePk: Scalars['Int']['output'];
  home: Team;
  pipelines: Array<MediaPipeline>;
  status: GameStatus;
  venue: Venue;
};

export enum GameStatus {
  CANCELLED = 'CANCELLED',
  FINAL = 'FINAL',
  LIVE = 'LIVE',
  LIVE_DELAYED = 'LIVE_DELAYED',
  POSTPONED = 'POSTPONED',
  SCHEDULED = 'SCHEDULED',
  SCHEDULED_DELAYED = 'SCHEDULED_DELAYED',
  SUSPENDED = 'SUSPENDED',
  UNKNOWN = 'UNKNOWN'
}

export enum IndexIdType {
  GAME = 'GAME',
  MEDIA = 'MEDIA'
}

export enum InningState {
  BOTTOM = 'BOTTOM',
  END = 'END',
  MIDDLE = 'MIDDLE',
  TOP = 'TOP'
}

export type Keyword = {
  __typename?: 'Keyword';
  name: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type KeywordInput = {
  name: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type Location = {
  __typename?: 'Location';
  country: Scalars['String']['output'];
  designatedMarketArea: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  locationProvider: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  zip: Scalars['String']['output'];
};

export type LocationAsset = {
  __typename?: 'LocationAsset';
  adStatus?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['Int']['output']>;
  cdn: Scalars['String']['output'];
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationCdnId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  path: Scalars['String']['output'];
  playback?: Maybe<Playback>;
  /** @deprecated Please use playback.url */
  playbackUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  state: AssetState;
  tier: AssetTier;
  videoId?: Maybe<Scalars['String']['output']>;
};

export type LocationOverrideCreationResult = {
  __typename?: 'LocationOverrideCreationResult';
  status: Scalars['String']['output'];
};

export type LocationOverridePageView = {
  __typename?: 'LocationOverridePageView';
  currentPage: Scalars['Int']['output'];
  overrides: Array<LocationOverrideView>;
  totalPages: Scalars['Int']['output'];
};

export enum LocationOverrideSortAttribute {
  CREATED_DATE = 'CREATED_DATE',
  EXPIRATION_DATE = 'EXPIRATION_DATE'
}

export enum LocationOverrideSortOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type LocationOverrideView = {
  __typename?: 'LocationOverrideView';
  countryCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  expiration: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  oktaId: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type Media = {
  __typename?: 'Media';
  pipelines: Array<MediaPipeline>;
};

export type MediaAssetsInput = {
  assetIds: Array<Scalars['Int']['input']>;
  mediaId: Scalars['String']['input'];
};

export type MediaConfiguration = {
  __typename?: 'MediaConfiguration';
  contentExperience: ContentExperience;
  mediaType: MediaType;
  state: MediaState;
};

export type MediaContext = {
  __typename?: 'MediaContext';
  feedType: MediaFeedType;
  id: Scalars['String']['output'];
  language: Scalars['String']['output'];
  mediaType: MediaType;
};

export enum MediaFeedType {
  AWAY = 'AWAY',
  HOME = 'HOME',
  NATIONAL = 'NATIONAL',
  UNKNOWN = 'UNKNOWN'
}

export type MediaPipeline = {
  __typename?: 'MediaPipeline';
  activeSlateCode?: Maybe<Scalars['String']['output']>;
  adBreakDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  adBreakStartedDateTime?: Maybe<Scalars['String']['output']>;
  alerts: Array<PipelineAlert>;
  eviPod?: Maybe<EviPodInfo>;
  eviStatus: PipelineEviStatus;
  feedType: MediaFeedType;
  gameSource: ProgramSource;
  id: Scalars['Int']['output'];
  isAudioOnly: Scalars['Boolean']['output'];
  media: Array<MediaContext>;
  postgameSource: ProgramSource;
  pregameSource: ProgramSource;
  programSource: ProgramSource;
  red5Config?: Maybe<Red5Config>;
  resumedFromDateTime?: Maybe<Scalars['String']['output']>;
  scheduledStartDateTime?: Maybe<Scalars['String']['output']>;
  sourceSystem: MediaSourceSystem;
  status: PipelineStatus;
  streamState: StreamState;
};

export type MediaPolicy = {
  __typename?: 'MediaPolicy';
  contentDate?: Maybe<Scalars['String']['output']>;
  feedSubType?: Maybe<Scalars['String']['output']>;
  feedType?: Maybe<Scalars['String']['output']>;
  gamePk?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  mediaType: Scalars['String']['output'];
  requiredAuth?: Maybe<Scalars['String']['output']>;
  viewingPolicies: Array<ViewingPolicy>;
};

export type MediaPolicyInput = {
  contentDate?: InputMaybe<Scalars['String']['input']>;
  feedSubType?: InputMaybe<Scalars['String']['input']>;
  feedType?: InputMaybe<Scalars['String']['input']>;
  gamePk?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  mediaType: Scalars['String']['input'];
  requiredAuth?: InputMaybe<Scalars['String']['input']>;
  viewingPolicyHrefs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MediaProcessingResult = {
  __typename?: 'MediaProcessingResult';
  mediaId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MediaQuality = {
  __typename?: 'MediaQuality';
  colorSpace?: Maybe<VideoColorSpace>;
  resolution?: Maybe<VideoResolution>;
};

export enum MediaSourceSystem {
  CEREBRO = 'CEREBRO',
  OTHER = 'OTHER',
  SKYWALKER = 'SKYWALKER',
  YODA = 'YODA'
}

export enum MediaState {
  ARCHIVE = 'ARCHIVE',
  OFF = 'OFF',
  ON = 'ON'
}

export enum MediaType {
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO'
}

export type MetadataFieldDefinition = {
  __typename?: 'MetadataFieldDefinition';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Milestone = {
  __typename?: 'Milestone';
  absoluteTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  keywords: Array<Keyword>;
  milestoneType: MilestoneType;
  relativeTime?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type MilestoneInput = {
  absoluteTime: Scalars['String']['input'];
  keywords?: InputMaybe<Array<KeywordInput>>;
  milestoneType: MilestoneType;
  updatedBy: Scalars['String']['input'];
};

export type MilestoneSchema = {
  __typename?: 'MilestoneSchema';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  metadataFields: Array<MetadataFieldDefinition>;
  name: Scalars['String']['output'];
};

export enum MilestoneType {
  BROADCAST_END = 'BROADCAST_END',
  BROADCAST_START = 'BROADCAST_START',
  GAME_FINAL = 'GAME_FINAL',
  GAME_FIRST_PITCH = 'GAME_FIRST_PITCH',
  GAME_LIVE = 'GAME_LIVE',
  GAME_WARMUP = 'GAME_WARMUP',
  INNING_END = 'INNING_END',
  INNING_HALF_END = 'INNING_HALF_END',
  INNING_HALF_START = 'INNING_HALF_START',
  INNING_START = 'INNING_START',
  OTHER = 'OTHER',
  STREAM_START = 'STREAM_START',
  STREAM_STOP = 'STREAM_STOP'
}

export type MulticastMappingUpdateRequest = {
  callSign: Scalars['String']['input'];
  hdrMulticastAddress?: InputMaybe<Scalars['String']['input']>;
  multicastAddress: Scalars['String']['input'];
  priority: Scalars['String']['input'];
  sourceLocation: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Activate ad serving for a specific GAM asset for a given mediaId */
  activateAds: Scalars['Boolean']['output'];
  /** Adjust a current game milestone to a new time. Timestamp should be in ISO-8601 format */
  adjustMilestoneTime?: Maybe<Milestone>;
  /** Archive one or more media pipelines */
  archiveMedia: Array<MediaProcessingResult>;
  /** Assigns a team to a given pipeline config, and unassigns the team if it is currently assigned to another config */
  assignDevPipelineConfig?: Maybe<Scalars['Boolean']['output']>;
  /** Assign EVI Pod for Pipeline */
  assignEviPod: MediaProcessingResult;
  /** Assign a channel to a set of partner targets */
  assignTargets: Array<UpdateTargetResult>;
  /** Borrow a Pipeline from production */
  borrowPipeline?: Maybe<Scalars['Boolean']['output']>;
  /** Create an audience */
  createAudience?: Maybe<Audience>;
  /** Create a BiVo job */
  createBivoJob?: Maybe<BivoJob>;
  createBroadcastOverride?: Maybe<PipelineBroadcastOverride>;
  /** Creates a broadcast source override */
  createBroadcastSourceOverride?: Maybe<BroadcastSourceOverride>;
  /** Create a new ESNI rule */
  createEsniRule: EsniRule;
  /**
   * Create Experience Override
   * @deprecated Use createSessionOverride or createPlaybackOverride
   */
  createExperienceOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Add user location (Blackout) override via Commerce API */
  createLocationOverride?: Maybe<LocationOverrideCreationResult>;
  createMulticastMapping?: Maybe<PipelineMulticastMapping>;
  createPlaybackOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Create a viewing policy by href */
  createPolicy?: Maybe<ViewingPolicy>;
  createSessionOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an audience by href */
  deleteAudience: EchoProcessingResult;
  /** Delete a BiVo job */
  deleteBivoJob?: Maybe<Scalars['Boolean']['output']>;
  deleteBroadcastOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a broadcast source override */
  deleteBroadcastSourceOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Delete Copyright Stream */
  deleteCopyrightStream?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an ESNI rule */
  deleteEsniRule: EsniRuleProcessingResult;
  /**
   * Delete Experience Override
   * @deprecated Use deleteSessionOverride or deletePlaybackOverride
   */
  deleteExperienceOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Delete Media Policy */
  deleteMediaPolicies?: Maybe<MediaProcessingResult>;
  /** Delete an existing game milestone */
  deleteMilestone: Scalars['Boolean']['output'];
  deleteMulticastMapping?: Maybe<Scalars['Boolean']['output']>;
  deletePlaybackOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a viewing policy by href */
  deletePolicy: EchoProcessingResult;
  deleteSessionOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Disable feature for game */
  disableFeature: FeatureDisableResult;
  /** Enable feature for game */
  enableFeature: FeatureEnableResult;
  /** Trigger an end of ad break for one or more media ids. If the media is not an in an ad break no action will occur */
  endAdBreak: Array<MediaProcessingResult>;
  /** Generate a playable url for a piece of media as well as ad information */
  generatePlaybackUrls?: Maybe<Array<PlaybackInfo>>;
  /** Trigger (re)indexing of media content to supply content search with up to date broadcast data as needed */
  indexBy?: Maybe<Array<Maybe<Content>>>;
  /** Ingest Assets Into DAI */
  ingestAssetsIntoDai: Scalars['Boolean']['output'];
  /**
   * Apply new start/end times for a given Stream.
   *
   * Timestamps should be ISO-8601 format
   */
  initiateTrim: MediaProcessingResult;
  /**
   * Trigger an ad-break to be sent to one or media ids
   *
   * Slate code is the slate to use as a bumper when ad inventory does not fill the entire break
   *
   * Event Type must be a supported adEventType for a given sport
   */
  insertAdBreak: Array<MediaProcessingResult>;
  /** Create a new game milestone for a given piece of media */
  insertMilestone?: Maybe<Milestone>;
  /** Lift the slate for one or more media ids */
  liftSlate: Array<MediaProcessingResult>;
  /** Pause ad serving for a specific GAM asset for a given mediaId */
  pauseAds: Scalars['Boolean']['output'];
  /** Reprocess media to attach latest policies */
  processEsniMedia?: Maybe<EsniMediaProcessingResult>;
  /** Provision Copyright Stream */
  provisionCopyrightStream?: Maybe<CopyrightStream>;
  /** Provision one or more media pipelines */
  provisionMedia: Array<MediaProcessingResult>;
  /** Resolve alert for feed */
  resolveAlert: MediaProcessingResult;
  /** Return a Pipeline to production */
  returnPipeline?: Maybe<Scalars['Boolean']['output']>;
  /** Revert start/end times for a previously-trimmed Stream. */
  revertTrim: MediaProcessingResult;
  /** Change the route of the source media to another source such as pregame / post game or program feed */
  routeMedia: Array<MediaProcessingResult>;
  /** Change The Evi Server Status */
  setEviStatus: MediaProcessingResult;
  /** Set the slate for one or more media ids */
  setSlate: Array<MediaProcessingResult>;
  /** Start Copyright Stream */
  startCopyrightStream?: Maybe<CopyrightStream>;
  /** Start one or more media pipelines */
  startMedia: Array<MediaProcessingResult>;
  /** Stop Copyright Stream */
  stopCopyrightStream?: Maybe<CopyrightStream>;
  /** Stop one or more media pipelines */
  stopMedia: Array<MediaProcessingResult>;
  /** Change the source of the program to either FrontHaul or BackHaul */
  switchProgramSource: Array<MediaProcessingResult>;
  /** Sync Content Registry Media info from source (Skywalker) */
  syncMediaContent?: Maybe<Array<Scalars['String']['output']>>;
  /** Sync pipeline routing from Lightyear for one or more media pipelines */
  syncPipelineRouting: Array<MediaProcessingResult>;
  /** Toggles the enabled state of all Skyview configs */
  toggleAllSkyviewConfigs?: Maybe<Scalars['Boolean']['output']>;
  /** Toggles the enabled state of the individual Skyview config for a team and language */
  toggleSkyviewConfig?: Maybe<SkyviewConfig>;
  /**
   * Change the state of Broadcast Media entry in Stats API
   * @deprecated Please use `updateBroadcast` instead.
   */
  transitionMediaState: MediaProcessingResult;
  /** Tear down one or more pipelines before they are started */
  unscheduleMedia: Array<MediaProcessingResult>;
  /** Update ads enabled flag */
  updateAdsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Update Asset State
   * @deprecated Use updateAssetsState mutation
   */
  updateAssetState: MediaProcessingResult;
  /** Update the state of multiple assets for given media IDs */
  updateAssetsState: Array<MediaProcessingResult>;
  /** update an audience by href */
  updateAudience?: Maybe<Audience>;
  /** Update a BiVo job */
  updateBivoJob?: Maybe<BivoJob>;
  /** Update various attributes on a broadcast */
  updateBroadcast: MediaProcessingResult;
  updateBroadcastOverride?: Maybe<PipelineBroadcastOverride>;
  /** Updates Skywalker's pregame, game, or postgame source for a pipeline */
  updateBroadcastSource?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a broadcasst source override */
  updateBroadcastSourceOverride?: Maybe<BroadcastSourceOverride>;
  /** Update CDN Status */
  updateCdnStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Update an existing ESNI rule */
  updateEsniRule: EsniRule;
  /**
   * Update Experience Override
   * @deprecated Use updateSessionOverride or updatePlaybackOverride
   */
  updateExperienceOverride?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Change the free game type status on a Broadcast Media entry in Stats API
   * @deprecated Please use `updateBroadcast` instead.
   */
  updateFreeGameType: MediaProcessingResult;
  updateMulticastMapping?: Maybe<PipelineMulticastMapping>;
  /**
   * Locks or unlocks partner distribution sources for the given team id
   *
   * Calling this mutation with setLock true will lock sources, while false will unlock sources
   */
  updatePartnerDistributionLock: Scalars['Boolean']['output'];
  /** Update pipeline config by team */
  updatePipelineConfig?: Maybe<PipelineConfigInfo>;
  /** Update pipeline input config by venue and feed type code */
  updatePipelineInputConfig?: Maybe<PipelineInputConfigInfo>;
  /**
   * Update mediaId to an existing pipeline.
   *
   * The gateway will fetch the relevant game and feed data based on the mediaId passed in and
   * request a pipeline update from Skywalker.
   */
  updatePipelineMedia: MediaProcessingResult;
  updatePlaybackOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Update a viewing policy by href */
  updatePolicy?: Maybe<ViewingPolicy>;
  updateSessionOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Upsert ViewingPolicies to a MediaPolicy */
  upsertMediaPolicies?: Maybe<Array<Maybe<MediaPolicy>>>;
  /** Run validation process for a given game */
  validate?: Maybe<ValidationResult>;
  /** Dry run of what policies would be attached to a media */
  validateEsniMedia?: Maybe<EsniMediaProcessingResult>;
};


export type MutationActivateAdsArgs = {
  mediaId: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};


export type MutationAdjustMilestoneTimeArgs = {
  mediaId: Scalars['String']['input'];
  milestoneId: Scalars['String']['input'];
  timestamp: Scalars['String']['input'];
};


export type MutationArchiveMediaArgs = {
  mediaIds: Array<Scalars['String']['input']>;
};


export type MutationAssignDevPipelineConfigArgs = {
  pipelineId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};


export type MutationAssignEviPodArgs = {
  eviPodName: Scalars['String']['input'];
  mediaId: Scalars['String']['input'];
};


export type MutationAssignTargetsArgs = {
  targetChanges: Array<TargetChangeInput>;
};


export type MutationBorrowPipelineArgs = {
  teamId: Scalars['Int']['input'];
};


export type MutationCreateAudienceArgs = {
  audience: AudienceCreateInput;
};


export type MutationCreateBivoJobArgs = {
  input: BivoCreateJobInput;
};


export type MutationCreateBroadcastOverrideArgs = {
  callSign: Scalars['String']['input'];
  feedTypeCode: Scalars['String']['input'];
  fronthaulDecoderInputLabel?: InputMaybe<Scalars['String']['input']>;
  gamePk: Scalars['Int']['input'];
  multicastAddress?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
};


export type MutationCreateBroadcastSourceOverrideArgs = {
  broadcastSourceOverrideInput: BroadcastSourceOverrideInput;
};


export type MutationCreateEsniRuleArgs = {
  input: EsniRuleInput;
};


export type MutationCreateExperienceOverrideArgs = {
  experience: Scalars['String']['input'];
  features: Array<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  matchParams: Scalars['JSON']['input'];
};


export type MutationCreateLocationOverrideArgs = {
  countryCode: Scalars['String']['input'];
  ipAddress: Scalars['String']['input'];
  oktaId: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type MutationCreateMulticastMappingArgs = {
  callSign: Scalars['String']['input'];
  hdrMulticastAddress?: InputMaybe<Scalars['String']['input']>;
  multicastAddress: Scalars['String']['input'];
  priority: Scalars['String']['input'];
  sourceLocation: Scalars['String']['input'];
};


export type MutationCreatePlaybackOverrideArgs = {
  experience: PlaybackExperience;
  features: Array<PlaybackFeature>;
  matchParams: Scalars['JSON']['input'];
};


export type MutationCreatePolicyArgs = {
  policy: PolicyCreateInput;
};


export type MutationCreateSessionOverrideArgs = {
  experience: SessionExperience;
  features: Array<SessionFeature>;
  matchParams: Scalars['JSON']['input'];
};


export type MutationDeleteAudienceArgs = {
  href: Scalars['String']['input'];
};


export type MutationDeleteBivoJobArgs = {
  jobId: Scalars['Int']['input'];
};


export type MutationDeleteBroadcastOverrideArgs = {
  id: Scalars['Int']['input'];
  region: Scalars['String']['input'];
};


export type MutationDeleteBroadcastSourceOverrideArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCopyrightStreamArgs = {
  streamId: Scalars['String']['input'];
};


export type MutationDeleteEsniRuleArgs = {
  ruleId: Scalars['String']['input'];
};


export type MutationDeleteExperienceOverrideArgs = {
  overrideId: Scalars['Int']['input'];
};


export type MutationDeleteMediaPoliciesArgs = {
  mediaId: Scalars['String']['input'];
};


export type MutationDeleteMilestoneArgs = {
  mediaId: Scalars['String']['input'];
  milestoneId: Scalars['String']['input'];
};


export type MutationDeleteMulticastMappingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePlaybackOverrideArgs = {
  overrideId: Scalars['Int']['input'];
};


export type MutationDeletePolicyArgs = {
  href: Scalars['String']['input'];
};


export type MutationDeleteSessionOverrideArgs = {
  overrideId: Scalars['Int']['input'];
};


export type MutationDisableFeatureArgs = {
  featureId: Scalars['Int']['input'];
};


export type MutationEnableFeatureArgs = {
  featureType: FeatureType;
  gameDate: Scalars['String']['input'];
  gamePk: Scalars['Int']['input'];
};


export type MutationEndAdBreakArgs = {
  mediaIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationGeneratePlaybackUrlsArgs = {
  mediaIds: Array<Scalars['String']['input']>;
};


export type MutationIndexByArgs = {
  id: Scalars['String']['input'];
  idType: IndexIdType;
};


export type MutationIngestAssetsIntoDaiArgs = {
  assetIds: Array<Scalars['Int']['input']>;
};


export type MutationInitiateTrimArgs = {
  mediaId: Scalars['String']['input'];
  newEndTime: Scalars['String']['input'];
  newStartTime: Scalars['String']['input'];
};


export type MutationInsertAdBreakArgs = {
  durationSeconds: Scalars['Int']['input'];
  eventType?: InputMaybe<Scalars['String']['input']>;
  includeBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIds: Array<InputMaybe<Scalars['String']['input']>>;
  slateCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInsertMilestoneArgs = {
  mediaId: Scalars['String']['input'];
  milestoneInput: MilestoneInput;
};


export type MutationLiftSlateArgs = {
  mediaIds: Array<Scalars['String']['input']>;
};


export type MutationPauseAdsArgs = {
  mediaId: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};


export type MutationProcessEsniMediaArgs = {
  mediaId: Scalars['String']['input'];
};


export type MutationProvisionCopyrightStreamArgs = {
  stream: CopyrightStreamProvision;
};


export type MutationProvisionMediaArgs = {
  mediaIds: Array<Scalars['String']['input']>;
};


export type MutationResolveAlertArgs = {
  alertId: Scalars['String']['input'];
  mediaId: Scalars['String']['input'];
};


export type MutationReturnPipelineArgs = {
  teamId: Scalars['Int']['input'];
};


export type MutationRevertTrimArgs = {
  mediaId: Scalars['String']['input'];
};


export type MutationRouteMediaArgs = {
  mediaIds: Array<Scalars['String']['input']>;
  routeType?: InputMaybe<RouteType>;
};


export type MutationSetEviStatusArgs = {
  mediaId: Scalars['String']['input'];
  status: PipelineEviStatus;
};


export type MutationSetSlateArgs = {
  mediaIds: Array<Scalars['String']['input']>;
  slateCode: Scalars['String']['input'];
};


export type MutationStartCopyrightStreamArgs = {
  streamId: Scalars['String']['input'];
};


export type MutationStartMediaArgs = {
  mediaIds: Array<Scalars['String']['input']>;
};


export type MutationStopCopyrightStreamArgs = {
  streamId: Scalars['String']['input'];
};


export type MutationStopMediaArgs = {
  mediaIds: Array<Scalars['String']['input']>;
};


export type MutationSwitchProgramSourceArgs = {
  mediaIds: Array<Scalars['String']['input']>;
  programSource: ProgramSource;
};


export type MutationSyncMediaContentArgs = {
  gamePk: Scalars['Int']['input'];
};


export type MutationSyncPipelineRoutingArgs = {
  mediaIds: Array<Scalars['String']['input']>;
};


export type MutationToggleAllSkyviewConfigsArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationToggleSkyviewConfigArgs = {
  enabled: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type MutationTransitionMediaStateArgs = {
  mediaId: Scalars['String']['input'];
  newState: MediaState;
};


export type MutationUnscheduleMediaArgs = {
  mediaIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateAdsEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateAssetStateArgs = {
  assetId: Scalars['Int']['input'];
  assetState: AssetState;
  mediaId: Scalars['String']['input'];
};


export type MutationUpdateAssetsStateArgs = {
  assetState: AssetState;
  mediaAssets: Array<MediaAssetsInput>;
};


export type MutationUpdateAudienceArgs = {
  audience: AudienceUpdateInput;
  href: Scalars['String']['input'];
};


export type MutationUpdateBivoJobArgs = {
  input: BivoUpdateJobInput;
  jobId: Scalars['Int']['input'];
};


export type MutationUpdateBroadcastArgs = {
  availableForStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  colorSpace?: InputMaybe<VideoColorSpace>;
  freeGameStatuses?: InputMaybe<Array<FreeGameStatusInput>>;
  mediaId: Scalars['String']['input'];
  mediaState?: InputMaybe<MediaState>;
  mvpdRequired?: InputMaybe<Scalars['Boolean']['input']>;
  videoResolution?: InputMaybe<VideoResolution>;
};


export type MutationUpdateBroadcastOverrideArgs = {
  id: Scalars['Int']['input'];
  region: Scalars['String']['input'];
  updatedBroadcastOverride: BroadcastOverrideUpdateRequest;
};


export type MutationUpdateBroadcastSourceArgs = {
  feedType: MediaFeedType;
  gamePk: Scalars['Int']['input'];
  sourceUpdateInput: BroadcastSourceUpdateInput;
};


export type MutationUpdateBroadcastSourceOverrideArgs = {
  broadcastSourceOverrideInput: BroadcastSourceOverrideInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCdnStatusArgs = {
  cdn: Cdn;
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateEsniRuleArgs = {
  input: EsniRuleInput;
  ruleId: Scalars['String']['input'];
};


export type MutationUpdateExperienceOverrideArgs = {
  experience: Scalars['String']['input'];
  features: Array<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  matchParams: Scalars['JSON']['input'];
};


export type MutationUpdateFreeGameTypeArgs = {
  freeGameType: FreeGameType;
  mediaId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
};


export type MutationUpdateMulticastMappingArgs = {
  id: Scalars['Int']['input'];
  updatedMapping: MulticastMappingUpdateRequest;
};


export type MutationUpdatePartnerDistributionLockArgs = {
  setLock: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};


export type MutationUpdatePipelineConfigArgs = {
  pipelineConfig: PipelineConfig;
  teamId: Scalars['Int']['input'];
};


export type MutationUpdatePipelineInputConfigArgs = {
  feedType: MediaFeedType;
  pipelineInputConfig?: InputMaybe<PipelineInputConfig>;
  venueId: Scalars['Int']['input'];
};


export type MutationUpdatePipelineMediaArgs = {
  mediaId: Scalars['String']['input'];
};


export type MutationUpdatePlaybackOverrideArgs = {
  experience: PlaybackExperience;
  features: Array<PlaybackFeature>;
  id: Scalars['Int']['input'];
  matchParams: Scalars['JSON']['input'];
};


export type MutationUpdatePolicyArgs = {
  href: Scalars['String']['input'];
  policy: PolicyUpdateInput;
};


export type MutationUpdateSessionOverrideArgs = {
  experience: SessionExperience;
  features: Array<SessionFeature>;
  id: Scalars['Int']['input'];
  matchParams: Scalars['JSON']['input'];
};


export type MutationUpsertMediaPoliciesArgs = {
  media: MediaPolicyInput;
};


export type MutationValidateArgs = {
  gamePk: Scalars['Int']['input'];
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
  validationProcess: Scalars['String']['input'];
};


export type MutationValidateEsniMediaArgs = {
  mediaId: Scalars['String']['input'];
};

export type ObjectState = {
  __typename?: 'ObjectState';
  objectId: Scalars['Int']['output'];
  objectType?: Maybe<Scalars['String']['output']>;
};

export type OverrideInput = {
  experience: Scalars['String']['input'];
  features: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  matchParams: Scalars['JSON']['input'];
};

export type PaginatedSessions = {
  __typename?: 'PaginatedSessions';
  sessions: Array<Session>;
  totalCount: Scalars['Float']['output'];
  totalPages: Scalars['Float']['output'];
};

export type PartnerView = {
  __typename?: 'PartnerView';
  name: Scalars['String']['output'];
  targets: Array<TargetView>;
};

export type PipelineAlert = {
  __typename?: 'PipelineAlert';
  active?: Maybe<Scalars['Boolean']['output']>;
  clearedDateTime?: Maybe<Scalars['String']['output']>;
  createdDateTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type PipelineBroadcastAcquisition = {
  __typename?: 'PipelineBroadcastAcquisition';
  callSign: Scalars['String']['output'];
  defaults: Array<Maybe<PipelineBroadcastSource>>;
  overrides: Array<Maybe<PipelineBroadcastOverride>>;
};

export type PipelineBroadcastOverride = {
  __typename?: 'PipelineBroadcastOverride';
  callSign: Scalars['String']['output'];
  fronthaulDecoderInputLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  multicastAddress?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
};

export type PipelineBroadcastSource = {
  __typename?: 'PipelineBroadcastSource';
  decoderInputLabel?: Maybe<Scalars['String']['output']>;
  host: Scalars['String']['output'];
  multicastAddress: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type PipelineConfig = {
  activeSource?: InputMaybe<ProgramSource>;
  altaChannelUrl?: InputMaybe<Scalars['String']['input']>;
  backhaulDecoderHost?: InputMaybe<Scalars['String']['input']>;
  backhaulDecoderServiceLabel?: InputMaybe<Scalars['String']['input']>;
  eviProgramSwitchSrc?: InputMaybe<Scalars['Int']['input']>;
  eviSdpUrlAudio?: InputMaybe<Scalars['String']['input']>;
  eviSdpUrlVideo?: InputMaybe<Scalars['String']['input']>;
  eviSwitchDst?: InputMaybe<Scalars['Int']['input']>;
  fronthaulDecoderHost?: InputMaybe<Scalars['String']['input']>;
  fronthaulDecoderServiceLabel?: InputMaybe<Scalars['String']['input']>;
  lexiInstanceUrl?: InputMaybe<Scalars['String']['input']>;
  partnerLockEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  partnerLockExclusions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pd01Dst?: InputMaybe<Scalars['Int']['input']>;
  pd02Dst?: InputMaybe<Scalars['Int']['input']>;
  pd03Dst?: InputMaybe<Scalars['Int']['input']>;
  postGameSrc?: InputMaybe<Scalars['Int']['input']>;
  preGameSrc?: InputMaybe<Scalars['Int']['input']>;
  primaryBackhaulSrc?: InputMaybe<Scalars['Int']['input']>;
  primaryFronthaulSrc?: InputMaybe<Scalars['Int']['input']>;
  programSwitchDst?: InputMaybe<Scalars['Int']['input']>;
  programSwitchSrc?: InputMaybe<Scalars['Int']['input']>;
  red5BackupHost?: InputMaybe<Scalars['String']['input']>;
  red5BackupNodeGroup?: InputMaybe<Scalars['String']['input']>;
  red5PostProcStreamName?: InputMaybe<Scalars['String']['input']>;
  red5PreProcStreamName?: InputMaybe<Scalars['String']['input']>;
  red5PrimaryHost?: InputMaybe<Scalars['String']['input']>;
  red5PrimaryNodeGroup?: InputMaybe<Scalars['String']['input']>;
  sdpUrlAncillary?: InputMaybe<Scalars['String']['input']>;
  sdpUrlAudio?: InputMaybe<Scalars['String']['input']>;
  sdpUrlVideo?: InputMaybe<Scalars['String']['input']>;
  videonBackupStreamUrl?: InputMaybe<Scalars['String']['input']>;
  videonPrimaryStreamUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PipelineConfigInfo = {
  __typename?: 'PipelineConfigInfo';
  activeSource?: Maybe<ProgramSource>;
  altaChannelUrl?: Maybe<Scalars['String']['output']>;
  backhaulDecoderHost?: Maybe<Scalars['String']['output']>;
  backhaulDecoderServiceLabel?: Maybe<Scalars['String']['output']>;
  eviProgramSwitchSrc?: Maybe<Scalars['Int']['output']>;
  eviSdpUrlAudio?: Maybe<Scalars['String']['output']>;
  eviSdpUrlVideo?: Maybe<Scalars['String']['output']>;
  eviSwitchDst?: Maybe<Scalars['Int']['output']>;
  fronthaulDecoderHost?: Maybe<Scalars['String']['output']>;
  fronthaulDecoderServiceLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lexiInstanceUrl?: Maybe<Scalars['String']['output']>;
  partnerLockEnabled?: Maybe<Scalars['Boolean']['output']>;
  partnerLockExclusions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pd01Dst?: Maybe<Scalars['Int']['output']>;
  pd02Dst?: Maybe<Scalars['Int']['output']>;
  pd03Dst?: Maybe<Scalars['Int']['output']>;
  postGameSrc?: Maybe<Scalars['Int']['output']>;
  preGameSrc?: Maybe<Scalars['Int']['output']>;
  primaryBackhaulSrc?: Maybe<Scalars['Int']['output']>;
  primaryFronthaulSrc?: Maybe<Scalars['Int']['output']>;
  programSwitchDst?: Maybe<Scalars['Int']['output']>;
  programSwitchSrc?: Maybe<Scalars['Int']['output']>;
  red5BackupHost?: Maybe<Scalars['String']['output']>;
  red5BackupNodeGroup?: Maybe<Scalars['String']['output']>;
  red5PostProcStreamName?: Maybe<Scalars['String']['output']>;
  red5PreProcStreamName?: Maybe<Scalars['String']['output']>;
  red5PrimaryHost?: Maybe<Scalars['String']['output']>;
  red5PrimaryNodeGroup?: Maybe<Scalars['String']['output']>;
  sdpUrlAncillary?: Maybe<Scalars['String']['output']>;
  sdpUrlAudio?: Maybe<Scalars['String']['output']>;
  sdpUrlVideo?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  videonBackupStreamUrl?: Maybe<Scalars['String']['output']>;
  videonPrimaryStreamUrl?: Maybe<Scalars['String']['output']>;
};

export enum PipelineEviStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

export enum PipelineHealthStatus {
  HEALTHY = 'HEALTHY',
  UNHEALTHY = 'UNHEALTHY'
}

export type PipelineInputConfig = {
  category: Scalars['String']['input'];
  inputLabel: Scalars['String']['input'];
};

export type PipelineInputConfigInfo = {
  __typename?: 'PipelineInputConfigInfo';
  category?: Maybe<Scalars['String']['output']>;
  feedTypeCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inputLabel?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type PipelineMonitor = {
  __typename?: 'PipelineMonitor';
  eventPipeline?: Maybe<PipelineMonitorEventPipelineInfo>;
  pipelineConfig?: Maybe<PipelineConfigInfo>;
};

export type PipelineMonitorEventPipelineInfo = {
  __typename?: 'PipelineMonitorEventPipelineInfo';
  status?: Maybe<PipelineStatus>;
};

export type PipelineMulticastMapping = {
  __typename?: 'PipelineMulticastMapping';
  callSign: Scalars['String']['output'];
  hdrMulticastAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  multicastAddress: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  sourceLocation: Scalars['String']['output'];
};

export enum PipelineStatus {
  ARCHIVED = 'ARCHIVED',
  ENDED = 'ENDED',
  ENDING = 'ENDING',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  PROVISIONED = 'PROVISIONED',
  RUNNING = 'RUNNING',
  SCHEDULED = 'SCHEDULED',
  STARTING = 'STARTING',
  WARNING = 'WARNING'
}

export type Playback = {
  __typename?: 'Playback';
  adEngineIdentifiers: Array<AdEngineIdentifier>;
  adExperienceType: AdExperienceType;
  adsEnabled: Scalars['Boolean']['output'];
  cdn?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priority: Scalars['Int']['output'];
  token?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum PlaybackExperience {
  FASTLY = 'FASTLY',
  MEDIA_CDN = 'MEDIA_CDN'
}

export enum PlaybackFeature {
  AUDIO_ADS_DISABLED = 'AUDIO_ADS_DISABLED',
  EVI_DISABLED = 'EVI_DISABLED',
  EVI_ENABLED = 'EVI_ENABLED',
  HDR_DISABLED = 'HDR_DISABLED',
  HDR_ENABLED = 'HDR_ENABLED',
  VIDEO_ADS_DISABLED = 'VIDEO_ADS_DISABLED'
}

export type PlaybackInfo = {
  __typename?: 'PlaybackInfo';
  mediaId: Scalars['String']['output'];
  playbacks: Array<Playback>;
};

export type PlaybackSession = {
  __typename?: 'PlaybackSession';
  contentExperience: Scalars['String']['output'];
  countsForCap: Scalars['Boolean']['output'];
  createTime: Scalars['String']['output'];
  entitlements: Array<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  mediaId: Scalars['String']['output'];
  playbackSessionId: Scalars['String']['output'];
  playbackStatus: Scalars['String']['output'];
};

export type PolicyCreateInput = {
  action: Scalars['String']['input'];
  actionLabel: Scalars['String']['input'];
  audienceHref: Scalars['String']['input'];
  href: Scalars['String']['input'];
  /**
   * `policyName` should be non-nullable, however as it is a new field it is
   * made nullable for the time-being and will be filled in with href until
   * clients like SOP are able to migrate to requiring this value.
   */
  policyName?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyUpdateInput = {
  action: Scalars['String']['input'];
  actionLabel: Scalars['String']['input'];
  audienceHref: Scalars['String']['input'];
  /**
   * `policyName` should be non-nullable, however as it is a new field it is
   * made nullable for the time-being until clients like SOP are able to migrate
   * to requiring this value.
   */
  policyName?: InputMaybe<Scalars['String']['input']>;
};

export type Profile = {
  __typename?: 'Profile';
  doNotSell?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  favoriteTeam?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum ProgramSource {
  AUDIO = 'AUDIO',
  BACKHAUL = 'BACKHAUL',
  FRONTHAUL = 'FRONTHAUL',
  UNKNOWN = 'UNKNOWN'
}

export type Query = {
  __typename?: 'Query';
  /** Return the list of available event based triggers that are supported by the ad server */
  adEventTypes: Array<AdEventType>;
  /** Get ads enabled status */
  adsEnabled: Scalars['Boolean']['output'];
  /** Return audience by href */
  audience?: Maybe<Audience>;
  /** Return the list of audiences that exist */
  audiences: Array<Audience>;
  /** Fetch audit source systems and associated operations */
  auditSourceSystems: Array<AuditSourceSystemMetadata>;
  /** Fetch full audit trail */
  audits: AuditPageView;
  /** Get a BiVo job by id */
  bivoJob?: Maybe<BivoJob>;
  /** Get BiVo job definitions grouped by executor */
  bivoJobDefinitions: Array<BivoJobDefinitionGroup>;
  /**
   * Search BiVo jobs. When gamePk is provided, returns jobs for that game.
   * Otherwise searches by date range; startDate is required on that path.
   */
  bivoJobs?: Maybe<Array<BivoJob>>;
  broadcastAcquisitions: PipelineBroadcastAcquisition;
  /** Gets all configured source overrides */
  broadcastSourceOverrides: Array<BroadcastSourceOverride>;
  /** Get all Copyright Streams */
  copyrightStreams: Array<CopyrightStream>;
  /** Get ESNI rules with pagination */
  esniRules: Array<EsniRule>;
  /** Get EVI pods */
  eviPods: Array<EviPodInfo>;
  /**
   * Get all existing experience overrides
   * @deprecated Use sessionOverrides or playbackOverrides instead
   */
  experienceOverrides: Array<ExperienceOverrideSearchView>;
  /** Get game information */
  game?: Maybe<Game>;
  /** Fetch all Location (Blackout) overrides */
  getActiveLocationOverrides: LocationOverridePageView;
  /** Get all Zixi Channels */
  getAllChannels: Array<DataCenter>;
  /** Fetch all targets */
  getAllTargets: Array<PartnerView>;
  /**
   * Fetch full audit trail by GamePk
   * @deprecated Replaced by audits query for more robust searching
   */
  getAuditByGame: Array<AuditView>;
  /**
   * Fetch full audit trail by Media Id
   * @deprecated Replaced by audits query for more robust searching
   */
  getAuditByMedia: Array<AuditView>;
  /**
   * Fetch full audit trail by user email
   * @deprecated Replaced by audits query for more robust searching
   */
  getAuditByUser: Array<AuditView>;
  /** Get Zixi Channel by name */
  getChannel?: Maybe<Channel>;
  getFeatures: Array<Feature>;
  /** Get # of available pipelines for provisioning */
  getNumAvailablePipelines: Scalars['Int']['output'];
  getPlaybackExperience: UserExperienceOverrideView;
  /** Fetch target by name */
  getTarget?: Maybe<TargetView>;
  /** Get matching override experience */
  getUserExperience: UserExperienceOverrideView;
  /** Return the media policies based on search by either media, game, or date */
  mediaPolicies: Array<MediaPolicy>;
  /** The schema definition for each type of milestone */
  milestoneSchemas: Array<MilestoneSchema>;
  /** Get the current game and stream milestones for a given mediaId */
  milestones?: Maybe<Array<Milestone>>;
  multicastMapping?: Maybe<PipelineMulticastMapping>;
  /** Get low-level info about Media pipelines */
  pipelineConfigs: Array<PipelineConfigInfo>;
  /** Get info about Media pipeline inputs */
  pipelineInputConfigs: Array<PipelineInputConfigInfo>;
  /** Get all active pipelines */
  pipelineMonitors: Array<PipelineMonitor>;
  /** Get CDNs from playback service */
  playbackCdns: Array<CdnStatus>;
  playbackOverrides: Array<ExperienceOverrideSearchView>;
  /**
   * Get the schedule for a given sport or list of sports.
   *
   * Default args are today's schedule and MLB sport code. Date format supported is YYYY-MM-DD
   */
  schedule: Array<Game>;
  searchMulticastMappings: Array<PipelineMulticastMapping>;
  /** Get all Zixi Sources Based on the search parameters provided */
  searchZixiSourcesByTeam: Array<SkywalkerZixiSource>;
  sessionOverrides: Array<ExperienceOverrideSearchView>;
  /** Get all Signing Key value by id */
  signingKeyValue?: Maybe<Scalars['String']['output']>;
  /** Get all SigningKeys */
  signingKeys: Array<SigningKey>;
  /** Get all Skyview configs */
  skyviewConfigs: Array<SkyviewConfig>;
  /** Get available slates by sport */
  slates: Array<Slate>;
  /** Return user data by oktaId */
  userData: UserData;
  /** Get user information based on email */
  userInfo?: Maybe<UserInfo>;
  validationSchemas: Array<ValidationSchema>;
  /** Return the list of policies that exist */
  viewingPolicies: Array<ViewingPolicy>;
};


export type QueryAdEventTypesArgs = {
  sport?: InputMaybe<Sport>;
};


export type QueryAudienceArgs = {
  href: Scalars['String']['input'];
};


export type QueryAuditsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  instigator?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operations?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sourceSystems?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<ResourceTagInput>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBivoJobArgs = {
  jobId: Scalars['Int']['input'];
};


export type QueryBivoJobsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  gamePk?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BivoJobStatus>;
};


export type QueryBroadcastAcquisitionsArgs = {
  feedTypeCode: Scalars['String']['input'];
  gamePk: Scalars['Int']['input'];
};


export type QueryCopyrightStreamsArgs = {
  gamePk: Scalars['Int']['input'];
  scheduleDate: Scalars['String']['input'];
};


export type QueryEsniRulesArgs = {
  status?: InputMaybe<EsniRuleStatus>;
  type?: InputMaybe<EsniRuleType>;
};


export type QueryGameArgs = {
  gamePk: Scalars['Int']['input'];
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetActiveLocationOverridesArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sortAttribute?: LocationOverrideSortAttribute;
  sortOrder?: LocationOverrideSortOrder;
};


export type QueryGetAuditByGameArgs = {
  gamePk: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAuditByMediaArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mediaId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAuditByUserArgs = {
  email: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetChannelArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetFeaturesArgs = {
  gameDate: Scalars['String']['input'];
};


export type QueryGetPlaybackExperienceArgs = {
  matchParams: Scalars['JSON']['input'];
};


export type QueryGetTargetArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetUserExperienceArgs = {
  matchParams: Scalars['JSON']['input'];
};


export type QueryMediaPoliciesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  gamePk?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMilestonesArgs = {
  mediaId: Scalars['String']['input'];
};


export type QueryMulticastMappingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPipelineConfigsArgs = {
  teamId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPipelineInputConfigsArgs = {
  venueId: Scalars['Int']['input'];
};


export type QueryScheduleArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<InputMaybe<Sport>>>;
};


export type QuerySearchMulticastMappingsArgs = {
  callSign?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sourceLocation?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchZixiSourcesByTeamArgs = {
  activeSource?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySigningKeyValueArgs = {
  id: Scalars['String']['input'];
};


export type QuerySigningKeysArgs = {
  contentType?: InputMaybe<SigningKeyContentType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySlatesArgs = {
  sport?: InputMaybe<Sport>;
  type?: InputMaybe<SlateType>;
};


export type QueryUserDataArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserInfoArgs = {
  email: Scalars['String']['input'];
};

export type Red5Config = {
  __typename?: 'Red5Config';
  backupHost?: Maybe<Scalars['String']['output']>;
  backupNodeGroup?: Maybe<Scalars['String']['output']>;
  postProcStreamName?: Maybe<Scalars['String']['output']>;
  preProcStreamName?: Maybe<Scalars['String']['output']>;
  primaryHost?: Maybe<Scalars['String']['output']>;
  primaryNodeGroup?: Maybe<Scalars['String']['output']>;
};

export type ResourceTag = {
  __typename?: 'ResourceTag';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ResourceTagInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum RouteType {
  POSTGAME = 'POSTGAME',
  PREGAME = 'PREGAME',
  PROGRAM = 'PROGRAM'
}

export type Rule = {
  __typename?: 'Rule';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Session = {
  __typename?: 'Session';
  device: Device;
  experience: Scalars['String']['output'];
  expireDate: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  initTime: Scalars['String']['output'];
  location: Location;
  playbackSessions: Array<PlaybackSession>;
  sessionId: Scalars['String']['output'];
};

export enum SessionExperience {
  MLB = 'MLB'
}

export enum SessionFeature {
  AUDIO_ADS_DISABLED = 'AUDIO_ADS_DISABLED',
  MLB_AUDIO = 'MLB_AUDIO',
  VIDEO_ADS_DISABLED = 'VIDEO_ADS_DISABLED'
}

export type SigningKey = {
  __typename?: 'SigningKey';
  contentType: SigningKeyContentType;
  createdAt: Scalars['String']['output'];
  deprecatedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  promotedAt?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export enum SigningKeyContentType {
  LINEAR = 'LINEAR',
  MILB_GAME = 'MILB_GAME',
  MLB_GAME = 'MLB_GAME',
  SUBSCRIBER_LIVE = 'SUBSCRIBER_LIVE',
  SUBSCRIBER_VOD = 'SUBSCRIBER_VOD'
}

export type SkyviewConfig = {
  __typename?: 'SkyviewConfig';
  enabled: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  teamId: Scalars['Int']['output'];
};

export type SkywalkerZixiSource = {
  __typename?: 'SkywalkerZixiSource';
  activeSource: Scalars['String']['output'];
  destination: Scalars['String']['output'];
  location: Scalars['String']['output'];
  teamId?: Maybe<Scalars['Int']['output']>;
  zixiSourceName: Scalars['String']['output'];
};

export type Slate = {
  __typename?: 'Slate';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  sourceSystem: MediaSourceSystem;
  thumbnailUri?: Maybe<Scalars['String']['output']>;
  type: SlateType;
};

export enum SlateType {
  AD_BREAK = 'AD_BREAK',
  ENDING = 'ENDING',
  MID = 'MID',
  STARTING = 'STARTING'
}

export enum SourceType {
  GAME = 'GAME',
  POSTGAME = 'POSTGAME',
  PREGAME = 'PREGAME'
}

export enum Sport {
  AA = 'AA',
  AAA = 'AAA',
  HIGH_A = 'HIGH_A',
  LOW_A = 'LOW_A',
  MLB = 'MLB'
}

export enum StreamState {
  EVENT_ARCHIVE = 'EVENT_ARCHIVE',
  PROGRAM_DONE = 'PROGRAM_DONE',
  PROGRAM_ON = 'PROGRAM_ON',
  STREAM_DONE = 'STREAM_DONE',
  STREAM_OFF = 'STREAM_OFF',
  STREAM_ON = 'STREAM_ON'
}

export type Subscription = {
  __typename?: 'Subscription';
  mediaUpdates: Media;
};


export type SubscriptionMediaUpdatesArgs = {
  mediaIds: Array<Scalars['String']['input']>;
};

export type TargetChangeInput = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  target: TargetIdentifierInput;
};

export type TargetIdentifier = {
  __typename?: 'TargetIdentifier';
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type TargetIdentifierInput = {
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type TargetView = {
  __typename?: 'TargetView';
  channelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Team = {
  __typename?: 'Team';
  abbreviation: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export enum TopBottom {
  BOTTOM = 'BOTTOM',
  TOP = 'TOP'
}

export type UpdateTargetResult = {
  __typename?: 'UpdateTargetResult';
  channelId?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  target: TargetIdentifier;
};

export type UserData = {
  __typename?: 'UserData';
  cachedEntitlements?: Maybe<Array<Scalars['String']['output']>>;
  cachedProfile?: Maybe<CachedProfile>;
  entitlements: Array<Scalars['String']['output']>;
  profile: Profile;
  sessions?: Maybe<PaginatedSessions>;
  userId: Scalars['String']['output'];
};


export type UserDataSessionsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UserExperienceOverrideView = {
  __typename?: 'UserExperienceOverrideView';
  experience: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  isValid: Scalars['Boolean']['output'];
  ruleResults: Array<Maybe<ValidationRuleResult>>;
  validationProcess: Scalars['String']['output'];
};

export type ValidationRuleResult = {
  __typename?: 'ValidationRuleResult';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  result: Scalars['Boolean']['output'];
};

export type ValidationSchema = {
  __typename?: 'ValidationSchema';
  rules: Array<Maybe<Rule>>;
  validationProcess: Scalars['String']['output'];
};

export type Venue = {
  __typename?: 'Venue';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum VideoColorSpace {
  HDR = 'HDR',
  SDR = 'SDR'
}

export enum VideoResolution {
  /**  720p */
  FHD = 'FHD',
  HD = 'HD',
  /**  1080p */
  UHD = 'UHD'
}

export type ViewingPolicy = {
  __typename?: 'ViewingPolicy';
  action: Scalars['String']['output'];
  actionLabel: Scalars['String']['output'];
  audienceHref: Scalars['String']['output'];
  href: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ScheduleQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<InputMaybe<Sport>> | InputMaybe<Sport>>;
}>;


export type ScheduleQuery = { __typename?: 'Query', schedule: Array<{ __typename?: 'Game', gameDate: string, gamePk: number, status: GameStatus, away: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, home: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, venue: { __typename?: 'Venue', id: number, name: string }, feeds: Array<{ __typename?: 'Feed', feedType: MediaFeedType, postGameShow: boolean, preGameShow?: string | null }>, content: Array<{ __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, gamePk?: number | null, mediaId: string, mediaState: { __typename?: 'MediaConfiguration', contentExperience: ContentExperience, mediaType: MediaType, state: MediaState } }>, pipelines: Array<{ __typename?: 'MediaPipeline', id: number, feedType: MediaFeedType, programSource: ProgramSource, status: PipelineStatus, scheduledStartDateTime?: string | null, streamState: StreamState, resumedFromDateTime?: string | null, pregameSource: ProgramSource, postgameSource: ProgramSource, gameSource: ProgramSource, media: Array<{ __typename?: 'MediaContext', id: string, mediaType: MediaType, feedType: MediaFeedType }> }> }> };

export type AuditsQueryVariables = Exact<{
  sourceSystems?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  operations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  instigator?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<ResourceTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AuditsQuery = { __typename?: 'Query', audits: { __typename?: 'AuditPageView', total: number, audits: Array<{ __typename?: 'AuditView', id: number, createdAt: string, sourceSystem: string, operation: string, instigator?: string | null, email?: string | null, traceId?: string | null, eventData?: any | null, resourceTags?: Array<{ __typename?: 'ResourceTag', name: string, value: string }> | null }> } };

export type AuditSourceSystemsQueryVariables = Exact<{ [key: string]: never; }>;


export type AuditSourceSystemsQuery = { __typename?: 'Query', auditSourceSystems: Array<{ __typename?: 'AuditSourceSystemMetadata', name: string, operations: Array<string> }> };

export type BtcPipelineFieldsFragment = { __typename?: 'MediaPipeline', id: number, activeSlateCode?: string | null, feedType: MediaFeedType, programSource: ProgramSource, pregameSource: ProgramSource, gameSource: ProgramSource, postgameSource: ProgramSource, status: PipelineStatus, sourceSystem: MediaSourceSystem, scheduledStartDateTime?: string | null, streamState: StreamState, resumedFromDateTime?: string | null, eviStatus: PipelineEviStatus, eviPod?: { __typename?: 'EviPodInfo', active: boolean, vendor: string, id: number, name: string } | null, media: Array<{ __typename?: 'MediaContext', id: string, mediaType: MediaType, feedType: MediaFeedType }>, alerts: Array<{ __typename?: 'PipelineAlert', active?: boolean | null, clearedDateTime?: string | null, createdDateTime: string, id: number, message: string }> };

export type BtcPipelineMediaUpdateFieldsFragment = { __typename?: 'MediaPipeline', id: number, activeSlateCode?: string | null, feedType: MediaFeedType, status: PipelineStatus, sourceSystem: MediaSourceSystem, scheduledStartDateTime?: string | null, streamState: StreamState, resumedFromDateTime?: string | null, eviStatus: PipelineEviStatus, eviPod?: { __typename?: 'EviPodInfo', active: boolean, vendor: string, id: number, name: string } | null, media: Array<{ __typename?: 'MediaContext', id: string, mediaType: MediaType, feedType: MediaFeedType }>, alerts: Array<{ __typename?: 'PipelineAlert', active?: boolean | null, clearedDateTime?: string | null, createdDateTime: string, id: number, message: string }> };

export type BtcContentFieldsFragment = { __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, gamePk?: number | null, mediaId: string, language: string, mediaState: { __typename?: 'MediaConfiguration', contentExperience: ContentExperience, mediaType: MediaType, state: MediaState } };

export type BtcContentAssetsFieldsFragment = { __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, gamePk?: number | null, mediaId: string, language: string, assets: Array<{ __typename?: 'LocationAsset', adStatus?: string | null, assetId?: number | null, cdn: string, features?: Array<string | null> | null, provider: string, state: AssetState, tier: AssetTier, videoId?: string | null, playback?: { __typename?: 'Playback', url: string, cdn?: string | null, token?: string | null, expiration?: string | null, adsEnabled: boolean, adExperienceType: AdExperienceType, priority: number, adEngineIdentifiers: Array<{ __typename?: 'AdEngineIdentifier', name: string, value: string }> } | null }>, mediaState: { __typename?: 'MediaConfiguration', contentExperience: ContentExperience, mediaType: MediaType, state: MediaState } };

export type BtcBroadcastFieldsFragment = { __typename?: 'Broadcast', availability: BroadcastAvailability, availableForStreaming: boolean, callSign: string, colorSpace?: VideoColorSpace | null, feedType: MediaFeedType, language: string, mediaId: string, mediaState: MediaState, mediaType: MediaType, mvpdRequired: boolean, name: string, postGameShow: boolean, preGameShow?: string | null, videoResolution?: VideoResolution | null, freeGameStatuses: Array<{ __typename?: 'FreeGameStatus', freeGameType: FreeGameType, status: boolean }> };

export type BtcGameFieldsFragment = { __typename?: 'Game', gameDate: string, gamePk: number, status: GameStatus, away: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, home: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, venue: { __typename?: 'Venue', id: number, name: string }, features: Array<{ __typename?: 'Feature', featureType: FeatureType, gameDate: string, gamePk: number, id: number }>, feeds: Array<{ __typename?: 'Feed', feedType: MediaFeedType, postGameShow: boolean, preGameShow?: string | null }>, broadcasts: Array<{ __typename?: 'Broadcast', availability: BroadcastAvailability, availableForStreaming: boolean, callSign: string, colorSpace?: VideoColorSpace | null, feedType: MediaFeedType, language: string, mediaId: string, mediaState: MediaState, mediaType: MediaType, mvpdRequired: boolean, name: string, postGameShow: boolean, preGameShow?: string | null, videoResolution?: VideoResolution | null, freeGameStatuses: Array<{ __typename?: 'FreeGameStatus', freeGameType: FreeGameType, status: boolean }> }>, content: Array<{ __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, gamePk?: number | null, mediaId: string, language: string, mediaState: { __typename?: 'MediaConfiguration', contentExperience: ContentExperience, mediaType: MediaType, state: MediaState } }>, pipelines: Array<{ __typename?: 'MediaPipeline', id: number, activeSlateCode?: string | null, feedType: MediaFeedType, programSource: ProgramSource, pregameSource: ProgramSource, gameSource: ProgramSource, postgameSource: ProgramSource, status: PipelineStatus, sourceSystem: MediaSourceSystem, scheduledStartDateTime?: string | null, streamState: StreamState, resumedFromDateTime?: string | null, eviStatus: PipelineEviStatus, eviPod?: { __typename?: 'EviPodInfo', active: boolean, vendor: string, id: number, name: string } | null, media: Array<{ __typename?: 'MediaContext', id: string, mediaType: MediaType, feedType: MediaFeedType }>, alerts: Array<{ __typename?: 'PipelineAlert', active?: boolean | null, clearedDateTime?: string | null, createdDateTime: string, id: number, message: string }> }> };

export type MulticastMappingFieldsFragment = { __typename?: 'PipelineMulticastMapping', id: number, callSign: string, sourceLocation: string, multicastAddress: string, hdrMulticastAddress?: string | null, priority: string };

export type CopyrightStreamFieldsFragment = { __typename?: 'CopyrightStream', id: string, gamePk: number, homeTriCode: string, awayTriCode: string, scheduleDate: string, feedType: string, status: string, gameStartTime: string, streamStartTime?: string | null, streamEndTime?: string | null };

export type ProvisionMediaMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProvisionMediaMutation = { __typename?: 'Mutation', provisionMedia: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null }> };

export type UnscheduleMediaMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UnscheduleMediaMutation = { __typename?: 'Mutation', unscheduleMedia: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null }> };

export type StartMediaMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type StartMediaMutation = { __typename?: 'Mutation', startMedia: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, reason?: string | null, success: boolean }> };

export type StopMediaMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type StopMediaMutation = { __typename?: 'Mutation', stopMedia: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, reason?: string | null, success: boolean }> };

export type ArchiveMediaMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ArchiveMediaMutation = { __typename?: 'Mutation', archiveMedia: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, reason?: string | null, success: boolean }> };

export type ResolveAlertMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  alertId: Scalars['String']['input'];
}>;


export type ResolveAlertMutation = { __typename?: 'Mutation', resolveAlert: { __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null } };

export type SetEviStatusMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  status: PipelineEviStatus;
}>;


export type SetEviStatusMutation = { __typename?: 'Mutation', setEviStatus: { __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null } };

export type SyncMediaContentMutationVariables = Exact<{
  gamePk: Scalars['Int']['input'];
}>;


export type SyncMediaContentMutation = { __typename?: 'Mutation', syncMediaContent?: Array<string> | null };

export type UpdatePipelineMediaMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
}>;


export type UpdatePipelineMediaMutation = { __typename?: 'Mutation', updatePipelineMedia: { __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null } };

export type UpdateAssetsStateMutationVariables = Exact<{
  mediaAssets: Array<MediaAssetsInput> | MediaAssetsInput;
  assetState: AssetState;
}>;


export type UpdateAssetsStateMutation = { __typename?: 'Mutation', updateAssetsState: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null }> };

export type ActivateAdsMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
}>;


export type ActivateAdsMutation = { __typename?: 'Mutation', activateAds: boolean };

export type PauseAdsMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
}>;


export type PauseAdsMutation = { __typename?: 'Mutation', pauseAds: boolean };

export type CreateMulticastMappingMutationVariables = Exact<{
  callSign: Scalars['String']['input'];
  priority: Scalars['String']['input'];
  sourceLocation: Scalars['String']['input'];
  multicastAddress: Scalars['String']['input'];
  hdrMulticastAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMulticastMappingMutation = { __typename?: 'Mutation', createMulticastMapping?: { __typename?: 'PipelineMulticastMapping', id: number, callSign: string, sourceLocation: string, multicastAddress: string, hdrMulticastAddress?: string | null, priority: string } | null };

export type UpdateMulticastMappingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  updatedMapping: MulticastMappingUpdateRequest;
}>;


export type UpdateMulticastMappingMutation = { __typename?: 'Mutation', updateMulticastMapping?: { __typename?: 'PipelineMulticastMapping', id: number, callSign: string, sourceLocation: string, multicastAddress: string, hdrMulticastAddress?: string | null, priority: string } | null };

export type DeleteMulticastMappingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteMulticastMappingMutation = { __typename?: 'Mutation', deleteMulticastMapping?: boolean | null };

export type AssignEviPodMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  eviPodName: Scalars['String']['input'];
}>;


export type AssignEviPodMutation = { __typename?: 'Mutation', assignEviPod: { __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null } };

export type ProvisionCopyrightStreamMutationVariables = Exact<{
  stream: CopyrightStreamProvision;
}>;


export type ProvisionCopyrightStreamMutation = { __typename?: 'Mutation', provisionCopyrightStream?: { __typename?: 'CopyrightStream', id: string, gamePk: number, homeTriCode: string, awayTriCode: string, scheduleDate: string, feedType: string, status: string, gameStartTime: string, streamStartTime?: string | null, streamEndTime?: string | null } | null };

export type StartCopyrightStreamMutationVariables = Exact<{
  streamId: Scalars['String']['input'];
}>;


export type StartCopyrightStreamMutation = { __typename?: 'Mutation', startCopyrightStream?: { __typename?: 'CopyrightStream', id: string, gamePk: number, homeTriCode: string, awayTriCode: string, scheduleDate: string, feedType: string, status: string, gameStartTime: string, streamStartTime?: string | null, streamEndTime?: string | null } | null };

export type StopCopyrightStreamMutationVariables = Exact<{
  streamId: Scalars['String']['input'];
}>;


export type StopCopyrightStreamMutation = { __typename?: 'Mutation', stopCopyrightStream?: { __typename?: 'CopyrightStream', id: string, gamePk: number, homeTriCode: string, awayTriCode: string, scheduleDate: string, feedType: string, status: string, gameStartTime: string, streamStartTime?: string | null, streamEndTime?: string | null } | null };

export type DeleteCopyrightStreamMutationVariables = Exact<{
  streamId: Scalars['String']['input'];
}>;


export type DeleteCopyrightStreamMutation = { __typename?: 'Mutation', deleteCopyrightStream?: boolean | null };

export type UpdateCdnStatusMutationVariables = Exact<{
  cdn: Cdn;
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateCdnStatusMutation = { __typename?: 'Mutation', updateCdnStatus?: boolean | null };

export type UpdateBroadcastMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  mediaState?: InputMaybe<MediaState>;
  freeGameStatuses?: InputMaybe<Array<FreeGameStatusInput> | FreeGameStatusInput>;
  availableForStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  videoResolution?: InputMaybe<VideoResolution>;
  colorSpace?: InputMaybe<VideoColorSpace>;
  mvpdRequired?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateBroadcastMutation = { __typename?: 'Mutation', updateBroadcast: { __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null } };

export type UpdateBroadcastSourceMutationVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  feedType: MediaFeedType;
  sourceUpdateInput: BroadcastSourceUpdateInput;
}>;


export type UpdateBroadcastSourceMutation = { __typename?: 'Mutation', updateBroadcastSource?: boolean | null };

export type SwitchProgramSourceMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  programSource: ProgramSource;
}>;


export type SwitchProgramSourceMutation = { __typename?: 'Mutation', switchProgramSource: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null }> };

export type CreateBroadcastSourceOverrideMutationVariables = Exact<{
  broadcastSourceOverrideInput: BroadcastSourceOverrideInput;
}>;


export type CreateBroadcastSourceOverrideMutation = { __typename?: 'Mutation', createBroadcastSourceOverride?: { __typename?: 'BroadcastSourceOverride', id: string, callSign: string, pregameSource?: ProgramSource | null, gameSource?: ProgramSource | null, postgameSource?: ProgramSource | null } | null };

export type DeleteBroadcastSourceOverrideMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBroadcastSourceOverrideMutation = { __typename?: 'Mutation', deleteBroadcastSourceOverride?: boolean | null };

export type UpdateBroadcastSourceOverrideMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  broadcastSourceOverrideInput: BroadcastSourceOverrideInput;
}>;


export type UpdateBroadcastSourceOverrideMutation = { __typename?: 'Mutation', updateBroadcastSourceOverride?: { __typename?: 'BroadcastSourceOverride', id: string, callSign: string, pregameSource?: ProgramSource | null, postgameSource?: ProgramSource | null, gameSource?: ProgramSource | null } | null };

export type CreateBroadcastOverrideMutationVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  feedTypeCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
  callSign: Scalars['String']['input'];
  fronthaulDecoderInputLabel?: InputMaybe<Scalars['String']['input']>;
  multicastAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBroadcastOverrideMutation = { __typename?: 'Mutation', createBroadcastOverride?: { __typename?: 'PipelineBroadcastOverride', id: number, region: string, callSign: string, fronthaulDecoderInputLabel?: string | null, multicastAddress?: string | null } | null };

export type UpdateBroadcastOverrideMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  region: Scalars['String']['input'];
  updatedBroadcastOverride: BroadcastOverrideUpdateRequest;
}>;


export type UpdateBroadcastOverrideMutation = { __typename?: 'Mutation', updateBroadcastOverride?: { __typename?: 'PipelineBroadcastOverride', id: number, region: string, callSign: string, fronthaulDecoderInputLabel?: string | null, multicastAddress?: string | null } | null };

export type DeleteBroadcastOverrideMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  region: Scalars['String']['input'];
}>;


export type DeleteBroadcastOverrideMutation = { __typename?: 'Mutation', deleteBroadcastOverride?: boolean | null };

export type UpdatePartnerDistributionLockMutationVariables = Exact<{
  teamId: Scalars['Int']['input'];
  setLock: Scalars['Boolean']['input'];
}>;


export type UpdatePartnerDistributionLockMutation = { __typename?: 'Mutation', updatePartnerDistributionLock: boolean };

export type ToggleSkyviewConfigMutationVariables = Exact<{
  teamId: Scalars['Int']['input'];
  language: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleSkyviewConfigMutation = { __typename?: 'Mutation', toggleSkyviewConfig?: { __typename?: 'SkyviewConfig', teamId: number, language: string, enabled: boolean } | null };

export type ToggleAllSkyviewConfigsMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleAllSkyviewConfigsMutation = { __typename?: 'Mutation', toggleAllSkyviewConfigs?: boolean | null };

export type IngestAssetsIntoDaiMutationVariables = Exact<{
  assetIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type IngestAssetsIntoDaiMutation = { __typename?: 'Mutation', ingestAssetsIntoDai: boolean };

export type BtcScheduleQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<InputMaybe<Sport>> | InputMaybe<Sport>>;
}>;


export type BtcScheduleQuery = { __typename?: 'Query', schedule: Array<{ __typename?: 'Game', gameDate: string, gamePk: number, status: GameStatus, away: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, home: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, venue: { __typename?: 'Venue', id: number, name: string }, features: Array<{ __typename?: 'Feature', featureType: FeatureType, gameDate: string, gamePk: number, id: number }>, feeds: Array<{ __typename?: 'Feed', feedType: MediaFeedType, postGameShow: boolean, preGameShow?: string | null }>, broadcasts: Array<{ __typename?: 'Broadcast', availability: BroadcastAvailability, availableForStreaming: boolean, callSign: string, colorSpace?: VideoColorSpace | null, feedType: MediaFeedType, language: string, mediaId: string, mediaState: MediaState, mediaType: MediaType, mvpdRequired: boolean, name: string, postGameShow: boolean, preGameShow?: string | null, videoResolution?: VideoResolution | null, freeGameStatuses: Array<{ __typename?: 'FreeGameStatus', freeGameType: FreeGameType, status: boolean }> }>, content: Array<{ __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, gamePk?: number | null, mediaId: string, language: string, mediaState: { __typename?: 'MediaConfiguration', contentExperience: ContentExperience, mediaType: MediaType, state: MediaState } }>, pipelines: Array<{ __typename?: 'MediaPipeline', id: number, activeSlateCode?: string | null, feedType: MediaFeedType, programSource: ProgramSource, pregameSource: ProgramSource, gameSource: ProgramSource, postgameSource: ProgramSource, status: PipelineStatus, sourceSystem: MediaSourceSystem, scheduledStartDateTime?: string | null, streamState: StreamState, resumedFromDateTime?: string | null, eviStatus: PipelineEviStatus, eviPod?: { __typename?: 'EviPodInfo', active: boolean, vendor: string, id: number, name: string } | null, media: Array<{ __typename?: 'MediaContext', id: string, mediaType: MediaType, feedType: MediaFeedType }>, alerts: Array<{ __typename?: 'PipelineAlert', active?: boolean | null, clearedDateTime?: string | null, createdDateTime: string, id: number, message: string }> }> }> };

export type BtcGameQueryVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type BtcGameQuery = { __typename?: 'Query', game?: { __typename?: 'Game', gameDate: string, gamePk: number, status: GameStatus, away: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, home: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, venue: { __typename?: 'Venue', id: number, name: string }, features: Array<{ __typename?: 'Feature', featureType: FeatureType, gameDate: string, gamePk: number, id: number }>, feeds: Array<{ __typename?: 'Feed', feedType: MediaFeedType, postGameShow: boolean, preGameShow?: string | null }>, broadcasts: Array<{ __typename?: 'Broadcast', availability: BroadcastAvailability, availableForStreaming: boolean, callSign: string, colorSpace?: VideoColorSpace | null, feedType: MediaFeedType, language: string, mediaId: string, mediaState: MediaState, mediaType: MediaType, mvpdRequired: boolean, name: string, postGameShow: boolean, preGameShow?: string | null, videoResolution?: VideoResolution | null, freeGameStatuses: Array<{ __typename?: 'FreeGameStatus', freeGameType: FreeGameType, status: boolean }> }>, content: Array<{ __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, gamePk?: number | null, mediaId: string, language: string, mediaState: { __typename?: 'MediaConfiguration', contentExperience: ContentExperience, mediaType: MediaType, state: MediaState } }>, pipelines: Array<{ __typename?: 'MediaPipeline', id: number, activeSlateCode?: string | null, feedType: MediaFeedType, programSource: ProgramSource, pregameSource: ProgramSource, gameSource: ProgramSource, postgameSource: ProgramSource, status: PipelineStatus, sourceSystem: MediaSourceSystem, scheduledStartDateTime?: string | null, streamState: StreamState, resumedFromDateTime?: string | null, eviStatus: PipelineEviStatus, eviPod?: { __typename?: 'EviPodInfo', active: boolean, vendor: string, id: number, name: string } | null, media: Array<{ __typename?: 'MediaContext', id: string, mediaType: MediaType, feedType: MediaFeedType }>, alerts: Array<{ __typename?: 'PipelineAlert', active?: boolean | null, clearedDateTime?: string | null, createdDateTime: string, id: number, message: string }> }> } | null };

export type BtcGamePipelinesQueryVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type BtcGamePipelinesQuery = { __typename?: 'Query', game?: { __typename?: 'Game', gamePk: number, pipelines: Array<{ __typename?: 'MediaPipeline', id: number, activeSlateCode?: string | null, feedType: MediaFeedType, programSource: ProgramSource, pregameSource: ProgramSource, gameSource: ProgramSource, postgameSource: ProgramSource, status: PipelineStatus, sourceSystem: MediaSourceSystem, scheduledStartDateTime?: string | null, streamState: StreamState, resumedFromDateTime?: string | null, eviStatus: PipelineEviStatus, eviPod?: { __typename?: 'EviPodInfo', active: boolean, vendor: string, id: number, name: string } | null, media: Array<{ __typename?: 'MediaContext', id: string, mediaType: MediaType, feedType: MediaFeedType }>, alerts: Array<{ __typename?: 'PipelineAlert', active?: boolean | null, clearedDateTime?: string | null, createdDateTime: string, id: number, message: string }> }> } | null };

export type BtcGameContentQueryVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type BtcGameContentQuery = { __typename?: 'Query', game?: { __typename?: 'Game', gamePk: number, content: Array<{ __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, gamePk?: number | null, mediaId: string, language: string, mediaState: { __typename?: 'MediaConfiguration', contentExperience: ContentExperience, mediaType: MediaType, state: MediaState } }> } | null };

export type BtcGameContentWithAssetsQueryVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type BtcGameContentWithAssetsQuery = { __typename?: 'Query', game?: { __typename?: 'Game', gamePk: number, content: Array<{ __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, gamePk?: number | null, mediaId: string, language: string, assets: Array<{ __typename?: 'LocationAsset', adStatus?: string | null, assetId?: number | null, cdn: string, features?: Array<string | null> | null, provider: string, state: AssetState, tier: AssetTier, videoId?: string | null, playback?: { __typename?: 'Playback', url: string, cdn?: string | null, token?: string | null, expiration?: string | null, adsEnabled: boolean, adExperienceType: AdExperienceType, priority: number, adEngineIdentifiers: Array<{ __typename?: 'AdEngineIdentifier', name: string, value: string }> } | null }>, mediaState: { __typename?: 'MediaConfiguration', contentExperience: ContentExperience, mediaType: MediaType, state: MediaState } }> } | null };

export type SearchMulticastMappingQueryVariables = Exact<{
  callSign?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sourceLocations?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchMulticastMappingQuery = { __typename?: 'Query', searchMulticastMappings: Array<{ __typename?: 'PipelineMulticastMapping', id: number, callSign: string, sourceLocation: string, multicastAddress: string, hdrMulticastAddress?: string | null, priority: string }> };

export type EviPodsQueryVariables = Exact<{ [key: string]: never; }>;


export type EviPodsQuery = { __typename?: 'Query', eviPods: Array<{ __typename?: 'EviPodInfo', id: number, name: string, vendor: string, active: boolean }> };

export type CopyrightStreamsQueryVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  scheduleDate: Scalars['String']['input'];
}>;


export type CopyrightStreamsQuery = { __typename?: 'Query', copyrightStreams: Array<{ __typename?: 'CopyrightStream', id: string, gamePk: number, homeTriCode: string, awayTriCode: string, scheduleDate: string, feedType: string, status: string, gameStartTime: string, streamStartTime?: string | null, streamEndTime?: string | null }> };

export type PlaybackCdnsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaybackCdnsQuery = { __typename?: 'Query', playbackCdns: Array<{ __typename?: 'CdnStatus', cdn: Cdn, enabled: boolean }> };

export type BroadcastSourceOverridesQueryVariables = Exact<{ [key: string]: never; }>;


export type BroadcastSourceOverridesQuery = { __typename?: 'Query', broadcastSourceOverrides: Array<{ __typename?: 'BroadcastSourceOverride', id: string, callSign: string, pregameSource?: ProgramSource | null, gameSource?: ProgramSource | null, postgameSource?: ProgramSource | null }> };

export type BroadcastAcquisitionsQueryVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  feedTypeCode: Scalars['String']['input'];
}>;


export type BroadcastAcquisitionsQuery = { __typename?: 'Query', broadcastAcquisitions: { __typename?: 'PipelineBroadcastAcquisition', callSign: string, defaults: Array<{ __typename?: 'PipelineBroadcastSource', decoderInputLabel?: string | null, multicastAddress: string, host: string, region: string, priority: string } | null>, overrides: Array<{ __typename?: 'PipelineBroadcastOverride', id: number, region: string, callSign: string, fronthaulDecoderInputLabel?: string | null, multicastAddress?: string | null } | null> } };

export type SearchZixiSourcesByTeamQueryVariables = Exact<{
  teamId?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  activeSource?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchZixiSourcesByTeamQuery = { __typename?: 'Query', searchZixiSourcesByTeam: Array<{ __typename?: 'SkywalkerZixiSource', zixiSourceName: string, teamId?: number | null, location: string, destination: string, activeSource: string }> };

export type SkyviewConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type SkyviewConfigsQuery = { __typename?: 'Query', skyviewConfigs: Array<{ __typename?: 'SkyviewConfig', teamId: number, language: string, enabled: boolean }> };

export type MediaPolicyFieldsFragment = { __typename?: 'MediaPolicy', id: string, mediaType: string, gamePk?: string | null, feedType?: string | null, feedSubType?: string | null, language?: string | null, contentDate?: string | null };

export type ViewingPolicyFieldsFragment = { __typename?: 'ViewingPolicy', id: number, href: string, action: string, actionLabel: string, name: string, audienceHref: string };

export type EsniRuleFieldsFragment = { __typename?: 'EsniRule', id: string, name: string, type: EsniRuleType, priority: number, query: string, status: EsniRuleStatus, actions: Array<{ __typename?: 'EsniRuleAction', actionType: ActionType, metadata: any }> };

export type EsniMediaProcessingResultFieldsFragment = { __typename?: 'EsniMediaProcessingResult', policies: Array<string>, rules: Array<{ __typename?: 'EsniRule', id: string, name: string, type: EsniRuleType, status: EsniRuleStatus, priority: number }> };

export type UpdateAudienceMutationVariables = Exact<{
  href: Scalars['String']['input'];
  audience: AudienceUpdateInput;
}>;


export type UpdateAudienceMutation = { __typename?: 'Mutation', updateAudience?: { __typename?: 'Audience', href: string, authenticated: boolean, match: string, type: AudienceType, details?: Array<string> | null, id: number } | null };

export type CreatePolicyMutationVariables = Exact<{
  policy: PolicyCreateInput;
}>;


export type CreatePolicyMutation = { __typename?: 'Mutation', createPolicy?: { __typename?: 'ViewingPolicy', id: number, href: string, action: string, actionLabel: string, name: string, audienceHref: string } | null };

export type UpdatePolicyMutationVariables = Exact<{
  href: Scalars['String']['input'];
  policy: PolicyUpdateInput;
}>;


export type UpdatePolicyMutation = { __typename?: 'Mutation', updatePolicy?: { __typename?: 'ViewingPolicy', id: number, href: string, action: string, actionLabel: string, name: string, audienceHref: string } | null };

export type UpsertMediaPoliciesMutationVariables = Exact<{
  media: MediaPolicyInput;
}>;


export type UpsertMediaPoliciesMutation = { __typename?: 'Mutation', upsertMediaPolicies?: Array<{ __typename?: 'MediaPolicy', id: string, mediaType: string, gamePk?: string | null, feedType?: string | null, feedSubType?: string | null, language?: string | null, contentDate?: string | null, viewingPolicies: Array<{ __typename?: 'ViewingPolicy', id: number, href: string, action: string, actionLabel: string, name: string, audienceHref: string }> } | null> | null };

export type CreateAudienceMutationVariables = Exact<{
  audience: AudienceCreateInput;
}>;


export type CreateAudienceMutation = { __typename?: 'Mutation', createAudience?: { __typename?: 'Audience', href: string, authenticated: boolean, match: string, type: AudienceType, details?: Array<string> | null } | null };

export type DeletePolicyMutationVariables = Exact<{
  href: Scalars['String']['input'];
}>;


export type DeletePolicyMutation = { __typename?: 'Mutation', deletePolicy: { __typename?: 'EchoProcessingResult', href: string, success: boolean, reason?: string | null } };

export type DeleteAudienceMutationVariables = Exact<{
  href: Scalars['String']['input'];
}>;


export type DeleteAudienceMutation = { __typename?: 'Mutation', deleteAudience: { __typename?: 'EchoProcessingResult', href: string, success: boolean, reason?: string | null } };

export type DeleteEsniRuleMutationVariables = Exact<{
  ruleId: Scalars['String']['input'];
}>;


export type DeleteEsniRuleMutation = { __typename?: 'Mutation', deleteEsniRule: { __typename?: 'EsniRuleProcessingResult', ruleId: string, success: boolean, reason?: string | null } };

export type CreateEsniRuleMutationVariables = Exact<{
  input: EsniRuleInput;
}>;


export type CreateEsniRuleMutation = { __typename?: 'Mutation', createEsniRule: { __typename?: 'EsniRule', id: string, name: string, type: EsniRuleType, priority: number, query: string, status: EsniRuleStatus, actions: Array<{ __typename?: 'EsniRuleAction', actionType: ActionType, metadata: any }> } };

export type UpdateEsniRuleMutationVariables = Exact<{
  ruleId: Scalars['String']['input'];
  input: EsniRuleInput;
}>;


export type UpdateEsniRuleMutation = { __typename?: 'Mutation', updateEsniRule: { __typename?: 'EsniRule', id: string, name: string, type: EsniRuleType, priority: number, query: string, status: EsniRuleStatus, actions: Array<{ __typename?: 'EsniRuleAction', actionType: ActionType, metadata: any }> } };

export type ValidateEsniMediaMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
}>;


export type ValidateEsniMediaMutation = { __typename?: 'Mutation', validateEsniMedia?: { __typename?: 'EsniMediaProcessingResult', policies: Array<string>, rules: Array<{ __typename?: 'EsniRule', id: string, name: string, type: EsniRuleType, status: EsniRuleStatus, priority: number }> } | null };

export type ProcessEsniMediaMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
}>;


export type ProcessEsniMediaMutation = { __typename?: 'Mutation', processEsniMedia?: { __typename?: 'EsniMediaProcessingResult', policies: Array<string>, rules: Array<{ __typename?: 'EsniRule', id: string, name: string, type: EsniRuleType, status: EsniRuleStatus, priority: number }> } | null };

export type MediaPoliciesQueryVariables = Exact<{
  mediaId?: InputMaybe<Scalars['String']['input']>;
  gamePk?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
}>;


export type MediaPoliciesQuery = { __typename?: 'Query', mediaPolicies: Array<{ __typename?: 'MediaPolicy', id: string, mediaType: string, gamePk?: string | null, feedType?: string | null, feedSubType?: string | null, language?: string | null, contentDate?: string | null, viewingPolicies: Array<{ __typename?: 'ViewingPolicy', id: number, href: string, action: string, actionLabel: string, name: string, audienceHref: string }> }> };

export type AudiencesQueryVariables = Exact<{ [key: string]: never; }>;


export type AudiencesQuery = { __typename?: 'Query', audiences: Array<{ __typename?: 'Audience', href: string, authenticated: boolean, match: string, type: AudienceType, details?: Array<string> | null }> };

export type ViewingPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewingPoliciesQuery = { __typename?: 'Query', viewingPolicies: Array<{ __typename?: 'ViewingPolicy', id: number, href: string, action: string, actionLabel: string, name: string, audienceHref: string }> };

export type AudienceQueryVariables = Exact<{
  href: Scalars['String']['input'];
}>;


export type AudienceQuery = { __typename?: 'Query', audience?: { __typename?: 'Audience', href: string, authenticated: boolean, match: string, type: AudienceType, details?: Array<string> | null } | null };

export type EsniRulesQueryVariables = Exact<{
  status?: InputMaybe<EsniRuleStatus>;
  type?: InputMaybe<EsniRuleType>;
}>;


export type EsniRulesQuery = { __typename?: 'Query', esniRules: Array<{ __typename?: 'EsniRule', id: string, name: string, type: EsniRuleType, priority: number, query: string, status: EsniRuleStatus, actions: Array<{ __typename?: 'EsniRuleAction', actionType: ActionType, metadata: any }> }> };

export type TeamFieldsFragment = { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string };

export type CreateLocationOverrideMutationVariables = Exact<{
  oktaId: Scalars['String']['input'];
  ipAddress: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type CreateLocationOverrideMutation = { __typename?: 'Mutation', createLocationOverride?: { __typename?: 'LocationOverrideCreationResult', status: string } | null };

export type GetActiveLocationOverridesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveLocationOverridesQuery = { __typename?: 'Query', getActiveLocationOverrides: { __typename?: 'LocationOverridePageView', currentPage: number, totalPages: number, overrides: Array<{ __typename?: 'LocationOverrideView', oktaId: string, zipCode: string, ipAddress: string, countryCode: string, expiration: string, createdAt?: string | null }> } };

export type UserInfoQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserInfoQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', id: string, email: string, firstName?: string | null, lastName?: string | null } | null };

export type RouteMediaMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  routeType?: InputMaybe<RouteType>;
}>;


export type RouteMediaMutation = { __typename?: 'Mutation', routeMedia: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, reason?: string | null, success: boolean }> };

export type EndAdBreakMutationVariables = Exact<{
  mediaIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type EndAdBreakMutation = { __typename?: 'Mutation', endAdBreak: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, reason?: string | null, success: boolean }> };

export type SetSlateMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  slateCode: Scalars['String']['input'];
}>;


export type SetSlateMutation = { __typename?: 'Mutation', setSlate: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, reason?: string | null, success: boolean }> };

export type LiftSlateMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LiftSlateMutation = { __typename?: 'Mutation', liftSlate: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, reason?: string | null, success: boolean }> };

export type InsertAdBreakMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  durationSeconds: Scalars['Int']['input'];
  slateCode: Scalars['String']['input'];
  eventType?: InputMaybe<Scalars['String']['input']>;
  includeBuffer?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertAdBreakMutation = { __typename?: 'Mutation', insertAdBreak: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, reason?: string | null, success: boolean }> };

export type SyncPipelineRoutingMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SyncPipelineRoutingMutation = { __typename?: 'Mutation', syncPipelineRouting: Array<{ __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null }> };

export type AdEventTypesQueryVariables = Exact<{
  sport?: InputMaybe<Sport>;
}>;


export type AdEventTypesQuery = { __typename?: 'Query', adEventTypes: Array<{ __typename?: 'AdEventType', label: string, value: string }> };

export type LoggerScheduleQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<InputMaybe<Sport>> | InputMaybe<Sport>>;
}>;


export type LoggerScheduleQuery = { __typename?: 'Query', schedule: Array<{ __typename?: 'Game', gameDate: string, gamePk: number, status: GameStatus, away: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, home: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, venue: { __typename?: 'Venue', id: number, name: string }, pipelines: Array<{ __typename?: 'MediaPipeline', id: number, feedType: MediaFeedType, programSource: ProgramSource, status: PipelineStatus }>, feeds: Array<{ __typename?: 'Feed', feedType: MediaFeedType, preGameShow?: string | null, postGameShow: boolean }> }> };

export type LoggerGameQueryVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoggerGameQuery = { __typename?: 'Query', game?: { __typename?: 'Game', gamePk: number, status: GameStatus, away: { __typename?: 'Team', id: number, abbreviation: string }, home: { __typename?: 'Team', id: number, abbreviation: string }, feeds: Array<{ __typename?: 'Feed', feedType: MediaFeedType, postGameShow: boolean, preGameShow?: string | null }>, content: Array<{ __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, mediaId: string, mediaState: { __typename?: 'MediaConfiguration', mediaType: MediaType, state: MediaState } }>, pipelines: Array<{ __typename?: 'MediaPipeline', id: number, activeSlateCode?: string | null, adBreakDurationInSeconds?: number | null, adBreakStartedDateTime?: string | null, feedType: MediaFeedType, programSource: ProgramSource, status: PipelineStatus, sourceSystem: MediaSourceSystem, scheduledStartDateTime?: string | null, streamState: StreamState, resumedFromDateTime?: string | null, media: Array<{ __typename?: 'MediaContext', id: string, mediaType: MediaType, feedType: MediaFeedType, language: string }>, red5Config?: { __typename?: 'Red5Config', primaryHost?: string | null, primaryNodeGroup?: string | null, backupHost?: string | null, backupNodeGroup?: string | null, preProcStreamName?: string | null, postProcStreamName?: string | null } | null }> } | null };

export type SlatesQueryVariables = Exact<{
  sport?: InputMaybe<Sport>;
  type?: InputMaybe<SlateType>;
}>;


export type SlatesQuery = { __typename?: 'Query', slates: Array<{ __typename?: 'Slate', id: number, code: string, type: SlateType, description?: string | null, thumbnailUri?: string | null, sourceSystem: MediaSourceSystem }> };

export type ValidateLitmusSchemaMutationVariables = Exact<{
  validationProcess: Scalars['String']['input'];
  gamePk: Scalars['Int']['input'];
}>;


export type ValidateLitmusSchemaMutation = { __typename?: 'Mutation', validate?: { __typename?: 'ValidationResult', isValid: boolean, validationProcess: string, ruleResults: Array<{ __typename?: 'ValidationRuleResult', name: string, description: string, result: boolean } | null> } | null };

export type LitmusScheduleQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<InputMaybe<Sport>> | InputMaybe<Sport>>;
}>;


export type LitmusScheduleQuery = { __typename?: 'Query', schedule: Array<{ __typename?: 'Game', gameDate: string, gamePk: number, status: GameStatus, away: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, home: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, venue: { __typename?: 'Venue', id: number, name: string } }> };

export type ValidationSchemasQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidationSchemasQuery = { __typename?: 'Query', validationSchemas: Array<{ __typename?: 'ValidationSchema', validationProcess: string, rules: Array<{ __typename?: 'Rule', name: string, description: string } | null> }> };

export type AdjustMilestoneTimeMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  milestoneId: Scalars['String']['input'];
  timestamp: Scalars['String']['input'];
}>;


export type AdjustMilestoneTimeMutation = { __typename?: 'Mutation', adjustMilestoneTime?: { __typename?: 'Milestone', id: string, milestoneType: MilestoneType, title: string, absoluteTime: string, updatedBy: string, keywords: Array<{ __typename?: 'Keyword', name: string, value: any }> } | null };

export type DeleteMilestoneMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  milestoneId: Scalars['String']['input'];
}>;


export type DeleteMilestoneMutation = { __typename?: 'Mutation', deleteMilestone: boolean };

export type InsertMilestoneMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  milestoneInput: MilestoneInput;
}>;


export type InsertMilestoneMutation = { __typename?: 'Mutation', insertMilestone?: { __typename?: 'Milestone', id: string, title: string, milestoneType: MilestoneType, updatedBy: string, keywords: Array<{ __typename?: 'Keyword', name: string, value: any }> } | null };

export type InitiateTrimMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  newStartTime: Scalars['String']['input'];
  newEndTime: Scalars['String']['input'];
}>;


export type InitiateTrimMutation = { __typename?: 'Mutation', initiateTrim: { __typename?: 'MediaProcessingResult', mediaId: string, success: boolean, reason?: string | null } };

export type MilestonesScheduleQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<InputMaybe<Sport>> | InputMaybe<Sport>>;
}>;


export type MilestonesScheduleQuery = { __typename?: 'Query', schedule: Array<{ __typename?: 'Game', gameDate: string, gamePk: number, status: GameStatus, away: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, home: { __typename?: 'Team', id: number, name: string, shortName: string, abbreviation: string }, venue: { __typename?: 'Venue', id: number, name: string }, pipelines: Array<{ __typename?: 'MediaPipeline', id: number }>, content: Array<{ __typename?: 'Content', mediaId: string, mediaState: { __typename?: 'MediaConfiguration', state: MediaState } }> }> };

export type MilestonesGameQueryVariables = Exact<{
  gamePk: Scalars['Int']['input'];
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type MilestonesGameQuery = { __typename?: 'Query', game?: { __typename?: 'Game', gamePk: number, pipelines: Array<{ __typename?: 'MediaPipeline', id: number, streamState: StreamState, media: Array<{ __typename?: 'MediaContext', id: string }> }>, content: Array<{ __typename?: 'Content', callSign?: string | null, feedType: MediaFeedType, mediaId: string, mediaState: { __typename?: 'MediaConfiguration', mediaType: MediaType } }> } | null };

export type MilestoneSchemasQueryVariables = Exact<{ [key: string]: never; }>;


export type MilestoneSchemasQuery = { __typename?: 'Query', milestoneSchemas: Array<{ __typename?: 'MilestoneSchema', name: string, displayName: string, description: string, metadataFields: Array<{ __typename?: 'MetadataFieldDefinition', name: string, displayName: string, description: string, type: string }> }> };

export type MilestonesQueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
}>;


export type MilestonesQuery = { __typename?: 'Query', milestones?: Array<{ __typename?: 'Milestone', id: string, milestoneType: MilestoneType, absoluteTime: string, title: string, updatedBy: string, keywords: Array<{ __typename?: 'Keyword', name: string, value: any }> }> | null };

export type GeneratePlaybackUrlsMutationVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GeneratePlaybackUrlsMutation = { __typename?: 'Mutation', generatePlaybackUrls?: Array<{ __typename?: 'PlaybackInfo', playbacks: Array<{ __typename?: 'Playback', url: string, cdn?: string | null, token?: string | null, expiration?: string | null, adsEnabled: boolean, adExperienceType: AdExperienceType, priority: number, features?: Array<string | null> | null, adEngineIdentifiers: Array<{ __typename?: 'AdEngineIdentifier', name: string, value: string }> }> }> | null };

export type AssignTargetsMutationVariables = Exact<{
  targetChanges: Array<TargetChangeInput> | TargetChangeInput;
}>;


export type AssignTargetsMutation = { __typename?: 'Mutation', assignTargets: Array<{ __typename?: 'UpdateTargetResult', success: boolean, reason?: string | null, channelId?: number | null, target: { __typename?: 'TargetIdentifier', id: number, type: string } }> };

export type CreatePlaybackOverrideMutationVariables = Exact<{
  experience: PlaybackExperience;
  features: Array<PlaybackFeature> | PlaybackFeature;
  matchParams: Scalars['JSON']['input'];
}>;


export type CreatePlaybackOverrideMutation = { __typename?: 'Mutation', createPlaybackOverride?: boolean | null };

export type UpdatePlaybackOverrideMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  experience: PlaybackExperience;
  features: Array<PlaybackFeature> | PlaybackFeature;
  matchParams: Scalars['JSON']['input'];
}>;


export type UpdatePlaybackOverrideMutation = { __typename?: 'Mutation', updatePlaybackOverride?: boolean | null };

export type DeletePlaybackOverrideMutationVariables = Exact<{
  overrideId: Scalars['Int']['input'];
}>;


export type DeletePlaybackOverrideMutation = { __typename?: 'Mutation', deletePlaybackOverride?: boolean | null };

export type PlaybackOverridesQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaybackOverridesQuery = { __typename?: 'Query', playbackOverrides: Array<{ __typename?: 'ExperienceOverrideSearchView', id: string, experience: string, features: Array<string>, matchParams: any }> };

export type AllOverridesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllOverridesQuery = { __typename?: 'Query', sessionOverrides: Array<{ __typename?: 'ExperienceOverrideSearchView', id: string, features: Array<string>, matchParams: any }>, playbackOverrides: Array<{ __typename?: 'ExperienceOverrideSearchView', id: string, experience: string, features: Array<string>, matchParams: any }> };

export type CreateSessionOverrideMutationVariables = Exact<{
  features: Array<SessionFeature> | SessionFeature;
  matchParams: Scalars['JSON']['input'];
}>;


export type CreateSessionOverrideMutation = { __typename?: 'Mutation', createSessionOverride?: boolean | null };

export type UpdateSessionOverrideMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  features: Array<SessionFeature> | SessionFeature;
  matchParams: Scalars['JSON']['input'];
}>;


export type UpdateSessionOverrideMutation = { __typename?: 'Mutation', updateSessionOverride?: boolean | null };

export type DeleteSessionOverrideMutationVariables = Exact<{
  overrideId: Scalars['Int']['input'];
}>;


export type DeleteSessionOverrideMutation = { __typename?: 'Mutation', deleteSessionOverride?: boolean | null };

export type SessionOverridesQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionOverridesQuery = { __typename?: 'Query', sessionOverrides: Array<{ __typename?: 'ExperienceOverrideSearchView', id: string, features: Array<string>, matchParams: any }> };

export type PipelineConfigFieldsFragment = { __typename?: 'PipelineConfigInfo', activeSource?: ProgramSource | null, altaChannelUrl?: string | null, backhaulDecoderHost?: string | null, backhaulDecoderServiceLabel?: string | null, eviProgramSwitchSrc?: number | null, eviSdpUrlAudio?: string | null, eviSdpUrlVideo?: string | null, eviSwitchDst?: number | null, fronthaulDecoderHost?: string | null, fronthaulDecoderServiceLabel?: string | null, id: number, lexiInstanceUrl?: string | null, videonPrimaryStreamUrl?: string | null, videonBackupStreamUrl?: string | null, partnerLockEnabled?: boolean | null, partnerLockExclusions?: Array<string | null> | null, pd01Dst?: number | null, pd02Dst?: number | null, pd03Dst?: number | null, postGameSrc?: number | null, preGameSrc?: number | null, primaryBackhaulSrc?: number | null, primaryFronthaulSrc?: number | null, programSwitchDst?: number | null, programSwitchSrc?: number | null, sdpUrlAncillary?: string | null, sdpUrlAudio?: string | null, sdpUrlVideo?: string | null, teamId?: number | null, red5PreProcStreamName?: string | null, red5PostProcStreamName?: string | null, red5PrimaryHost?: string | null, red5BackupHost?: string | null, red5PrimaryNodeGroup?: string | null, red5BackupNodeGroup?: string | null };

export type UpdatePipelineConfigMutationVariables = Exact<{
  teamId: Scalars['Int']['input'];
  pipelineConfig: PipelineConfig;
}>;


export type UpdatePipelineConfigMutation = { __typename?: 'Mutation', updatePipelineConfig?: { __typename?: 'PipelineConfigInfo', activeSource?: ProgramSource | null, altaChannelUrl?: string | null, backhaulDecoderHost?: string | null, backhaulDecoderServiceLabel?: string | null, eviProgramSwitchSrc?: number | null, eviSdpUrlAudio?: string | null, eviSdpUrlVideo?: string | null, eviSwitchDst?: number | null, fronthaulDecoderHost?: string | null, fronthaulDecoderServiceLabel?: string | null, id: number, lexiInstanceUrl?: string | null, videonPrimaryStreamUrl?: string | null, videonBackupStreamUrl?: string | null, partnerLockEnabled?: boolean | null, partnerLockExclusions?: Array<string | null> | null, pd01Dst?: number | null, pd02Dst?: number | null, pd03Dst?: number | null, postGameSrc?: number | null, preGameSrc?: number | null, primaryBackhaulSrc?: number | null, primaryFronthaulSrc?: number | null, programSwitchDst?: number | null, programSwitchSrc?: number | null, sdpUrlAncillary?: string | null, sdpUrlAudio?: string | null, sdpUrlVideo?: string | null, teamId?: number | null, red5PreProcStreamName?: string | null, red5PostProcStreamName?: string | null, red5PrimaryHost?: string | null, red5BackupHost?: string | null, red5PrimaryNodeGroup?: string | null, red5BackupNodeGroup?: string | null } | null };

export type GetPipelineConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPipelineConfigsQuery = { __typename?: 'Query', pipelineConfigs: Array<{ __typename?: 'PipelineConfigInfo', activeSource?: ProgramSource | null, altaChannelUrl?: string | null, backhaulDecoderHost?: string | null, backhaulDecoderServiceLabel?: string | null, eviProgramSwitchSrc?: number | null, eviSdpUrlAudio?: string | null, eviSdpUrlVideo?: string | null, eviSwitchDst?: number | null, fronthaulDecoderHost?: string | null, fronthaulDecoderServiceLabel?: string | null, id: number, lexiInstanceUrl?: string | null, videonPrimaryStreamUrl?: string | null, videonBackupStreamUrl?: string | null, partnerLockEnabled?: boolean | null, partnerLockExclusions?: Array<string | null> | null, pd01Dst?: number | null, pd02Dst?: number | null, pd03Dst?: number | null, postGameSrc?: number | null, preGameSrc?: number | null, primaryBackhaulSrc?: number | null, primaryFronthaulSrc?: number | null, programSwitchDst?: number | null, programSwitchSrc?: number | null, sdpUrlAncillary?: string | null, sdpUrlAudio?: string | null, sdpUrlVideo?: string | null, teamId?: number | null, red5PreProcStreamName?: string | null, red5PostProcStreamName?: string | null, red5PrimaryHost?: string | null, red5BackupHost?: string | null, red5PrimaryNodeGroup?: string | null, red5BackupNodeGroup?: string | null }> };

export type UpdatePipelineInputConfigMutationVariables = Exact<{
  venueId: Scalars['Int']['input'];
  feedType: MediaFeedType;
  pipelineInputConfig?: InputMaybe<PipelineInputConfig>;
}>;


export type UpdatePipelineInputConfigMutation = { __typename?: 'Mutation', updatePipelineInputConfig?: { __typename?: 'PipelineInputConfigInfo', venueId?: number | null, feedTypeCode?: string | null, id: number, inputLabel?: string | null, category?: string | null } | null };

export type PipelineInputConfigsQueryVariables = Exact<{
  venueId: Scalars['Int']['input'];
}>;


export type PipelineInputConfigsQuery = { __typename?: 'Query', pipelineInputConfigs: Array<{ __typename?: 'PipelineInputConfigInfo', id: number, venueId?: number | null, feedTypeCode?: string | null, inputLabel?: string | null, category?: string | null }> };

export type AssignDevPipelineConfigMutationVariables = Exact<{
  teamId: Scalars['Int']['input'];
  pipelineId: Scalars['Int']['input'];
}>;


export type AssignDevPipelineConfigMutation = { __typename?: 'Mutation', assignDevPipelineConfig?: boolean | null };

export type BorrowPipelineMutationVariables = Exact<{
  teamId: Scalars['Int']['input'];
}>;


export type BorrowPipelineMutation = { __typename?: 'Mutation', borrowPipeline?: boolean | null };

export type ReturnPipelineMutationVariables = Exact<{
  teamId: Scalars['Int']['input'];
}>;


export type ReturnPipelineMutation = { __typename?: 'Mutation', returnPipeline?: boolean | null };

export type PipelineMonitorsQueryVariables = Exact<{ [key: string]: never; }>;


export type PipelineMonitorsQuery = { __typename?: 'Query', pipelineMonitors: Array<{ __typename?: 'PipelineMonitor', pipelineConfig?: { __typename?: 'PipelineConfigInfo', fronthaulDecoderServiceLabel?: string | null, id: number, teamId?: number | null } | null, eventPipeline?: { __typename?: 'PipelineMonitorEventPipelineInfo', status?: PipelineStatus | null } | null }> };

export type GetPartnerMappingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerMappingQuery = { __typename?: 'Query', getAllChannels: Array<{ __typename?: 'DataCenter', name: string, channels: Array<{ __typename?: 'Channel', id: number, name: string }> }>, getAllTargets: Array<{ __typename?: 'PartnerView', name: string, targets: Array<{ __typename?: 'TargetView', id: number, name: string, status: string, type: string }> }> };

export type GetChannelQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetChannelQuery = { __typename?: 'Query', getChannel?: { __typename?: 'Channel', id: number, name: string, targets: Array<{ __typename?: 'TargetIdentifier', id: number, type: string }> } | null };

export type GetTargetQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetTargetQuery = { __typename?: 'Query', getTarget?: { __typename?: 'TargetView', id: number, name: string, status: string, type: string, channelId?: number | null } | null };

export type MediaUpdatesSubscriptionVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MediaUpdatesSubscription = { __typename?: 'Subscription', mediaUpdates: { __typename?: 'Media', pipelines: Array<{ __typename?: 'MediaPipeline', id: number, activeSlateCode?: string | null, feedType: MediaFeedType, status: PipelineStatus, sourceSystem: MediaSourceSystem, scheduledStartDateTime?: string | null, streamState: StreamState, resumedFromDateTime?: string | null, eviStatus: PipelineEviStatus, eviPod?: { __typename?: 'EviPodInfo', active: boolean, vendor: string, id: number, name: string } | null, media: Array<{ __typename?: 'MediaContext', id: string, mediaType: MediaType, feedType: MediaFeedType }>, alerts: Array<{ __typename?: 'PipelineAlert', active?: boolean | null, clearedDateTime?: string | null, createdDateTime: string, id: number, message: string }> }> } };

export type UserIdQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserIdQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', id: string } | null };

export type UserDataQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserDataQuery = { __typename?: 'Query', userData: { __typename?: 'UserData', userId: string, entitlements: Array<string>, cachedEntitlements?: Array<string> | null, profile: { __typename?: 'Profile', favoriteTeam?: number | null, doNotSell?: boolean | null, email?: string | null, firstName?: string | null, lastName?: string | null }, cachedProfile?: { __typename?: 'CachedProfile', favoriteTeam?: number | null, doNotSell?: boolean | null } | null, sessions?: { __typename?: 'PaginatedSessions', totalCount: number, sessions: Array<{ __typename?: 'Session', sessionId: string, initTime: string, expireDate: string, experience: string, features: Array<string>, location: { __typename?: 'Location', zip: string, country: string, latitude: number, longitude: number, designatedMarketArea: string, locationProvider: string }, playbackSessions: Array<{ __typename?: 'PlaybackSession', playbackSessionId: string, createTime: string, countsForCap: boolean, mediaId: string, entitlements: Array<string>, playbackStatus: string, contentExperience: string, features: Array<string> }>, device: { __typename?: 'Device', id: string, os: string, version: string, platform: string, ipAddress: string, userAgent: string, applicationRuntime: string, language: string, profile: string, manufacturer: string, model: string, extraAttributes: string, appVersion: string } }> } | null } };

export type PlaybackOverrideFragment = { __typename?: 'ExperienceOverrideSearchView', id: string, features: Array<string>, matchParams: any, experience: string };

export type SessionOverrideFragment = { __typename?: 'ExperienceOverrideSearchView', id: string, features: Array<string>, matchParams: any };

export const BtcPipelineMediaUpdateFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCPipelineMediaUpdateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPipeline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSlateCode"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"resumedFromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"eviStatus"}},{"kind":"Field","name":{"kind":"Name","value":"eviPod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alerts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"clearedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<BtcPipelineMediaUpdateFieldsFragment, unknown>;
export const BtcContentAssetsFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCContentAssetsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adStatus"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"cdn"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"playback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"cdn"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"adsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"adExperienceType"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"adEngineIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<BtcContentAssetsFieldsFragment, unknown>;
export const TeamFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]} as unknown as DocumentNode<TeamFieldsFragment, unknown>;
export const BtcBroadcastFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCBroadcastFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"}},{"kind":"Field","name":{"kind":"Name","value":"availableForStreaming"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"colorSpace"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"freeGameStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"freeGameType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"mvpdRequired"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"videoResolution"}}]}}]} as unknown as DocumentNode<BtcBroadcastFieldsFragment, unknown>;
export const BtcContentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCContentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<BtcContentFieldsFragment, unknown>;
export const BtcPipelineFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCPipelineFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPipeline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSlateCode"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"programSource"}},{"kind":"Field","name":{"kind":"Name","value":"pregameSource"}},{"kind":"Field","name":{"kind":"Name","value":"gameSource"}},{"kind":"Field","name":{"kind":"Name","value":"postgameSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"resumedFromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"eviStatus"}},{"kind":"Field","name":{"kind":"Name","value":"eviPod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alerts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"clearedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<BtcPipelineFieldsFragment, unknown>;
export const BtcGameFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCGameFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Game"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureType"}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"broadcasts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCBroadcastFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCContentFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCPipelineFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCBroadcastFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"}},{"kind":"Field","name":{"kind":"Name","value":"availableForStreaming"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"colorSpace"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"freeGameStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"freeGameType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"mvpdRequired"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"videoResolution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCContentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCPipelineFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPipeline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSlateCode"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"programSource"}},{"kind":"Field","name":{"kind":"Name","value":"pregameSource"}},{"kind":"Field","name":{"kind":"Name","value":"gameSource"}},{"kind":"Field","name":{"kind":"Name","value":"postgameSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"resumedFromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"eviStatus"}},{"kind":"Field","name":{"kind":"Name","value":"eviPod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alerts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"clearedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<BtcGameFieldsFragment, unknown>;
export const MulticastMappingFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MulticastMappingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineMulticastMapping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLocation"}},{"kind":"Field","name":{"kind":"Name","value":"multicastAddress"}},{"kind":"Field","name":{"kind":"Name","value":"hdrMulticastAddress"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]} as unknown as DocumentNode<MulticastMappingFieldsFragment, unknown>;
export const CopyrightStreamFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CopyrightStreamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopyrightStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"homeTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"awayTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleDate"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"gameStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamEndTime"}}]}}]} as unknown as DocumentNode<CopyrightStreamFieldsFragment, unknown>;
export const MediaPolicyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MediaPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"feedSubType"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"contentDate"}}]}}]} as unknown as DocumentNode<MediaPolicyFieldsFragment, unknown>;
export const ViewingPolicyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewingPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewingPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"audienceHref"}}]}}]} as unknown as DocumentNode<ViewingPolicyFieldsFragment, unknown>;
export const EsniRuleFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EsniRuleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EsniRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"query"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<EsniRuleFieldsFragment, unknown>;
export const EsniMediaProcessingResultFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EsniMediaProcessingResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EsniMediaProcessingResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"}}]}}]} as unknown as DocumentNode<EsniMediaProcessingResultFieldsFragment, unknown>;
export const PipelineConfigFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineConfigFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineConfigInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeSource"}},{"kind":"Field","name":{"kind":"Name","value":"altaChannelUrl"}},{"kind":"Field","name":{"kind":"Name","value":"backhaulDecoderHost"}},{"kind":"Field","name":{"kind":"Name","value":"backhaulDecoderServiceLabel"}},{"kind":"Field","name":{"kind":"Name","value":"eviProgramSwitchSrc"}},{"kind":"Field","name":{"kind":"Name","value":"eviSdpUrlAudio"}},{"kind":"Field","name":{"kind":"Name","value":"eviSdpUrlVideo"}},{"kind":"Field","name":{"kind":"Name","value":"eviSwitchDst"}},{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderHost"}},{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderServiceLabel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lexiInstanceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videonPrimaryStreamUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videonBackupStreamUrl"}},{"kind":"Field","name":{"kind":"Name","value":"partnerLockEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"partnerLockExclusions"}},{"kind":"Field","name":{"kind":"Name","value":"pd01Dst"}},{"kind":"Field","name":{"kind":"Name","value":"pd02Dst"}},{"kind":"Field","name":{"kind":"Name","value":"pd03Dst"}},{"kind":"Field","name":{"kind":"Name","value":"postGameSrc"}},{"kind":"Field","name":{"kind":"Name","value":"preGameSrc"}},{"kind":"Field","name":{"kind":"Name","value":"primaryBackhaulSrc"}},{"kind":"Field","name":{"kind":"Name","value":"primaryFronthaulSrc"}},{"kind":"Field","name":{"kind":"Name","value":"programSwitchDst"}},{"kind":"Field","name":{"kind":"Name","value":"programSwitchSrc"}},{"kind":"Field","name":{"kind":"Name","value":"sdpUrlAncillary"}},{"kind":"Field","name":{"kind":"Name","value":"sdpUrlAudio"}},{"kind":"Field","name":{"kind":"Name","value":"sdpUrlVideo"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"red5PreProcStreamName"}},{"kind":"Field","name":{"kind":"Name","value":"red5PostProcStreamName"}},{"kind":"Field","name":{"kind":"Name","value":"red5PrimaryHost"}},{"kind":"Field","name":{"kind":"Name","value":"red5BackupHost"}},{"kind":"Field","name":{"kind":"Name","value":"red5PrimaryNodeGroup"}},{"kind":"Field","name":{"kind":"Name","value":"red5BackupNodeGroup"}}]}}]} as unknown as DocumentNode<PipelineConfigFieldsFragment, unknown>;
export const PlaybackOverrideFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlaybackOverride"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceOverrideSearchView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"matchParams"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}}]}}]} as unknown as DocumentNode<PlaybackOverrideFragment, unknown>;
export const SessionOverrideFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionOverride"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceOverrideSearchView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"matchParams"}}]}}]} as unknown as DocumentNode<SessionOverrideFragment, unknown>;
export const ScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"schedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Sport"}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MLB"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"programSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"resumedFromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"pregameSource"}},{"kind":"Field","name":{"kind":"Name","value":"postgameSource"}},{"kind":"Field","name":{"kind":"Name","value":"gameSource"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]} as unknown as DocumentNode<ScheduleQuery, ScheduleQueryVariables>;
export const AuditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"audits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceSystems"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instigator"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tag"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceTagInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceSystems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceSystems"}}},{"kind":"Argument","name":{"kind":"Name","value":"operations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operations"}}},{"kind":"Argument","name":{"kind":"Name","value":"instigator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instigator"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"tag"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tag"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"operation"}},{"kind":"Field","name":{"kind":"Name","value":"instigator"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"traceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<AuditsQuery, AuditsQueryVariables>;
export const AuditSourceSystemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"auditSourceSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditSourceSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"operations"}}]}}]}}]} as unknown as DocumentNode<AuditSourceSystemsQuery, AuditSourceSystemsQueryVariables>;
export const ProvisionMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"provisionMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provisionMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<ProvisionMediaMutation, ProvisionMediaMutationVariables>;
export const UnscheduleMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unscheduleMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unscheduleMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<UnscheduleMediaMutation, UnscheduleMediaMutationVariables>;
export const StartMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<StartMediaMutation, StartMediaMutationVariables>;
export const StopMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stopMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<StopMediaMutation, StopMediaMutationVariables>;
export const ArchiveMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"archiveMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ArchiveMediaMutation, ArchiveMediaMutationVariables>;
export const ResolveAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resolveAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alertId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveAlert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"alertId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alertId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<ResolveAlertMutation, ResolveAlertMutationVariables>;
export const SetEviStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setEviStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineEviStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setEviStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<SetEviStatusMutation, SetEviStatusMutationVariables>;
export const SyncMediaContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"syncMediaContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncMediaContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}}]}]}}]} as unknown as DocumentNode<SyncMediaContentMutation, SyncMediaContentMutationVariables>;
export const UpdatePipelineMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePipelineMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePipelineMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<UpdatePipelineMediaMutation, UpdatePipelineMediaMutationVariables>;
export const UpdateAssetsStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssetsState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaAssets"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MediaAssetsInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetState"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetState"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssetsState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaAssets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaAssets"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetState"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetState"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetsStateMutation, UpdateAssetsStateMutationVariables>;
export const ActivateAdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"activateAds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateAds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"videoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}}}]}]}}]} as unknown as DocumentNode<ActivateAdsMutation, ActivateAdsMutationVariables>;
export const PauseAdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pauseAds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pauseAds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"videoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}}}]}]}}]} as unknown as DocumentNode<PauseAdsMutation, PauseAdsMutationVariables>;
export const CreateMulticastMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMulticastMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priority"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceLocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"multicastAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hdrMulticastAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMulticastMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callSign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}}},{"kind":"Argument","name":{"kind":"Name","value":"priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priority"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceLocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLocation"}}},{"kind":"Argument","name":{"kind":"Name","value":"multicastAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"multicastAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"hdrMulticastAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hdrMulticastAddress"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MulticastMappingFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MulticastMappingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineMulticastMapping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLocation"}},{"kind":"Field","name":{"kind":"Name","value":"multicastAddress"}},{"kind":"Field","name":{"kind":"Name","value":"hdrMulticastAddress"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]} as unknown as DocumentNode<CreateMulticastMappingMutation, CreateMulticastMappingMutationVariables>;
export const UpdateMulticastMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMulticastMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedMapping"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MulticastMappingUpdateRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMulticastMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"updatedMapping"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedMapping"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MulticastMappingFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MulticastMappingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineMulticastMapping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLocation"}},{"kind":"Field","name":{"kind":"Name","value":"multicastAddress"}},{"kind":"Field","name":{"kind":"Name","value":"hdrMulticastAddress"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]} as unknown as DocumentNode<UpdateMulticastMappingMutation, UpdateMulticastMappingMutationVariables>;
export const DeleteMulticastMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteMulticastMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMulticastMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteMulticastMappingMutation, DeleteMulticastMappingMutationVariables>;
export const AssignEviPodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignEviPod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eviPodName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignEviPod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eviPodName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eviPodName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<AssignEviPodMutation, AssignEviPodMutationVariables>;
export const ProvisionCopyrightStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"provisionCopyrightStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stream"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CopyrightStreamProvision"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provisionCopyrightStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stream"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stream"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CopyrightStreamFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CopyrightStreamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopyrightStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"homeTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"awayTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleDate"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"gameStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamEndTime"}}]}}]} as unknown as DocumentNode<ProvisionCopyrightStreamMutation, ProvisionCopyrightStreamMutationVariables>;
export const StartCopyrightStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startCopyrightStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"streamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCopyrightStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"streamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"streamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CopyrightStreamFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CopyrightStreamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopyrightStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"homeTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"awayTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleDate"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"gameStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamEndTime"}}]}}]} as unknown as DocumentNode<StartCopyrightStreamMutation, StartCopyrightStreamMutationVariables>;
export const StopCopyrightStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stopCopyrightStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"streamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopCopyrightStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"streamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"streamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CopyrightStreamFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CopyrightStreamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopyrightStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"homeTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"awayTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleDate"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"gameStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamEndTime"}}]}}]} as unknown as DocumentNode<StopCopyrightStreamMutation, StopCopyrightStreamMutationVariables>;
export const DeleteCopyrightStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCopyrightStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"streamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCopyrightStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"streamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"streamId"}}}]}]}}]} as unknown as DocumentNode<DeleteCopyrightStreamMutation, DeleteCopyrightStreamMutationVariables>;
export const UpdateCdnStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCdnStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cdn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Cdn"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCdnStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cdn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cdn"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}]}]}}]} as unknown as DocumentNode<UpdateCdnStatusMutation, UpdateCdnStatusMutationVariables>;
export const UpdateBroadcastDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBroadcast"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaState"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MediaState"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"freeGameStatuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FreeGameStatusInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availableForStreaming"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoResolution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VideoResolution"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorSpace"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VideoColorSpace"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mvpdRequired"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBroadcast"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mediaState"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaState"}}},{"kind":"Argument","name":{"kind":"Name","value":"freeGameStatuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"freeGameStatuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"availableForStreaming"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableForStreaming"}}},{"kind":"Argument","name":{"kind":"Name","value":"videoResolution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoResolution"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorSpace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorSpace"}}},{"kind":"Argument","name":{"kind":"Name","value":"mvpdRequired"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mvpdRequired"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<UpdateBroadcastMutation, UpdateBroadcastMutationVariables>;
export const UpdateBroadcastSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBroadcastSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MediaFeedType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceUpdateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BroadcastSourceUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBroadcastSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"feedType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedType"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceUpdateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceUpdateInput"}}}]}]}}]} as unknown as DocumentNode<UpdateBroadcastSourceMutation, UpdateBroadcastSourceMutationVariables>;
export const SwitchProgramSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"switchProgramSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programSource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramSource"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"switchProgramSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"programSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programSource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<SwitchProgramSourceMutation, SwitchProgramSourceMutationVariables>;
export const CreateBroadcastSourceOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBroadcastSourceOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broadcastSourceOverrideInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BroadcastSourceOverrideInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBroadcastSourceOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"broadcastSourceOverrideInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broadcastSourceOverrideInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"pregameSource"}},{"kind":"Field","name":{"kind":"Name","value":"gameSource"}},{"kind":"Field","name":{"kind":"Name","value":"postgameSource"}}]}}]}}]} as unknown as DocumentNode<CreateBroadcastSourceOverrideMutation, CreateBroadcastSourceOverrideMutationVariables>;
export const DeleteBroadcastSourceOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteBroadcastSourceOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBroadcastSourceOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteBroadcastSourceOverrideMutation, DeleteBroadcastSourceOverrideMutationVariables>;
export const UpdateBroadcastSourceOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBroadcastSourceOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broadcastSourceOverrideInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BroadcastSourceOverrideInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBroadcastSourceOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"broadcastSourceOverrideInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broadcastSourceOverrideInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"pregameSource"}},{"kind":"Field","name":{"kind":"Name","value":"postgameSource"}},{"kind":"Field","name":{"kind":"Name","value":"gameSource"}}]}}]}}]} as unknown as DocumentNode<UpdateBroadcastSourceOverrideMutation, UpdateBroadcastSourceOverrideMutationVariables>;
export const CreateBroadcastOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBroadcastOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedTypeCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fronthaulDecoderInputLabel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"multicastAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBroadcastOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"feedTypeCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedTypeCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"region"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region"}}},{"kind":"Argument","name":{"kind":"Name","value":"callSign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}}},{"kind":"Argument","name":{"kind":"Name","value":"fronthaulDecoderInputLabel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fronthaulDecoderInputLabel"}}},{"kind":"Argument","name":{"kind":"Name","value":"multicastAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"multicastAddress"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderInputLabel"}},{"kind":"Field","name":{"kind":"Name","value":"multicastAddress"}}]}}]}}]} as unknown as DocumentNode<CreateBroadcastOverrideMutation, CreateBroadcastOverrideMutationVariables>;
export const UpdateBroadcastOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBroadcastOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedBroadcastOverride"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BroadcastOverrideUpdateRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBroadcastOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"region"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region"}}},{"kind":"Argument","name":{"kind":"Name","value":"updatedBroadcastOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedBroadcastOverride"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderInputLabel"}},{"kind":"Field","name":{"kind":"Name","value":"multicastAddress"}}]}}]}}]} as unknown as DocumentNode<UpdateBroadcastOverrideMutation, UpdateBroadcastOverrideMutationVariables>;
export const DeleteBroadcastOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteBroadcastOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBroadcastOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"region"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region"}}}]}]}}]} as unknown as DocumentNode<DeleteBroadcastOverrideMutation, DeleteBroadcastOverrideMutationVariables>;
export const UpdatePartnerDistributionLockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePartnerDistributionLock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setLock"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePartnerDistributionLock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"setLock"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setLock"}}}]}]}}]} as unknown as DocumentNode<UpdatePartnerDistributionLockMutation, UpdatePartnerDistributionLockMutationVariables>;
export const ToggleSkyviewConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"toggleSkyviewConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleSkyviewConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<ToggleSkyviewConfigMutation, ToggleSkyviewConfigMutationVariables>;
export const ToggleAllSkyviewConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"toggleAllSkyviewConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleAllSkyviewConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}]}]}}]} as unknown as DocumentNode<ToggleAllSkyviewConfigsMutation, ToggleAllSkyviewConfigsMutationVariables>;
export const IngestAssetsIntoDaiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ingestAssetsIntoDai"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ingestAssetsIntoDai"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetIds"}}}]}]}}]} as unknown as DocumentNode<IngestAssetsIntoDaiMutation, IngestAssetsIntoDaiMutationVariables>;
export const BtcScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"btcSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Sport"}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MLB"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCGameFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCBroadcastFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"}},{"kind":"Field","name":{"kind":"Name","value":"availableForStreaming"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"colorSpace"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"freeGameStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"freeGameType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"mvpdRequired"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"videoResolution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCContentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCPipelineFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPipeline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSlateCode"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"programSource"}},{"kind":"Field","name":{"kind":"Name","value":"pregameSource"}},{"kind":"Field","name":{"kind":"Name","value":"gameSource"}},{"kind":"Field","name":{"kind":"Name","value":"postgameSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"resumedFromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"eviStatus"}},{"kind":"Field","name":{"kind":"Name","value":"eviPod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alerts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"clearedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCGameFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Game"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureType"}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"broadcasts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCBroadcastFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCContentFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCPipelineFields"}}]}}]}}]} as unknown as DocumentNode<BtcScheduleQuery, BtcScheduleQueryVariables>;
export const BtcGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"btcGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduleDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCGameFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCBroadcastFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"}},{"kind":"Field","name":{"kind":"Name","value":"availableForStreaming"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"colorSpace"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"freeGameStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"freeGameType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"mvpdRequired"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"videoResolution"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCContentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCPipelineFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPipeline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSlateCode"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"programSource"}},{"kind":"Field","name":{"kind":"Name","value":"pregameSource"}},{"kind":"Field","name":{"kind":"Name","value":"gameSource"}},{"kind":"Field","name":{"kind":"Name","value":"postgameSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"resumedFromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"eviStatus"}},{"kind":"Field","name":{"kind":"Name","value":"eviPod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alerts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"clearedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCGameFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Game"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureType"}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"broadcasts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCBroadcastFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCContentFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCPipelineFields"}}]}}]}}]} as unknown as DocumentNode<BtcGameQuery, BtcGameQueryVariables>;
export const BtcGamePipelinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"btcGamePipelines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduleDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCPipelineFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCPipelineFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPipeline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSlateCode"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"programSource"}},{"kind":"Field","name":{"kind":"Name","value":"pregameSource"}},{"kind":"Field","name":{"kind":"Name","value":"gameSource"}},{"kind":"Field","name":{"kind":"Name","value":"postgameSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"resumedFromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"eviStatus"}},{"kind":"Field","name":{"kind":"Name","value":"eviPod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alerts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"clearedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<BtcGamePipelinesQuery, BtcGamePipelinesQueryVariables>;
export const BtcGameContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"btcGameContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduleDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCContentFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCContentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<BtcGameContentQuery, BtcGameContentQueryVariables>;
export const BtcGameContentWithAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"btcGameContentWithAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduleDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCContentAssetsFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCContentAssetsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adStatus"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"cdn"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"playback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"cdn"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"adsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"adExperienceType"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"adEngineIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<BtcGameContentWithAssetsQuery, BtcGameContentWithAssetsQueryVariables>;
export const SearchMulticastMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchMulticastMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceLocations"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchMulticastMappings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callSign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}}},{"kind":"Argument","name":{"kind":"Name","value":"priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priority"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceLocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLocations"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MulticastMappingFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MulticastMappingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineMulticastMapping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLocation"}},{"kind":"Field","name":{"kind":"Name","value":"multicastAddress"}},{"kind":"Field","name":{"kind":"Name","value":"hdrMulticastAddress"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]} as unknown as DocumentNode<SearchMulticastMappingQuery, SearchMulticastMappingQueryVariables>;
export const EviPodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"eviPods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eviPods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<EviPodsQuery, EviPodsQueryVariables>;
export const CopyrightStreamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"copyrightStreams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyrightStreams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduleDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CopyrightStreamFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CopyrightStreamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopyrightStream"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"homeTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"awayTriCode"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleDate"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"gameStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamEndTime"}}]}}]} as unknown as DocumentNode<CopyrightStreamsQuery, CopyrightStreamsQueryVariables>;
export const PlaybackCdnsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"playbackCdns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playbackCdns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdn"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<PlaybackCdnsQuery, PlaybackCdnsQueryVariables>;
export const BroadcastSourceOverridesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"broadcastSourceOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastSourceOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"pregameSource"}},{"kind":"Field","name":{"kind":"Name","value":"gameSource"}},{"kind":"Field","name":{"kind":"Name","value":"postgameSource"}}]}}]}}]} as unknown as DocumentNode<BroadcastSourceOverridesQuery, BroadcastSourceOverridesQueryVariables>;
export const BroadcastAcquisitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"broadcastAcquisitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedTypeCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastAcquisitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"feedTypeCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedTypeCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"defaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decoderInputLabel"}},{"kind":"Field","name":{"kind":"Name","value":"multicastAddress"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderInputLabel"}},{"kind":"Field","name":{"kind":"Name","value":"multicastAddress"}}]}}]}}]}}]} as unknown as DocumentNode<BroadcastAcquisitionsQuery, BroadcastAcquisitionsQueryVariables>;
export const SearchZixiSourcesByTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchZixiSourcesByTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchZixiSourcesByTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"Argument","name":{"kind":"Name","value":"destination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destination"}}},{"kind":"Argument","name":{"kind":"Name","value":"activeSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeSource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zixiSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"destination"}},{"kind":"Field","name":{"kind":"Name","value":"activeSource"}}]}}]}}]} as unknown as DocumentNode<SearchZixiSourcesByTeamQuery, SearchZixiSourcesByTeamQueryVariables>;
export const SkyviewConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"skyviewConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skyviewConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<SkyviewConfigsQuery, SkyviewConfigsQueryVariables>;
export const UpdateAudienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAudience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"href"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audience"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AudienceUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAudience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"href"},"value":{"kind":"Variable","name":{"kind":"Name","value":"href"}}},{"kind":"Argument","name":{"kind":"Name","value":"audience"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audience"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"authenticated"}},{"kind":"Field","name":{"kind":"Name","value":"match"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAudienceMutation, UpdateAudienceMutationVariables>;
export const CreatePolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"policy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PolicyCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"policy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"policy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewingPolicyFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewingPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewingPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"audienceHref"}}]}}]} as unknown as DocumentNode<CreatePolicyMutation, CreatePolicyMutationVariables>;
export const UpdatePolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"href"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"policy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PolicyUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"href"},"value":{"kind":"Variable","name":{"kind":"Name","value":"href"}}},{"kind":"Argument","name":{"kind":"Name","value":"policy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"policy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewingPolicyFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewingPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewingPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"audienceHref"}}]}}]} as unknown as DocumentNode<UpdatePolicyMutation, UpdatePolicyMutationVariables>;
export const UpsertMediaPoliciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertMediaPolicies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"media"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertMediaPolicies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"media"},"value":{"kind":"Variable","name":{"kind":"Name","value":"media"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaPolicyFields"}},{"kind":"Field","name":{"kind":"Name","value":"viewingPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewingPolicyFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MediaPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"feedSubType"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"contentDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewingPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewingPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"audienceHref"}}]}}]} as unknown as DocumentNode<UpsertMediaPoliciesMutation, UpsertMediaPoliciesMutationVariables>;
export const CreateAudienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAudience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audience"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AudienceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAudience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"audience"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audience"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"authenticated"}},{"kind":"Field","name":{"kind":"Name","value":"match"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]} as unknown as DocumentNode<CreateAudienceMutation, CreateAudienceMutationVariables>;
export const DeletePolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"href"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"href"},"value":{"kind":"Variable","name":{"kind":"Name","value":"href"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<DeletePolicyMutation, DeletePolicyMutationVariables>;
export const DeleteAudienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAudience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"href"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAudience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"href"},"value":{"kind":"Variable","name":{"kind":"Name","value":"href"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<DeleteAudienceMutation, DeleteAudienceMutationVariables>;
export const DeleteEsniRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEsniRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEsniRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ruleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<DeleteEsniRuleMutation, DeleteEsniRuleMutationVariables>;
export const CreateEsniRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createEsniRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EsniRuleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEsniRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EsniRuleFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EsniRuleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EsniRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"query"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<CreateEsniRuleMutation, CreateEsniRuleMutationVariables>;
export const UpdateEsniRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEsniRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EsniRuleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEsniRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ruleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EsniRuleFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EsniRuleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EsniRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"query"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<UpdateEsniRuleMutation, UpdateEsniRuleMutationVariables>;
export const ValidateEsniMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validateEsniMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateEsniMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EsniMediaProcessingResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EsniMediaProcessingResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EsniMediaProcessingResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"}}]}}]} as unknown as DocumentNode<ValidateEsniMediaMutation, ValidateEsniMediaMutationVariables>;
export const ProcessEsniMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"processEsniMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processEsniMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EsniMediaProcessingResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EsniMediaProcessingResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EsniMediaProcessingResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"}}]}}]} as unknown as DocumentNode<ProcessEsniMediaMutation, ProcessEsniMediaMutationVariables>;
export const MediaPoliciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"mediaPolicies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaPolicies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaPolicyFields"}},{"kind":"Field","name":{"kind":"Name","value":"viewingPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewingPolicyFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MediaPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"feedSubType"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"contentDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewingPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewingPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"audienceHref"}}]}}]} as unknown as DocumentNode<MediaPoliciesQuery, MediaPoliciesQueryVariables>;
export const AudiencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"audiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"authenticated"}},{"kind":"Field","name":{"kind":"Name","value":"match"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]} as unknown as DocumentNode<AudiencesQuery, AudiencesQueryVariables>;
export const ViewingPoliciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"viewingPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewingPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewingPolicyFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewingPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewingPolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"audienceHref"}}]}}]} as unknown as DocumentNode<ViewingPoliciesQuery, ViewingPoliciesQueryVariables>;
export const AudienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"audience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"href"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"href"},"value":{"kind":"Variable","name":{"kind":"Name","value":"href"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"authenticated"}},{"kind":"Field","name":{"kind":"Name","value":"match"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]} as unknown as DocumentNode<AudienceQuery, AudienceQueryVariables>;
export const EsniRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"esniRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EsniRuleStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EsniRuleType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"esniRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EsniRuleFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EsniRuleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EsniRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"query"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<EsniRulesQuery, EsniRulesQueryVariables>;
export const CreateLocationOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLocationOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oktaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ipAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLocationOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"oktaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oktaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ipAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ipAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"zipCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CreateLocationOverrideMutation, CreateLocationOverrideMutationVariables>;
export const GetActiveLocationOverridesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveLocationOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveLocationOverrides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"9999999"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oktaId"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveLocationOverridesQuery, GetActiveLocationOverridesQueryVariables>;
export const UserInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<UserInfoQuery, UserInfoQueryVariables>;
export const RouteMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"routeMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"routeType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RouteType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"routeMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"routeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"routeType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RouteMediaMutation, RouteMediaMutationVariables>;
export const EndAdBreakDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"endAdBreak"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endAdBreak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<EndAdBreakMutation, EndAdBreakMutationVariables>;
export const SetSlateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setSlate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slateCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setSlate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"slateCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slateCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SetSlateMutation, SetSlateMutationVariables>;
export const LiftSlateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"liftSlate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liftSlate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LiftSlateMutation, LiftSlateMutationVariables>;
export const InsertAdBreakDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertAdBreak"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"durationSeconds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slateCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeBuffer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAdBreak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"durationSeconds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"durationSeconds"}}},{"kind":"Argument","name":{"kind":"Name","value":"slateCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slateCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeBuffer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeBuffer"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<InsertAdBreakMutation, InsertAdBreakMutationVariables>;
export const SyncPipelineRoutingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"syncPipelineRouting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncPipelineRouting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<SyncPipelineRoutingMutation, SyncPipelineRoutingMutationVariables>;
export const AdEventTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"adEventTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sport"}},"defaultValue":{"kind":"EnumValue","value":"MLB"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adEventTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sport"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<AdEventTypesQuery, AdEventTypesQueryVariables>;
export const LoggerScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loggerSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Sport"}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MLB"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"programSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]} as unknown as DocumentNode<LoggerScheduleQuery, LoggerScheduleQueryVariables>;
export const LoggerGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loggerGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduleDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"postGameShow"}},{"kind":"Field","name":{"kind":"Name","value":"preGameShow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSlateCode"}},{"kind":"Field","name":{"kind":"Name","value":"adBreakDurationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"adBreakStartedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"programSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"resumedFromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"red5Config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryHost"}},{"kind":"Field","name":{"kind":"Name","value":"primaryNodeGroup"}},{"kind":"Field","name":{"kind":"Name","value":"backupHost"}},{"kind":"Field","name":{"kind":"Name","value":"backupNodeGroup"}},{"kind":"Field","name":{"kind":"Name","value":"preProcStreamName"}},{"kind":"Field","name":{"kind":"Name","value":"postProcStreamName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoggerGameQuery, LoggerGameQueryVariables>;
export const SlatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"slates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sport"}},"defaultValue":{"kind":"EnumValue","value":"MLB"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SlateType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sport"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUri"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}}]}}]}}]} as unknown as DocumentNode<SlatesQuery, SlatesQueryVariables>;
export const ValidateLitmusSchemaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validateLitmusSchema"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validationProcess"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validationProcess"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validationProcess"}}},{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"validationProcess"}},{"kind":"Field","name":{"kind":"Name","value":"ruleResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]}}]} as unknown as DocumentNode<ValidateLitmusSchemaMutation, ValidateLitmusSchemaMutationVariables>;
export const LitmusScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"litmusSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Sport"}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MLB"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]} as unknown as DocumentNode<LitmusScheduleQuery, LitmusScheduleQueryVariables>;
export const ValidationSchemasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validationSchemas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationSchemas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationProcess"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<ValidationSchemasQuery, ValidationSchemasQueryVariables>;
export const AdjustMilestoneTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"adjustMilestoneTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"milestoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adjustMilestoneTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"milestoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"milestoneId"}}},{"kind":"Argument","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"milestoneType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTime"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<AdjustMilestoneTimeMutation, AdjustMilestoneTimeMutationVariables>;
export const DeleteMilestoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteMilestone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"milestoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMilestone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"milestoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"milestoneId"}}}]}]}}]} as unknown as DocumentNode<DeleteMilestoneMutation, DeleteMilestoneMutationVariables>;
export const InsertMilestoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertMilestone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"milestoneInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MilestoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertMilestone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"milestoneInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"milestoneInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"milestoneType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<InsertMilestoneMutation, InsertMilestoneMutationVariables>;
export const InitiateTrimDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"initiateTrim"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newStartTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newEndTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateTrim"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newStartTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newStartTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"newEndTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newEndTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<InitiateTrimMutation, InitiateTrimMutationVariables>;
export const MilestonesScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"milestonesSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Sport"}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MLB"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gameDate"}},{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]} as unknown as DocumentNode<MilestonesScheduleQuery, MilestonesScheduleQueryVariables>;
export const MilestonesGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"milestonesGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gamePk"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gamePk"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduleDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gamePk"}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MilestonesGameQuery, MilestonesGameQueryVariables>;
export const MilestoneSchemasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"milestoneSchemas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"milestoneSchemas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metadataFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<MilestoneSchemasQuery, MilestoneSchemasQueryVariables>;
export const MilestonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"milestones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"milestones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"milestoneType"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTime"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<MilestonesQuery, MilestonesQueryVariables>;
export const GeneratePlaybackUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generatePlaybackUrls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generatePlaybackUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playbacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"cdn"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"adsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"adExperienceType"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"adEngineIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"}}]}}]}}]}}]} as unknown as DocumentNode<GeneratePlaybackUrlsMutation, GeneratePlaybackUrlsMutationVariables>;
export const AssignTargetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignTargets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetChanges"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetChangeInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignTargets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"targetChanges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetChanges"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<AssignTargetsMutation, AssignTargetsMutationVariables>;
export const CreatePlaybackOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPlaybackOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"experience"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybackExperience"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"features"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybackFeature"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchParams"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlaybackOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experience"},"value":{"kind":"Variable","name":{"kind":"Name","value":"experience"}}},{"kind":"Argument","name":{"kind":"Name","value":"features"},"value":{"kind":"Variable","name":{"kind":"Name","value":"features"}}},{"kind":"Argument","name":{"kind":"Name","value":"matchParams"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchParams"}}}]}]}}]} as unknown as DocumentNode<CreatePlaybackOverrideMutation, CreatePlaybackOverrideMutationVariables>;
export const UpdatePlaybackOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePlaybackOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"experience"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybackExperience"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"features"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybackFeature"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchParams"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlaybackOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"experience"},"value":{"kind":"Variable","name":{"kind":"Name","value":"experience"}}},{"kind":"Argument","name":{"kind":"Name","value":"features"},"value":{"kind":"Variable","name":{"kind":"Name","value":"features"}}},{"kind":"Argument","name":{"kind":"Name","value":"matchParams"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchParams"}}}]}]}}]} as unknown as DocumentNode<UpdatePlaybackOverrideMutation, UpdatePlaybackOverrideMutationVariables>;
export const DeletePlaybackOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePlaybackOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overrideId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePlaybackOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"overrideId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overrideId"}}}]}]}}]} as unknown as DocumentNode<DeletePlaybackOverrideMutation, DeletePlaybackOverrideMutationVariables>;
export const PlaybackOverridesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"playbackOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playbackOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"matchParams"}}]}}]}}]} as unknown as DocumentNode<PlaybackOverridesQuery, PlaybackOverridesQueryVariables>;
export const AllOverridesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"matchParams"}}]}},{"kind":"Field","name":{"kind":"Name","value":"playbackOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"matchParams"}}]}}]}}]} as unknown as DocumentNode<AllOverridesQuery, AllOverridesQueryVariables>;
export const CreateSessionOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSessionOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"features"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionFeature"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchParams"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSessionOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experience"},"value":{"kind":"EnumValue","value":"MLB"}},{"kind":"Argument","name":{"kind":"Name","value":"features"},"value":{"kind":"Variable","name":{"kind":"Name","value":"features"}}},{"kind":"Argument","name":{"kind":"Name","value":"matchParams"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchParams"}}}]}]}}]} as unknown as DocumentNode<CreateSessionOverrideMutation, CreateSessionOverrideMutationVariables>;
export const UpdateSessionOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSessionOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"features"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionFeature"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchParams"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSessionOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"experience"},"value":{"kind":"EnumValue","value":"MLB"}},{"kind":"Argument","name":{"kind":"Name","value":"features"},"value":{"kind":"Variable","name":{"kind":"Name","value":"features"}}},{"kind":"Argument","name":{"kind":"Name","value":"matchParams"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchParams"}}}]}]}}]} as unknown as DocumentNode<UpdateSessionOverrideMutation, UpdateSessionOverrideMutationVariables>;
export const DeleteSessionOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSessionOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overrideId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSessionOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"overrideId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overrideId"}}}]}]}}]} as unknown as DocumentNode<DeleteSessionOverrideMutation, DeleteSessionOverrideMutationVariables>;
export const SessionOverridesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sessionOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"matchParams"}}]}}]}}]} as unknown as DocumentNode<SessionOverridesQuery, SessionOverridesQueryVariables>;
export const UpdatePipelineConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePipelineConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipelineConfig"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineConfig"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePipelineConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pipelineConfig"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipelineConfig"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PipelineConfigFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineConfigFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineConfigInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeSource"}},{"kind":"Field","name":{"kind":"Name","value":"altaChannelUrl"}},{"kind":"Field","name":{"kind":"Name","value":"backhaulDecoderHost"}},{"kind":"Field","name":{"kind":"Name","value":"backhaulDecoderServiceLabel"}},{"kind":"Field","name":{"kind":"Name","value":"eviProgramSwitchSrc"}},{"kind":"Field","name":{"kind":"Name","value":"eviSdpUrlAudio"}},{"kind":"Field","name":{"kind":"Name","value":"eviSdpUrlVideo"}},{"kind":"Field","name":{"kind":"Name","value":"eviSwitchDst"}},{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderHost"}},{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderServiceLabel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lexiInstanceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videonPrimaryStreamUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videonBackupStreamUrl"}},{"kind":"Field","name":{"kind":"Name","value":"partnerLockEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"partnerLockExclusions"}},{"kind":"Field","name":{"kind":"Name","value":"pd01Dst"}},{"kind":"Field","name":{"kind":"Name","value":"pd02Dst"}},{"kind":"Field","name":{"kind":"Name","value":"pd03Dst"}},{"kind":"Field","name":{"kind":"Name","value":"postGameSrc"}},{"kind":"Field","name":{"kind":"Name","value":"preGameSrc"}},{"kind":"Field","name":{"kind":"Name","value":"primaryBackhaulSrc"}},{"kind":"Field","name":{"kind":"Name","value":"primaryFronthaulSrc"}},{"kind":"Field","name":{"kind":"Name","value":"programSwitchDst"}},{"kind":"Field","name":{"kind":"Name","value":"programSwitchSrc"}},{"kind":"Field","name":{"kind":"Name","value":"sdpUrlAncillary"}},{"kind":"Field","name":{"kind":"Name","value":"sdpUrlAudio"}},{"kind":"Field","name":{"kind":"Name","value":"sdpUrlVideo"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"red5PreProcStreamName"}},{"kind":"Field","name":{"kind":"Name","value":"red5PostProcStreamName"}},{"kind":"Field","name":{"kind":"Name","value":"red5PrimaryHost"}},{"kind":"Field","name":{"kind":"Name","value":"red5BackupHost"}},{"kind":"Field","name":{"kind":"Name","value":"red5PrimaryNodeGroup"}},{"kind":"Field","name":{"kind":"Name","value":"red5BackupNodeGroup"}}]}}]} as unknown as DocumentNode<UpdatePipelineConfigMutation, UpdatePipelineConfigMutationVariables>;
export const GetPipelineConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPipelineConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelineConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PipelineConfigFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineConfigFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineConfigInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeSource"}},{"kind":"Field","name":{"kind":"Name","value":"altaChannelUrl"}},{"kind":"Field","name":{"kind":"Name","value":"backhaulDecoderHost"}},{"kind":"Field","name":{"kind":"Name","value":"backhaulDecoderServiceLabel"}},{"kind":"Field","name":{"kind":"Name","value":"eviProgramSwitchSrc"}},{"kind":"Field","name":{"kind":"Name","value":"eviSdpUrlAudio"}},{"kind":"Field","name":{"kind":"Name","value":"eviSdpUrlVideo"}},{"kind":"Field","name":{"kind":"Name","value":"eviSwitchDst"}},{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderHost"}},{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderServiceLabel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lexiInstanceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videonPrimaryStreamUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videonBackupStreamUrl"}},{"kind":"Field","name":{"kind":"Name","value":"partnerLockEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"partnerLockExclusions"}},{"kind":"Field","name":{"kind":"Name","value":"pd01Dst"}},{"kind":"Field","name":{"kind":"Name","value":"pd02Dst"}},{"kind":"Field","name":{"kind":"Name","value":"pd03Dst"}},{"kind":"Field","name":{"kind":"Name","value":"postGameSrc"}},{"kind":"Field","name":{"kind":"Name","value":"preGameSrc"}},{"kind":"Field","name":{"kind":"Name","value":"primaryBackhaulSrc"}},{"kind":"Field","name":{"kind":"Name","value":"primaryFronthaulSrc"}},{"kind":"Field","name":{"kind":"Name","value":"programSwitchDst"}},{"kind":"Field","name":{"kind":"Name","value":"programSwitchSrc"}},{"kind":"Field","name":{"kind":"Name","value":"sdpUrlAncillary"}},{"kind":"Field","name":{"kind":"Name","value":"sdpUrlAudio"}},{"kind":"Field","name":{"kind":"Name","value":"sdpUrlVideo"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"red5PreProcStreamName"}},{"kind":"Field","name":{"kind":"Name","value":"red5PostProcStreamName"}},{"kind":"Field","name":{"kind":"Name","value":"red5PrimaryHost"}},{"kind":"Field","name":{"kind":"Name","value":"red5BackupHost"}},{"kind":"Field","name":{"kind":"Name","value":"red5PrimaryNodeGroup"}},{"kind":"Field","name":{"kind":"Name","value":"red5BackupNodeGroup"}}]}}]} as unknown as DocumentNode<GetPipelineConfigsQuery, GetPipelineConfigsQueryVariables>;
export const UpdatePipelineInputConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePipelineInputConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"venueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MediaFeedType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipelineInputConfig"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PipelineInputConfig"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePipelineInputConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"venueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"venueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"feedType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedType"}}},{"kind":"Argument","name":{"kind":"Name","value":"pipelineInputConfig"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipelineInputConfig"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"venueId"}},{"kind":"Field","name":{"kind":"Name","value":"feedTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inputLabel"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode<UpdatePipelineInputConfigMutation, UpdatePipelineInputConfigMutationVariables>;
export const PipelineInputConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pipelineInputConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"venueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelineInputConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"venueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"venueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"venueId"}},{"kind":"Field","name":{"kind":"Name","value":"feedTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"inputLabel"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode<PipelineInputConfigsQuery, PipelineInputConfigsQueryVariables>;
export const AssignDevPipelineConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignDevPipelineConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignDevPipelineConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pipelineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}}}]}]}}]} as unknown as DocumentNode<AssignDevPipelineConfigMutation, AssignDevPipelineConfigMutationVariables>;
export const BorrowPipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"borrowPipeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"borrowPipeline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}]}}]} as unknown as DocumentNode<BorrowPipelineMutation, BorrowPipelineMutationVariables>;
export const ReturnPipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"returnPipeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returnPipeline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}]}}]} as unknown as DocumentNode<ReturnPipelineMutation, ReturnPipelineMutationVariables>;
export const PipelineMonitorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pipelineMonitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelineMonitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelineConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fronthaulDecoderServiceLabel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventPipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<PipelineMonitorsQuery, PipelineMonitorsQueryVariables>;
export const GetPartnerMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPartnerMapping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAllTargets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetPartnerMappingQuery, GetPartnerMappingQueryVariables>;
export const GetChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetChannelQuery, GetChannelQueryVariables>;
export const GetTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]}}]} as unknown as DocumentNode<GetTargetQuery, GetTargetQueryVariables>;
export const MediaUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"mediaUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mediaIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BTCPipelineMediaUpdateFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BTCPipelineMediaUpdateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaPipeline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeSlateCode"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"streamState"}},{"kind":"Field","name":{"kind":"Name","value":"resumedFromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"eviStatus"}},{"kind":"Field","name":{"kind":"Name","value":"eviPod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"feedType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alerts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"clearedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<MediaUpdatesSubscription, MediaUpdatesSubscriptionVariables>;
export const UserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UserIdQuery, UserIdQueryVariables>;
export const UserDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"size"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"}},{"kind":"Field","name":{"kind":"Name","value":"cachedEntitlements"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoriteTeam"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSell"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cachedProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoriteTeam"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSell"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"size"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"initTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"designatedMarketArea"}},{"kind":"Field","name":{"kind":"Name","value":"locationProvider"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expireDate"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"playbackSessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playbackSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"countsForCap"}},{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"}},{"kind":"Field","name":{"kind":"Name","value":"playbackStatus"}},{"kind":"Field","name":{"kind":"Name","value":"contentExperience"}},{"kind":"Field","name":{"kind":"Name","value":"features"}}]}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"os"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRuntime"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"profile"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"extraAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"appVersion"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserDataQuery, UserDataQueryVariables>;

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockScheduleQuery(
 *   ({ query, variables }) => {
 *     const { date, sports } = variables;
 *     return HttpResponse.json({
 *       data: { schedule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockScheduleQuery = (resolver: GraphQLResponseResolver<ScheduleQuery, ScheduleQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ScheduleQuery, ScheduleQueryVariables>(
    'schedule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAuditsQuery(
 *   ({ query, variables }) => {
 *     const { sourceSystems, operations, instigator, email, traceId, startDate, endDate, tag, limit, page } = variables;
 *     return HttpResponse.json({
 *       data: { audits }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAuditsQuery = (resolver: GraphQLResponseResolver<AuditsQuery, AuditsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AuditsQuery, AuditsQueryVariables>(
    'audits',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAuditSourceSystemsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { auditSourceSystems }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAuditSourceSystemsQuery = (resolver: GraphQLResponseResolver<AuditSourceSystemsQuery, AuditSourceSystemsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AuditSourceSystemsQuery, AuditSourceSystemsQueryVariables>(
    'auditSourceSystems',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProvisionMediaMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds } = variables;
 *     return HttpResponse.json({
 *       data: { provisionMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProvisionMediaMutation = (resolver: GraphQLResponseResolver<ProvisionMediaMutation, ProvisionMediaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ProvisionMediaMutation, ProvisionMediaMutationVariables>(
    'provisionMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUnscheduleMediaMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds } = variables;
 *     return HttpResponse.json({
 *       data: { unscheduleMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUnscheduleMediaMutation = (resolver: GraphQLResponseResolver<UnscheduleMediaMutation, UnscheduleMediaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UnscheduleMediaMutation, UnscheduleMediaMutationVariables>(
    'unscheduleMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStartMediaMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds } = variables;
 *     return HttpResponse.json({
 *       data: { startMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStartMediaMutation = (resolver: GraphQLResponseResolver<StartMediaMutation, StartMediaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StartMediaMutation, StartMediaMutationVariables>(
    'startMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStopMediaMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds } = variables;
 *     return HttpResponse.json({
 *       data: { stopMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStopMediaMutation = (resolver: GraphQLResponseResolver<StopMediaMutation, StopMediaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StopMediaMutation, StopMediaMutationVariables>(
    'stopMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockArchiveMediaMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds } = variables;
 *     return HttpResponse.json({
 *       data: { archiveMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockArchiveMediaMutation = (resolver: GraphQLResponseResolver<ArchiveMediaMutation, ArchiveMediaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ArchiveMediaMutation, ArchiveMediaMutationVariables>(
    'archiveMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockResolveAlertMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, alertId } = variables;
 *     return HttpResponse.json({
 *       data: { resolveAlert }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockResolveAlertMutation = (resolver: GraphQLResponseResolver<ResolveAlertMutation, ResolveAlertMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ResolveAlertMutation, ResolveAlertMutationVariables>(
    'resolveAlert',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetEviStatusMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, status } = variables;
 *     return HttpResponse.json({
 *       data: { setEviStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSetEviStatusMutation = (resolver: GraphQLResponseResolver<SetEviStatusMutation, SetEviStatusMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SetEviStatusMutation, SetEviStatusMutationVariables>(
    'setEviStatus',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSyncMediaContentMutation(
 *   ({ query, variables }) => {
 *     const { gamePk } = variables;
 *     return HttpResponse.json({
 *       data: { syncMediaContent }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSyncMediaContentMutation = (resolver: GraphQLResponseResolver<SyncMediaContentMutation, SyncMediaContentMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SyncMediaContentMutation, SyncMediaContentMutationVariables>(
    'syncMediaContent',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePipelineMediaMutation(
 *   ({ query, variables }) => {
 *     const { mediaId } = variables;
 *     return HttpResponse.json({
 *       data: { updatePipelineMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdatePipelineMediaMutation = (resolver: GraphQLResponseResolver<UpdatePipelineMediaMutation, UpdatePipelineMediaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdatePipelineMediaMutation, UpdatePipelineMediaMutationVariables>(
    'updatePipelineMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateAssetsStateMutation(
 *   ({ query, variables }) => {
 *     const { mediaAssets, assetState } = variables;
 *     return HttpResponse.json({
 *       data: { updateAssetsState }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateAssetsStateMutation = (resolver: GraphQLResponseResolver<UpdateAssetsStateMutation, UpdateAssetsStateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateAssetsStateMutation, UpdateAssetsStateMutationVariables>(
    'updateAssetsState',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockActivateAdsMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, videoId } = variables;
 *     return HttpResponse.json({
 *       data: { activateAds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockActivateAdsMutation = (resolver: GraphQLResponseResolver<ActivateAdsMutation, ActivateAdsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ActivateAdsMutation, ActivateAdsMutationVariables>(
    'activateAds',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPauseAdsMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, videoId } = variables;
 *     return HttpResponse.json({
 *       data: { pauseAds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPauseAdsMutation = (resolver: GraphQLResponseResolver<PauseAdsMutation, PauseAdsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<PauseAdsMutation, PauseAdsMutationVariables>(
    'pauseAds',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateMulticastMappingMutation(
 *   ({ query, variables }) => {
 *     const { callSign, priority, sourceLocation, multicastAddress, hdrMulticastAddress } = variables;
 *     return HttpResponse.json({
 *       data: { createMulticastMapping }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateMulticastMappingMutation = (resolver: GraphQLResponseResolver<CreateMulticastMappingMutation, CreateMulticastMappingMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateMulticastMappingMutation, CreateMulticastMappingMutationVariables>(
    'createMulticastMapping',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMulticastMappingMutation(
 *   ({ query, variables }) => {
 *     const { id, updatedMapping } = variables;
 *     return HttpResponse.json({
 *       data: { updateMulticastMapping }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMulticastMappingMutation = (resolver: GraphQLResponseResolver<UpdateMulticastMappingMutation, UpdateMulticastMappingMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMulticastMappingMutation, UpdateMulticastMappingMutationVariables>(
    'updateMulticastMapping',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteMulticastMappingMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteMulticastMapping }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteMulticastMappingMutation = (resolver: GraphQLResponseResolver<DeleteMulticastMappingMutation, DeleteMulticastMappingMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteMulticastMappingMutation, DeleteMulticastMappingMutationVariables>(
    'deleteMulticastMapping',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAssignEviPodMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, eviPodName } = variables;
 *     return HttpResponse.json({
 *       data: { assignEviPod }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAssignEviPodMutation = (resolver: GraphQLResponseResolver<AssignEviPodMutation, AssignEviPodMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AssignEviPodMutation, AssignEviPodMutationVariables>(
    'assignEviPod',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProvisionCopyrightStreamMutation(
 *   ({ query, variables }) => {
 *     const { stream } = variables;
 *     return HttpResponse.json({
 *       data: { provisionCopyrightStream }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProvisionCopyrightStreamMutation = (resolver: GraphQLResponseResolver<ProvisionCopyrightStreamMutation, ProvisionCopyrightStreamMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ProvisionCopyrightStreamMutation, ProvisionCopyrightStreamMutationVariables>(
    'provisionCopyrightStream',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStartCopyrightStreamMutation(
 *   ({ query, variables }) => {
 *     const { streamId } = variables;
 *     return HttpResponse.json({
 *       data: { startCopyrightStream }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStartCopyrightStreamMutation = (resolver: GraphQLResponseResolver<StartCopyrightStreamMutation, StartCopyrightStreamMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StartCopyrightStreamMutation, StartCopyrightStreamMutationVariables>(
    'startCopyrightStream',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStopCopyrightStreamMutation(
 *   ({ query, variables }) => {
 *     const { streamId } = variables;
 *     return HttpResponse.json({
 *       data: { stopCopyrightStream }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStopCopyrightStreamMutation = (resolver: GraphQLResponseResolver<StopCopyrightStreamMutation, StopCopyrightStreamMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StopCopyrightStreamMutation, StopCopyrightStreamMutationVariables>(
    'stopCopyrightStream',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteCopyrightStreamMutation(
 *   ({ query, variables }) => {
 *     const { streamId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteCopyrightStream }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteCopyrightStreamMutation = (resolver: GraphQLResponseResolver<DeleteCopyrightStreamMutation, DeleteCopyrightStreamMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteCopyrightStreamMutation, DeleteCopyrightStreamMutationVariables>(
    'deleteCopyrightStream',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCdnStatusMutation(
 *   ({ query, variables }) => {
 *     const { cdn, enabled } = variables;
 *     return HttpResponse.json({
 *       data: { updateCdnStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCdnStatusMutation = (resolver: GraphQLResponseResolver<UpdateCdnStatusMutation, UpdateCdnStatusMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCdnStatusMutation, UpdateCdnStatusMutationVariables>(
    'updateCdnStatus',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateBroadcastMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, mediaState, freeGameStatuses, availableForStreaming, videoResolution, colorSpace, mvpdRequired } = variables;
 *     return HttpResponse.json({
 *       data: { updateBroadcast }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateBroadcastMutation = (resolver: GraphQLResponseResolver<UpdateBroadcastMutation, UpdateBroadcastMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateBroadcastMutation, UpdateBroadcastMutationVariables>(
    'updateBroadcast',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateBroadcastSourceMutation(
 *   ({ query, variables }) => {
 *     const { gamePk, feedType, sourceUpdateInput } = variables;
 *     return HttpResponse.json({
 *       data: { updateBroadcastSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateBroadcastSourceMutation = (resolver: GraphQLResponseResolver<UpdateBroadcastSourceMutation, UpdateBroadcastSourceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateBroadcastSourceMutation, UpdateBroadcastSourceMutationVariables>(
    'updateBroadcastSource',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSwitchProgramSourceMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds, programSource } = variables;
 *     return HttpResponse.json({
 *       data: { switchProgramSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSwitchProgramSourceMutation = (resolver: GraphQLResponseResolver<SwitchProgramSourceMutation, SwitchProgramSourceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SwitchProgramSourceMutation, SwitchProgramSourceMutationVariables>(
    'switchProgramSource',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateBroadcastSourceOverrideMutation(
 *   ({ query, variables }) => {
 *     const { broadcastSourceOverrideInput } = variables;
 *     return HttpResponse.json({
 *       data: { createBroadcastSourceOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateBroadcastSourceOverrideMutation = (resolver: GraphQLResponseResolver<CreateBroadcastSourceOverrideMutation, CreateBroadcastSourceOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateBroadcastSourceOverrideMutation, CreateBroadcastSourceOverrideMutationVariables>(
    'createBroadcastSourceOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteBroadcastSourceOverrideMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteBroadcastSourceOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteBroadcastSourceOverrideMutation = (resolver: GraphQLResponseResolver<DeleteBroadcastSourceOverrideMutation, DeleteBroadcastSourceOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteBroadcastSourceOverrideMutation, DeleteBroadcastSourceOverrideMutationVariables>(
    'deleteBroadcastSourceOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateBroadcastSourceOverrideMutation(
 *   ({ query, variables }) => {
 *     const { id, broadcastSourceOverrideInput } = variables;
 *     return HttpResponse.json({
 *       data: { updateBroadcastSourceOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateBroadcastSourceOverrideMutation = (resolver: GraphQLResponseResolver<UpdateBroadcastSourceOverrideMutation, UpdateBroadcastSourceOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateBroadcastSourceOverrideMutation, UpdateBroadcastSourceOverrideMutationVariables>(
    'updateBroadcastSourceOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateBroadcastOverrideMutation(
 *   ({ query, variables }) => {
 *     const { gamePk, feedTypeCode, region, callSign, fronthaulDecoderInputLabel, multicastAddress } = variables;
 *     return HttpResponse.json({
 *       data: { createBroadcastOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateBroadcastOverrideMutation = (resolver: GraphQLResponseResolver<CreateBroadcastOverrideMutation, CreateBroadcastOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateBroadcastOverrideMutation, CreateBroadcastOverrideMutationVariables>(
    'createBroadcastOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateBroadcastOverrideMutation(
 *   ({ query, variables }) => {
 *     const { id, region, updatedBroadcastOverride } = variables;
 *     return HttpResponse.json({
 *       data: { updateBroadcastOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateBroadcastOverrideMutation = (resolver: GraphQLResponseResolver<UpdateBroadcastOverrideMutation, UpdateBroadcastOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateBroadcastOverrideMutation, UpdateBroadcastOverrideMutationVariables>(
    'updateBroadcastOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteBroadcastOverrideMutation(
 *   ({ query, variables }) => {
 *     const { id, region } = variables;
 *     return HttpResponse.json({
 *       data: { deleteBroadcastOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteBroadcastOverrideMutation = (resolver: GraphQLResponseResolver<DeleteBroadcastOverrideMutation, DeleteBroadcastOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteBroadcastOverrideMutation, DeleteBroadcastOverrideMutationVariables>(
    'deleteBroadcastOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePartnerDistributionLockMutation(
 *   ({ query, variables }) => {
 *     const { teamId, setLock } = variables;
 *     return HttpResponse.json({
 *       data: { updatePartnerDistributionLock }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdatePartnerDistributionLockMutation = (resolver: GraphQLResponseResolver<UpdatePartnerDistributionLockMutation, UpdatePartnerDistributionLockMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdatePartnerDistributionLockMutation, UpdatePartnerDistributionLockMutationVariables>(
    'updatePartnerDistributionLock',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockToggleSkyviewConfigMutation(
 *   ({ query, variables }) => {
 *     const { teamId, language, enabled } = variables;
 *     return HttpResponse.json({
 *       data: { toggleSkyviewConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockToggleSkyviewConfigMutation = (resolver: GraphQLResponseResolver<ToggleSkyviewConfigMutation, ToggleSkyviewConfigMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ToggleSkyviewConfigMutation, ToggleSkyviewConfigMutationVariables>(
    'toggleSkyviewConfig',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockToggleAllSkyviewConfigsMutation(
 *   ({ query, variables }) => {
 *     const { enabled } = variables;
 *     return HttpResponse.json({
 *       data: { toggleAllSkyviewConfigs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockToggleAllSkyviewConfigsMutation = (resolver: GraphQLResponseResolver<ToggleAllSkyviewConfigsMutation, ToggleAllSkyviewConfigsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ToggleAllSkyviewConfigsMutation, ToggleAllSkyviewConfigsMutationVariables>(
    'toggleAllSkyviewConfigs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockIngestAssetsIntoDaiMutation(
 *   ({ query, variables }) => {
 *     const { assetIds } = variables;
 *     return HttpResponse.json({
 *       data: { ingestAssetsIntoDai }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockIngestAssetsIntoDaiMutation = (resolver: GraphQLResponseResolver<IngestAssetsIntoDaiMutation, IngestAssetsIntoDaiMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<IngestAssetsIntoDaiMutation, IngestAssetsIntoDaiMutationVariables>(
    'ingestAssetsIntoDai',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBtcScheduleQuery(
 *   ({ query, variables }) => {
 *     const { date, sports } = variables;
 *     return HttpResponse.json({
 *       data: { schedule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBtcScheduleQuery = (resolver: GraphQLResponseResolver<BtcScheduleQuery, BtcScheduleQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BtcScheduleQuery, BtcScheduleQueryVariables>(
    'btcSchedule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBtcGameQuery(
 *   ({ query, variables }) => {
 *     const { gamePk, scheduleDate } = variables;
 *     return HttpResponse.json({
 *       data: { game }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBtcGameQuery = (resolver: GraphQLResponseResolver<BtcGameQuery, BtcGameQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BtcGameQuery, BtcGameQueryVariables>(
    'btcGame',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBtcGamePipelinesQuery(
 *   ({ query, variables }) => {
 *     const { gamePk, scheduleDate } = variables;
 *     return HttpResponse.json({
 *       data: { game }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBtcGamePipelinesQuery = (resolver: GraphQLResponseResolver<BtcGamePipelinesQuery, BtcGamePipelinesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BtcGamePipelinesQuery, BtcGamePipelinesQueryVariables>(
    'btcGamePipelines',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBtcGameContentQuery(
 *   ({ query, variables }) => {
 *     const { gamePk, scheduleDate } = variables;
 *     return HttpResponse.json({
 *       data: { game }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBtcGameContentQuery = (resolver: GraphQLResponseResolver<BtcGameContentQuery, BtcGameContentQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BtcGameContentQuery, BtcGameContentQueryVariables>(
    'btcGameContent',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBtcGameContentWithAssetsQuery(
 *   ({ query, variables }) => {
 *     const { gamePk, scheduleDate } = variables;
 *     return HttpResponse.json({
 *       data: { game }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBtcGameContentWithAssetsQuery = (resolver: GraphQLResponseResolver<BtcGameContentWithAssetsQuery, BtcGameContentWithAssetsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BtcGameContentWithAssetsQuery, BtcGameContentWithAssetsQueryVariables>(
    'btcGameContentWithAssets',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchMulticastMappingQuery(
 *   ({ query, variables }) => {
 *     const { callSign, priority, sourceLocations } = variables;
 *     return HttpResponse.json({
 *       data: { searchMulticastMappings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSearchMulticastMappingQuery = (resolver: GraphQLResponseResolver<SearchMulticastMappingQuery, SearchMulticastMappingQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SearchMulticastMappingQuery, SearchMulticastMappingQueryVariables>(
    'searchMulticastMapping',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEviPodsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { eviPods }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEviPodsQuery = (resolver: GraphQLResponseResolver<EviPodsQuery, EviPodsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EviPodsQuery, EviPodsQueryVariables>(
    'eviPods',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCopyrightStreamsQuery(
 *   ({ query, variables }) => {
 *     const { gamePk, scheduleDate } = variables;
 *     return HttpResponse.json({
 *       data: { copyrightStreams }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCopyrightStreamsQuery = (resolver: GraphQLResponseResolver<CopyrightStreamsQuery, CopyrightStreamsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CopyrightStreamsQuery, CopyrightStreamsQueryVariables>(
    'copyrightStreams',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPlaybackCdnsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { playbackCdns }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPlaybackCdnsQuery = (resolver: GraphQLResponseResolver<PlaybackCdnsQuery, PlaybackCdnsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PlaybackCdnsQuery, PlaybackCdnsQueryVariables>(
    'playbackCdns',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBroadcastSourceOverridesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { broadcastSourceOverrides }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBroadcastSourceOverridesQuery = (resolver: GraphQLResponseResolver<BroadcastSourceOverridesQuery, BroadcastSourceOverridesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BroadcastSourceOverridesQuery, BroadcastSourceOverridesQueryVariables>(
    'broadcastSourceOverrides',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBroadcastAcquisitionsQuery(
 *   ({ query, variables }) => {
 *     const { gamePk, feedTypeCode } = variables;
 *     return HttpResponse.json({
 *       data: { broadcastAcquisitions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBroadcastAcquisitionsQuery = (resolver: GraphQLResponseResolver<BroadcastAcquisitionsQuery, BroadcastAcquisitionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BroadcastAcquisitionsQuery, BroadcastAcquisitionsQueryVariables>(
    'broadcastAcquisitions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchZixiSourcesByTeamQuery(
 *   ({ query, variables }) => {
 *     const { teamId, location, destination, activeSource } = variables;
 *     return HttpResponse.json({
 *       data: { searchZixiSourcesByTeam }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSearchZixiSourcesByTeamQuery = (resolver: GraphQLResponseResolver<SearchZixiSourcesByTeamQuery, SearchZixiSourcesByTeamQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SearchZixiSourcesByTeamQuery, SearchZixiSourcesByTeamQueryVariables>(
    'searchZixiSourcesByTeam',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSkyviewConfigsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { skyviewConfigs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSkyviewConfigsQuery = (resolver: GraphQLResponseResolver<SkyviewConfigsQuery, SkyviewConfigsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SkyviewConfigsQuery, SkyviewConfigsQueryVariables>(
    'skyviewConfigs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateAudienceMutation(
 *   ({ query, variables }) => {
 *     const { href, audience } = variables;
 *     return HttpResponse.json({
 *       data: { updateAudience }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateAudienceMutation = (resolver: GraphQLResponseResolver<UpdateAudienceMutation, UpdateAudienceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateAudienceMutation, UpdateAudienceMutationVariables>(
    'updateAudience',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreatePolicyMutation(
 *   ({ query, variables }) => {
 *     const { policy } = variables;
 *     return HttpResponse.json({
 *       data: { createPolicy }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreatePolicyMutation = (resolver: GraphQLResponseResolver<CreatePolicyMutation, CreatePolicyMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreatePolicyMutation, CreatePolicyMutationVariables>(
    'createPolicy',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePolicyMutation(
 *   ({ query, variables }) => {
 *     const { href, policy } = variables;
 *     return HttpResponse.json({
 *       data: { updatePolicy }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdatePolicyMutation = (resolver: GraphQLResponseResolver<UpdatePolicyMutation, UpdatePolicyMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdatePolicyMutation, UpdatePolicyMutationVariables>(
    'updatePolicy',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertMediaPoliciesMutation(
 *   ({ query, variables }) => {
 *     const { media } = variables;
 *     return HttpResponse.json({
 *       data: { upsertMediaPolicies }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertMediaPoliciesMutation = (resolver: GraphQLResponseResolver<UpsertMediaPoliciesMutation, UpsertMediaPoliciesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertMediaPoliciesMutation, UpsertMediaPoliciesMutationVariables>(
    'upsertMediaPolicies',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateAudienceMutation(
 *   ({ query, variables }) => {
 *     const { audience } = variables;
 *     return HttpResponse.json({
 *       data: { createAudience }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateAudienceMutation = (resolver: GraphQLResponseResolver<CreateAudienceMutation, CreateAudienceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateAudienceMutation, CreateAudienceMutationVariables>(
    'createAudience',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeletePolicyMutation(
 *   ({ query, variables }) => {
 *     const { href } = variables;
 *     return HttpResponse.json({
 *       data: { deletePolicy }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeletePolicyMutation = (resolver: GraphQLResponseResolver<DeletePolicyMutation, DeletePolicyMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeletePolicyMutation, DeletePolicyMutationVariables>(
    'deletePolicy',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteAudienceMutation(
 *   ({ query, variables }) => {
 *     const { href } = variables;
 *     return HttpResponse.json({
 *       data: { deleteAudience }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteAudienceMutation = (resolver: GraphQLResponseResolver<DeleteAudienceMutation, DeleteAudienceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteAudienceMutation, DeleteAudienceMutationVariables>(
    'deleteAudience',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteEsniRuleMutation(
 *   ({ query, variables }) => {
 *     const { ruleId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteEsniRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteEsniRuleMutation = (resolver: GraphQLResponseResolver<DeleteEsniRuleMutation, DeleteEsniRuleMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteEsniRuleMutation, DeleteEsniRuleMutationVariables>(
    'deleteEsniRule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateEsniRuleMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { createEsniRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateEsniRuleMutation = (resolver: GraphQLResponseResolver<CreateEsniRuleMutation, CreateEsniRuleMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateEsniRuleMutation, CreateEsniRuleMutationVariables>(
    'createEsniRule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateEsniRuleMutation(
 *   ({ query, variables }) => {
 *     const { ruleId, input } = variables;
 *     return HttpResponse.json({
 *       data: { updateEsniRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateEsniRuleMutation = (resolver: GraphQLResponseResolver<UpdateEsniRuleMutation, UpdateEsniRuleMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateEsniRuleMutation, UpdateEsniRuleMutationVariables>(
    'updateEsniRule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockValidateEsniMediaMutation(
 *   ({ query, variables }) => {
 *     const { mediaId } = variables;
 *     return HttpResponse.json({
 *       data: { validateEsniMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockValidateEsniMediaMutation = (resolver: GraphQLResponseResolver<ValidateEsniMediaMutation, ValidateEsniMediaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ValidateEsniMediaMutation, ValidateEsniMediaMutationVariables>(
    'validateEsniMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProcessEsniMediaMutation(
 *   ({ query, variables }) => {
 *     const { mediaId } = variables;
 *     return HttpResponse.json({
 *       data: { processEsniMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProcessEsniMediaMutation = (resolver: GraphQLResponseResolver<ProcessEsniMediaMutation, ProcessEsniMediaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ProcessEsniMediaMutation, ProcessEsniMediaMutationVariables>(
    'processEsniMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMediaPoliciesQuery(
 *   ({ query, variables }) => {
 *     const { mediaId, gamePk, date } = variables;
 *     return HttpResponse.json({
 *       data: { mediaPolicies }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMediaPoliciesQuery = (resolver: GraphQLResponseResolver<MediaPoliciesQuery, MediaPoliciesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MediaPoliciesQuery, MediaPoliciesQueryVariables>(
    'mediaPolicies',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAudiencesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { audiences }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAudiencesQuery = (resolver: GraphQLResponseResolver<AudiencesQuery, AudiencesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AudiencesQuery, AudiencesQueryVariables>(
    'audiences',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockViewingPoliciesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { viewingPolicies }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockViewingPoliciesQuery = (resolver: GraphQLResponseResolver<ViewingPoliciesQuery, ViewingPoliciesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ViewingPoliciesQuery, ViewingPoliciesQueryVariables>(
    'viewingPolicies',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAudienceQuery(
 *   ({ query, variables }) => {
 *     const { href } = variables;
 *     return HttpResponse.json({
 *       data: { audience }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAudienceQuery = (resolver: GraphQLResponseResolver<AudienceQuery, AudienceQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AudienceQuery, AudienceQueryVariables>(
    'audience',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEsniRulesQuery(
 *   ({ query, variables }) => {
 *     const { status, type } = variables;
 *     return HttpResponse.json({
 *       data: { esniRules }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEsniRulesQuery = (resolver: GraphQLResponseResolver<EsniRulesQuery, EsniRulesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EsniRulesQuery, EsniRulesQueryVariables>(
    'esniRules',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateLocationOverrideMutation(
 *   ({ query, variables }) => {
 *     const { oktaId, ipAddress, zipCode, countryCode } = variables;
 *     return HttpResponse.json({
 *       data: { createLocationOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateLocationOverrideMutation = (resolver: GraphQLResponseResolver<CreateLocationOverrideMutation, CreateLocationOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateLocationOverrideMutation, CreateLocationOverrideMutationVariables>(
    'createLocationOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetActiveLocationOverridesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getActiveLocationOverrides }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetActiveLocationOverridesQuery = (resolver: GraphQLResponseResolver<GetActiveLocationOverridesQuery, GetActiveLocationOverridesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetActiveLocationOverridesQuery, GetActiveLocationOverridesQueryVariables>(
    'getActiveLocationOverrides',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserInfoQuery(
 *   ({ query, variables }) => {
 *     const { email } = variables;
 *     return HttpResponse.json({
 *       data: { userInfo }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUserInfoQuery = (resolver: GraphQLResponseResolver<UserInfoQuery, UserInfoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UserInfoQuery, UserInfoQueryVariables>(
    'userInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRouteMediaMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds, routeType } = variables;
 *     return HttpResponse.json({
 *       data: { routeMedia }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRouteMediaMutation = (resolver: GraphQLResponseResolver<RouteMediaMutation, RouteMediaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RouteMediaMutation, RouteMediaMutationVariables>(
    'routeMedia',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEndAdBreakMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds } = variables;
 *     return HttpResponse.json({
 *       data: { endAdBreak }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEndAdBreakMutation = (resolver: GraphQLResponseResolver<EndAdBreakMutation, EndAdBreakMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EndAdBreakMutation, EndAdBreakMutationVariables>(
    'endAdBreak',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetSlateMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds, slateCode } = variables;
 *     return HttpResponse.json({
 *       data: { setSlate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSetSlateMutation = (resolver: GraphQLResponseResolver<SetSlateMutation, SetSlateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SetSlateMutation, SetSlateMutationVariables>(
    'setSlate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLiftSlateMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds } = variables;
 *     return HttpResponse.json({
 *       data: { liftSlate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLiftSlateMutation = (resolver: GraphQLResponseResolver<LiftSlateMutation, LiftSlateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<LiftSlateMutation, LiftSlateMutationVariables>(
    'liftSlate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsertAdBreakMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds, durationSeconds, slateCode, eventType, includeBuffer } = variables;
 *     return HttpResponse.json({
 *       data: { insertAdBreak }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsertAdBreakMutation = (resolver: GraphQLResponseResolver<InsertAdBreakMutation, InsertAdBreakMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<InsertAdBreakMutation, InsertAdBreakMutationVariables>(
    'insertAdBreak',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSyncPipelineRoutingMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds } = variables;
 *     return HttpResponse.json({
 *       data: { syncPipelineRouting }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSyncPipelineRoutingMutation = (resolver: GraphQLResponseResolver<SyncPipelineRoutingMutation, SyncPipelineRoutingMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SyncPipelineRoutingMutation, SyncPipelineRoutingMutationVariables>(
    'syncPipelineRouting',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAdEventTypesQuery(
 *   ({ query, variables }) => {
 *     const { sport } = variables;
 *     return HttpResponse.json({
 *       data: { adEventTypes }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAdEventTypesQuery = (resolver: GraphQLResponseResolver<AdEventTypesQuery, AdEventTypesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AdEventTypesQuery, AdEventTypesQueryVariables>(
    'adEventTypes',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLoggerScheduleQuery(
 *   ({ query, variables }) => {
 *     const { date, sports } = variables;
 *     return HttpResponse.json({
 *       data: { schedule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLoggerScheduleQuery = (resolver: GraphQLResponseResolver<LoggerScheduleQuery, LoggerScheduleQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LoggerScheduleQuery, LoggerScheduleQueryVariables>(
    'loggerSchedule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLoggerGameQuery(
 *   ({ query, variables }) => {
 *     const { gamePk, scheduleDate } = variables;
 *     return HttpResponse.json({
 *       data: { game }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLoggerGameQuery = (resolver: GraphQLResponseResolver<LoggerGameQuery, LoggerGameQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LoggerGameQuery, LoggerGameQueryVariables>(
    'loggerGame',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSlatesQuery(
 *   ({ query, variables }) => {
 *     const { sport, type } = variables;
 *     return HttpResponse.json({
 *       data: { slates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSlatesQuery = (resolver: GraphQLResponseResolver<SlatesQuery, SlatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SlatesQuery, SlatesQueryVariables>(
    'slates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockValidateLitmusSchemaMutation(
 *   ({ query, variables }) => {
 *     const { validationProcess, gamePk } = variables;
 *     return HttpResponse.json({
 *       data: { validate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockValidateLitmusSchemaMutation = (resolver: GraphQLResponseResolver<ValidateLitmusSchemaMutation, ValidateLitmusSchemaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ValidateLitmusSchemaMutation, ValidateLitmusSchemaMutationVariables>(
    'validateLitmusSchema',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLitmusScheduleQuery(
 *   ({ query, variables }) => {
 *     const { date, sports } = variables;
 *     return HttpResponse.json({
 *       data: { schedule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLitmusScheduleQuery = (resolver: GraphQLResponseResolver<LitmusScheduleQuery, LitmusScheduleQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LitmusScheduleQuery, LitmusScheduleQueryVariables>(
    'litmusSchedule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockValidationSchemasQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { validationSchemas }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockValidationSchemasQuery = (resolver: GraphQLResponseResolver<ValidationSchemasQuery, ValidationSchemasQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ValidationSchemasQuery, ValidationSchemasQueryVariables>(
    'validationSchemas',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAdjustMilestoneTimeMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, milestoneId, timestamp } = variables;
 *     return HttpResponse.json({
 *       data: { adjustMilestoneTime }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAdjustMilestoneTimeMutation = (resolver: GraphQLResponseResolver<AdjustMilestoneTimeMutation, AdjustMilestoneTimeMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AdjustMilestoneTimeMutation, AdjustMilestoneTimeMutationVariables>(
    'adjustMilestoneTime',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteMilestoneMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, milestoneId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteMilestone }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteMilestoneMutation = (resolver: GraphQLResponseResolver<DeleteMilestoneMutation, DeleteMilestoneMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteMilestoneMutation, DeleteMilestoneMutationVariables>(
    'deleteMilestone',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsertMilestoneMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, milestoneInput } = variables;
 *     return HttpResponse.json({
 *       data: { insertMilestone }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsertMilestoneMutation = (resolver: GraphQLResponseResolver<InsertMilestoneMutation, InsertMilestoneMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<InsertMilestoneMutation, InsertMilestoneMutationVariables>(
    'insertMilestone',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInitiateTrimMutation(
 *   ({ query, variables }) => {
 *     const { mediaId, newStartTime, newEndTime } = variables;
 *     return HttpResponse.json({
 *       data: { initiateTrim }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInitiateTrimMutation = (resolver: GraphQLResponseResolver<InitiateTrimMutation, InitiateTrimMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<InitiateTrimMutation, InitiateTrimMutationVariables>(
    'initiateTrim',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMilestonesScheduleQuery(
 *   ({ query, variables }) => {
 *     const { date, sports } = variables;
 *     return HttpResponse.json({
 *       data: { schedule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMilestonesScheduleQuery = (resolver: GraphQLResponseResolver<MilestonesScheduleQuery, MilestonesScheduleQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MilestonesScheduleQuery, MilestonesScheduleQueryVariables>(
    'milestonesSchedule',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMilestonesGameQuery(
 *   ({ query, variables }) => {
 *     const { gamePk, scheduleDate } = variables;
 *     return HttpResponse.json({
 *       data: { game }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMilestonesGameQuery = (resolver: GraphQLResponseResolver<MilestonesGameQuery, MilestonesGameQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MilestonesGameQuery, MilestonesGameQueryVariables>(
    'milestonesGame',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMilestoneSchemasQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { milestoneSchemas }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMilestoneSchemasQuery = (resolver: GraphQLResponseResolver<MilestoneSchemasQuery, MilestoneSchemasQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MilestoneSchemasQuery, MilestoneSchemasQueryVariables>(
    'milestoneSchemas',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMilestonesQuery(
 *   ({ query, variables }) => {
 *     const { mediaId } = variables;
 *     return HttpResponse.json({
 *       data: { milestones }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMilestonesQuery = (resolver: GraphQLResponseResolver<MilestonesQuery, MilestonesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MilestonesQuery, MilestonesQueryVariables>(
    'milestones',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGeneratePlaybackUrlsMutation(
 *   ({ query, variables }) => {
 *     const { mediaIds } = variables;
 *     return HttpResponse.json({
 *       data: { generatePlaybackUrls }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGeneratePlaybackUrlsMutation = (resolver: GraphQLResponseResolver<GeneratePlaybackUrlsMutation, GeneratePlaybackUrlsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<GeneratePlaybackUrlsMutation, GeneratePlaybackUrlsMutationVariables>(
    'generatePlaybackUrls',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAssignTargetsMutation(
 *   ({ query, variables }) => {
 *     const { targetChanges } = variables;
 *     return HttpResponse.json({
 *       data: { assignTargets }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAssignTargetsMutation = (resolver: GraphQLResponseResolver<AssignTargetsMutation, AssignTargetsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AssignTargetsMutation, AssignTargetsMutationVariables>(
    'assignTargets',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreatePlaybackOverrideMutation(
 *   ({ query, variables }) => {
 *     const { experience, features, matchParams } = variables;
 *     return HttpResponse.json({
 *       data: { createPlaybackOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreatePlaybackOverrideMutation = (resolver: GraphQLResponseResolver<CreatePlaybackOverrideMutation, CreatePlaybackOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreatePlaybackOverrideMutation, CreatePlaybackOverrideMutationVariables>(
    'createPlaybackOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePlaybackOverrideMutation(
 *   ({ query, variables }) => {
 *     const { id, experience, features, matchParams } = variables;
 *     return HttpResponse.json({
 *       data: { updatePlaybackOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdatePlaybackOverrideMutation = (resolver: GraphQLResponseResolver<UpdatePlaybackOverrideMutation, UpdatePlaybackOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdatePlaybackOverrideMutation, UpdatePlaybackOverrideMutationVariables>(
    'updatePlaybackOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeletePlaybackOverrideMutation(
 *   ({ query, variables }) => {
 *     const { overrideId } = variables;
 *     return HttpResponse.json({
 *       data: { deletePlaybackOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeletePlaybackOverrideMutation = (resolver: GraphQLResponseResolver<DeletePlaybackOverrideMutation, DeletePlaybackOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeletePlaybackOverrideMutation, DeletePlaybackOverrideMutationVariables>(
    'deletePlaybackOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPlaybackOverridesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { playbackOverrides }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPlaybackOverridesQuery = (resolver: GraphQLResponseResolver<PlaybackOverridesQuery, PlaybackOverridesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PlaybackOverridesQuery, PlaybackOverridesQueryVariables>(
    'playbackOverrides',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllOverridesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { sessionOverrides, playbackOverrides }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllOverridesQuery = (resolver: GraphQLResponseResolver<AllOverridesQuery, AllOverridesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllOverridesQuery, AllOverridesQueryVariables>(
    'allOverrides',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateSessionOverrideMutation(
 *   ({ query, variables }) => {
 *     const { features, matchParams } = variables;
 *     return HttpResponse.json({
 *       data: { createSessionOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateSessionOverrideMutation = (resolver: GraphQLResponseResolver<CreateSessionOverrideMutation, CreateSessionOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateSessionOverrideMutation, CreateSessionOverrideMutationVariables>(
    'createSessionOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSessionOverrideMutation(
 *   ({ query, variables }) => {
 *     const { id, features, matchParams } = variables;
 *     return HttpResponse.json({
 *       data: { updateSessionOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateSessionOverrideMutation = (resolver: GraphQLResponseResolver<UpdateSessionOverrideMutation, UpdateSessionOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateSessionOverrideMutation, UpdateSessionOverrideMutationVariables>(
    'updateSessionOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteSessionOverrideMutation(
 *   ({ query, variables }) => {
 *     const { overrideId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteSessionOverride }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteSessionOverrideMutation = (resolver: GraphQLResponseResolver<DeleteSessionOverrideMutation, DeleteSessionOverrideMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteSessionOverrideMutation, DeleteSessionOverrideMutationVariables>(
    'deleteSessionOverride',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSessionOverridesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { sessionOverrides }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSessionOverridesQuery = (resolver: GraphQLResponseResolver<SessionOverridesQuery, SessionOverridesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SessionOverridesQuery, SessionOverridesQueryVariables>(
    'sessionOverrides',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePipelineConfigMutation(
 *   ({ query, variables }) => {
 *     const { teamId, pipelineConfig } = variables;
 *     return HttpResponse.json({
 *       data: { updatePipelineConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdatePipelineConfigMutation = (resolver: GraphQLResponseResolver<UpdatePipelineConfigMutation, UpdatePipelineConfigMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdatePipelineConfigMutation, UpdatePipelineConfigMutationVariables>(
    'updatePipelineConfig',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPipelineConfigsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { pipelineConfigs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetPipelineConfigsQuery = (resolver: GraphQLResponseResolver<GetPipelineConfigsQuery, GetPipelineConfigsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetPipelineConfigsQuery, GetPipelineConfigsQueryVariables>(
    'getPipelineConfigs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePipelineInputConfigMutation(
 *   ({ query, variables }) => {
 *     const { venueId, feedType, pipelineInputConfig } = variables;
 *     return HttpResponse.json({
 *       data: { updatePipelineInputConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdatePipelineInputConfigMutation = (resolver: GraphQLResponseResolver<UpdatePipelineInputConfigMutation, UpdatePipelineInputConfigMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdatePipelineInputConfigMutation, UpdatePipelineInputConfigMutationVariables>(
    'updatePipelineInputConfig',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPipelineInputConfigsQuery(
 *   ({ query, variables }) => {
 *     const { venueId } = variables;
 *     return HttpResponse.json({
 *       data: { pipelineInputConfigs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPipelineInputConfigsQuery = (resolver: GraphQLResponseResolver<PipelineInputConfigsQuery, PipelineInputConfigsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PipelineInputConfigsQuery, PipelineInputConfigsQueryVariables>(
    'pipelineInputConfigs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAssignDevPipelineConfigMutation(
 *   ({ query, variables }) => {
 *     const { teamId, pipelineId } = variables;
 *     return HttpResponse.json({
 *       data: { assignDevPipelineConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAssignDevPipelineConfigMutation = (resolver: GraphQLResponseResolver<AssignDevPipelineConfigMutation, AssignDevPipelineConfigMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AssignDevPipelineConfigMutation, AssignDevPipelineConfigMutationVariables>(
    'assignDevPipelineConfig',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBorrowPipelineMutation(
 *   ({ query, variables }) => {
 *     const { teamId } = variables;
 *     return HttpResponse.json({
 *       data: { borrowPipeline }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBorrowPipelineMutation = (resolver: GraphQLResponseResolver<BorrowPipelineMutation, BorrowPipelineMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<BorrowPipelineMutation, BorrowPipelineMutationVariables>(
    'borrowPipeline',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReturnPipelineMutation(
 *   ({ query, variables }) => {
 *     const { teamId } = variables;
 *     return HttpResponse.json({
 *       data: { returnPipeline }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockReturnPipelineMutation = (resolver: GraphQLResponseResolver<ReturnPipelineMutation, ReturnPipelineMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ReturnPipelineMutation, ReturnPipelineMutationVariables>(
    'returnPipeline',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPipelineMonitorsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { pipelineMonitors }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPipelineMonitorsQuery = (resolver: GraphQLResponseResolver<PipelineMonitorsQuery, PipelineMonitorsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PipelineMonitorsQuery, PipelineMonitorsQueryVariables>(
    'pipelineMonitors',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPartnerMappingQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getAllChannels, getAllTargets }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetPartnerMappingQuery = (resolver: GraphQLResponseResolver<GetPartnerMappingQuery, GetPartnerMappingQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetPartnerMappingQuery, GetPartnerMappingQueryVariables>(
    'getPartnerMapping',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetChannelQuery(
 *   ({ query, variables }) => {
 *     const { name } = variables;
 *     return HttpResponse.json({
 *       data: { getChannel }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetChannelQuery = (resolver: GraphQLResponseResolver<GetChannelQuery, GetChannelQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetChannelQuery, GetChannelQueryVariables>(
    'getChannel',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetTargetQuery(
 *   ({ query, variables }) => {
 *     const { name } = variables;
 *     return HttpResponse.json({
 *       data: { getTarget }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetTargetQuery = (resolver: GraphQLResponseResolver<GetTargetQuery, GetTargetQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetTargetQuery, GetTargetQueryVariables>(
    'getTarget',
    resolver,
    options
  )


/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserIdQuery(
 *   ({ query, variables }) => {
 *     const { email } = variables;
 *     return HttpResponse.json({
 *       data: { userInfo }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUserIdQuery = (resolver: GraphQLResponseResolver<UserIdQuery, UserIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UserIdQuery, UserIdQueryVariables>(
    'userId',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserDataQuery(
 *   ({ query, variables }) => {
 *     const { userId, startDate, endDate, page, size } = variables;
 *     return HttpResponse.json({
 *       data: { userData }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUserDataQuery = (resolver: GraphQLResponseResolver<UserDataQuery, UserDataQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UserDataQuery, UserDataQueryVariables>(
    'userData',
    resolver,
    options
  )
